(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9932],{

/***/ 68231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);


var HorizontalLine = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div", {
        css: {
            height: 1,
            width: "100%",
            backgroundColor: color
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HorizontalLine);


/***/ }),

/***/ 23805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Terms; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98973);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var react_powerplug__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41491);
/* harmony import */ var _lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67459);
/* harmony import */ var _components_icons_ModalCloseIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86140);
/* harmony import */ var _components_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31772);







function Terms(param) {
    var policyUrl = param.policyUrl, title = param.title, children = param.children;
    var isMobile = (0,_lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_powerplug__WEBPACK_IMPORTED_MODULE_2__/* .Toggle */ .ZD, {
        initial: false,
        children: function(param) {
            var on = param.on, toggle = param.toggle;
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
                children: [
                    isMobile ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_mobile__WEBPACK_IMPORTED_MODULE_5__/* .MobileScreen */ .vp, {
                        isOpen: on,
                        children: function() {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_mobile__WEBPACK_IMPORTED_MODULE_5__/* .MobileScreenHeader */ .uD, {
                                        onRequestClose: toggle,
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("iframe", {
                                        src: policyUrl,
                                        frameBorder: 0,
                                        width: "100%",
                                        height: "91%",
                                        style: {
                                            overflow: "auto"
                                        }
                                    })
                                ]
                            });
                        }
                    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_0__/* .Modal */ .u_, {
                        isOpen: on,
                        onRequestClose: toggle,
                        ariaHideApp: false,
                        overlayStyle: {
                            overflow: "hidden"
                        },
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("span", {
                                css: {
                                    position: "absolute",
                                    top: 0,
                                    right: 16,
                                    padding: 20,
                                    cursor: "pointer"
                                },
                                role: "button",
                                "aria-label": "Close",
                                onClick: toggle,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_icons_ModalCloseIcon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("iframe", {
                                title: title,
                                src: policyUrl,
                                frameBorder: 0,
                                width: 800,
                                height: 800
                            })
                        ]
                    }),
                    children(toggle)
                ]
            });
        }
    });
};


/***/ }),

/***/ 52947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TwoPassRender; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);

function TwoPassRender(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isClient = ref[0], setIsClient = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setIsClient(typeof document !== "undefined");
    }, []);
    return isClient ? children(document) : null;
};


/***/ }),

/***/ 85819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DropdownArrow; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19026);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);





function DropdownArrow(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .SvgBox */ .$C, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "14",
        height: "6",
        viewBox: "0 0 14 6",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("path", {
            d: "M7 6L0.0717959 1.30507e-06L13.9282 9.36995e-08L7 6Z",
            fill: props.fill || "#086BE5"
        })
    }));
};


/***/ }),

/***/ 61499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DropdownArrowUp; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19026);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);





function DropdownArrowUp(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .SvgBox */ .$C, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "14",
        height: "6",
        viewBox: "0 0 14 6",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("path", {
            d: "M7 -6.99382e-07L0.0717959 6L13.9282 6L7 -6.99382e-07Z",
            fill: props.fill || "#086BE5"
        })
    }));
};


/***/ }),

/***/ 86140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ModalCloseIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);




function ModalCloseIcon(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: 9,
        height: 9
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
            fill: "#A5ADBA",
            fillRule: "evenodd",
            d: "M4.5 2.885L7.385 0 9 1.615 6.115 4.5 9 7.385 7.385 9 4.5 6.115 1.615 9 0 7.385 2.885 4.5 0 1.615 1.615 0 4.5 2.885z"
        })
    }));
};


/***/ }),

/***/ 6404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Alert; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95576);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);





function Alert(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("div", {
        css: {
            display: "grid",
            gridColumnGap: 14,
            gridTemplateColumns: "32px 1fr",
            alignItems: "center",
            padding: 20,
            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_2__/* .text */ .fL,
            fontSize: 16,
            lineHeight: 1.33,
            backgroundColor: "#ffdfdf",
            border: "solid 1px #ff7171",
            borderRadius: 3
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(ExclamationSign, {}),
            children
        ]
    });
};
function ExclamationSign(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: 32,
        height: 32,
        viewBox: "0 0 32 32"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: "#FF7171",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            transform: "translate(1 1)",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("circle", {
                    cx: 15,
                    cy: 15,
                    r: 15
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("rect", {
                    width: 2,
                    height: 10,
                    x: 14,
                    y: 7,
                    rx: 1
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("circle", {
                    cx: 15,
                    cy: 22,
                    r: 1
                })
            ]
        })
    }));
}


/***/ }),

/***/ 92418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var facepaint__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78098);

/* harmony default export */ __webpack_exports__["Z"] = ((0,facepaint__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
    "@media (min-width: 540px)",
    "@media (min-width: 720px)",
    "@media (min-width: 960px)",
    "@media (min-width: 1140px)", 
]));


/***/ }),

/***/ 31772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ly": function() { return /* binding */ MobileScreenBody; },
/* harmony export */   "uD": function() { return /* binding */ MobileScreenHeader; },
/* harmony export */   "vp": function() { return /* binding */ MobileScreen; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98973);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87995);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69057);








function MobileScreen(_param) {
    var isOpen = _param.isOpen, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "isOpen",
        "children"
    ]);
    if (typeof document !== "undefined") {
        return /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(/*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            css: {
                position: "fixed",
                top: 0,
                left: isOpen ? 0 : "100%",
                width: "100vw",
                height: "100vh",
                backgroundColor: "#ffffff",
                zIndex: 99000,
                visibility: isOpen ? "visible" : "hidden",
                transform: "translateZ(0)",
                overflow: "auto"
            }
        }, props), {
            children: [
                isOpen && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_0__/* .BlockBodyOverflow */ .Bm, {}),
                typeof children === "function" ? children(isOpen) : children
            ]
        })), document.body);
    }
    return null;
}
function MobileScreenHeader(_param) {
    var onRequestClose = _param.onRequestClose, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "onRequestClose",
        "children"
    ]);
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
        css: {
            display: "flex",
            alignItems: "center",
            borderBottom: "solid 1px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#fafafa",
            color: "#666666",
            position: "relative",
            paddingTop: 20,
            paddingBottom: 20
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("a", {
                href: "#",
                "aria-label": intl.formatMessage({
                    defaultMessage: "Close",
                    id: "rbrahO"
                }),
                css: {
                    position: "absolute",
                    role: "button",
                    top: 0,
                    left: 0,
                    color: "inherit",
                    fontSize: 16,
                    textDecoration: "none",
                    padding: 20
                },
                onClick: function(event) {
                    event.preventDefault();
                    onRequestClose();
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(LeftArrow, {
                    width: 33,
                    height: 23
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                css: {
                    flex: 1,
                    marginRight: 20,
                    marginLeft: 20,
                    fontSize: 16,
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden"
                }
            }, props), {
                children: children
            }))
        ]
    });
}
function MobileScreenBody(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        css: {
            padding: 20,
            display: "flex",
            flexDirection: "column"
        },
        children: children
    }));
}
var LeftArrow = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        width: 32,
        height: 23
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("path", {
            d: "M10.273 1.009a1.112 1.112 0 0 1 1.587 0 1.12 1.12 0 0 1 0 1.571l-8.047 8.047h26.554c.619 0 1.127.492 1.127 1.111s-.508 1.127-1.127 1.127H3.813l8.047 8.032c.429.444.429 1.159 0 1.587a1.112 1.112 0 0 1-1.587 0L.321 12.532a1.12 1.12 0 0 1 0-1.571l9.952-9.952z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
};


/***/ }),

/***/ 52126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zh": function() { return /* binding */ Padding; },
/* harmony export */   "Zt": function() { return /* binding */ Margin; },
/* harmony export */   "lv": function() { return /* binding */ SpacingBetween; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _components_mediaQueries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92418);
/* eslint-disable react/jsx-no-useless-fragment */ 





var Margin = function(_param) {
    var mt = _param.mt, mb = _param.mb, ml = _param.ml, mr = _param.mr, mx = _param.mx, my = _param.my, children = _param.children, css = _param.css, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "mt",
        "mb",
        "ml",
        "mr",
        "mx",
        "my",
        "children",
        "css"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        css: (0,_components_mediaQueries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            marginTop: mt,
            marginBottom: mb,
            marginLeft: ml,
            marginRight: mr
        }, xAxis("margin", mx), yAxis("margin", my), css)),
        children: children
    }));
};
var Padding = function(_param) {
    var pt = _param.pt, pb = _param.pb, pl = _param.pl, pr = _param.pr, px = _param.px, py = _param.py, children = _param.children, css = _param.css, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "pt",
        "pb",
        "pl",
        "pr",
        "px",
        "py",
        "children",
        "css"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        css: (0,_components_mediaQueries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            paddingTop: pt,
            paddingBottom: pb,
            paddingLeft: pl,
            paddingRight: pr
        }, xAxis("padding", px), yAxis("padding", py), css)),
        children: children
    }));
};
Padding.defaultProps = {
    pt: null,
    pb: null,
    pl: null,
    pr: null,
    px: null,
    py: null,
    css: null
};
function xAxis(prefix, value) {
    if (!value) {
        return {};
    }
    if (prefix === "margin") {
        return {
            marginLeft: value,
            marginRight: value
        };
    } else if (prefix === "padding") {
        return {
            paddingLeft: value,
            paddingRight: value
        };
    }
    return {};
}
function yAxis(prefix, value) {
    if (!value) {
        return {};
    }
    if (prefix === "margin") {
        return {
            marginTop: value,
            marginBottom: value
        };
    } else if (prefix === "padding") {
        return {
            paddingTop: value,
            paddingBottom: value
        };
    }
    return {};
}
var SpacingBetween = function(_param) {
    var top = _param.top, right = _param.right, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "top",
        "right",
        "children"
    ]);
    var actualChildren = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(children);
    var childrenCount = actualChildren.length;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
        children: actualChildren.map(function(child, index) {
            if (top && top > 0 && index > 0) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Margin, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    mt: top
                }, props), {
                    children: child
                }), index);
            } else if (right && right > 0 && index < childrenCount - 1) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Margin, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    mr: right
                }, props), {
                    children: child
                }), index);
            }
            return child;
        })
    });
};
SpacingBetween.defaultProps = {
    top: 0,
    right: 0
};


/***/ }),

/***/ 99909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIntlDate; }
/* harmony export */ });
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69057);

function useIntlDate() {
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    return {
        format: function(value) {
            return intl.formatDate(value, {
                year: "numeric",
                month: "long",
                day: "2-digit"
            });
        }
    };
};


/***/ }),

/***/ 67459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIsMobile; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _lib_hooks_useMediaWithInitialState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3335);
/* harmony import */ var _components_MobileDetectContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48582);



function useIsMobile() {
    var mobileDetectContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_components_MobileDetectContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    var isMobile =  true ? (0,_lib_hooks_useMediaWithInitialState__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("(max-width: 960px)") : 0;
    return isMobile;
};


/***/ }),

/***/ 3335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMediaWithInitialState; }
/* harmony export */ });
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59975);

function useMediaWithInitialState(mediaQuery) {
    return (0,react_use__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(mediaQuery, window.matchMedia(mediaQuery).matches);
};


/***/ }),

/***/ 32785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation DismissActionCenter {\n    dismissActionCenter\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject()));


/***/ }),

/***/ 44673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getGovlaunchBaseUrl; }
/* harmony export */ });
function getGovlaunchBaseUrl() {
    var app = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "portal";
    var environment = "production" || 0;
    if ([
        "site",
        "main",
        "govlaunch_frontend",
        "frontend",
        "portal"
    ].includes(app)) {
        if (environment === "development") {
            return "http://localhost:3000";
        } else if (environment === "production") {
            return "https://govlaunch.com";
        } else if (environment === "qa") {
            return "https://qa.govlaunch.com";
        }
    }
    if ([
        "disruptors-frontend",
        "disruptors"
    ].includes(app)) {
        if (environment === "development") {
            return "http://localhost:3001";
        } else if (environment === "production") {
            return "https://disruptors.govlaunch.com";
        } else if (environment === "qa") {
            return "https://disruptors.qa.govlaunch.com";
        }
    }
    if ([
        "innovators-frontend",
        "innovators"
    ].includes(app)) {
        if (environment === "development") {
            return "http://localhost:3002";
        } else if (environment === "production") {
            return "https://innovators.govlaunch.com";
        } else if (environment === "qa") {
            return "https://innovators.qa.govlaunch.com";
        }
    }
    return "";
};


/***/ }),

/***/ 29713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var facepaint__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78098);

/* harmony default export */ __webpack_exports__["Z"] = ((0,facepaint__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
    "@media (min-width: 540px)",
    "@media (min-width: 720px)",
    "@media (min-width: 960px)",
    "@media (min-width: 1140px)", 
]));


/***/ }),

/***/ 11135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Strongify; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);


function Strongify(chunk) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("strong", {
        children: chunk
    });
};


/***/ }),

/***/ 71858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ NavbarLayout; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(94614);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/router.js
var next_router = __webpack_require__(22051);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./lib/mutations/DismissActionCenter.ts
var DismissActionCenter = __webpack_require__(32785);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/actions/ActionCenterBanner.tsx








function ActionCenterBanner() {
    var viewer = (0,Auth/* useSelfie */.yD)();
    if (!viewer || viewer.__typename === "PendingUser" || !viewer.showActionCenterBanner) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
        mutation: DismissActionCenter/* default */.Z,
        children: function(dismissActionCenter) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    position: "relative",
                    padding: "24px 32px",
                    border: "solid 1px ".concat(palette/* primary */.T$),
                    backgroundColor: "rgba(0, 113, 187, 0.06)",
                    color: palette/* primary */.T$,
                    borderRadius: 5,
                    width: "100%"
                },
                children: [
                    viewer.__typename === "GovernmentUser" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "There are pending actions for your government",
                        id: "37gsbo"
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "There are pending actions for your company",
                        id: "0x13xY"
                    }),
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: viewer.__typename === "GovernmentUser" ? "/governments/[governmentSlug]/[[...content]]" : "/vendors/[vendorSlug]/[[...content]]",
                        as: viewer.__typename === "GovernmentUser" ? "/governments/".concat(viewer.government.slug, "/actions") : "/vendors/".concat((viewer.company || {}).slug, "/actions"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                            css: {
                                color: palette/* primary */.T$,
                                fontWeight: 600,
                                ":hover": {
                                    textDecoration: "underline !important"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Go to actions",
                                    id: "fNDYFb"
                                }),
                                " →"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        role: "button",
                        onClick: function() {
                            return dismissActionCenter();
                        },
                        css: {
                            position: "absolute",
                            top: 12,
                            right: 12,
                            textTransform: "uppercase",
                            fontSize: 12,
                            letterSpacing: 0.5,
                            color: palette/* primary */.T$,
                            cursor: "pointer",
                            ":hover": {
                                textDecoration: "underline !important"
                            }
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "DISMISS",
                            id: "J17wtF"
                        })
                    })
                ]
            });
        }
    });
}
/* harmony default export */ var actions_ActionCenterBanner = (ActionCenterBanner);

;// CONCATENATED MODULE: ./components/actions/showActionCenterBanner.ts
function showActionCenterBanner(viewer) {
    if (!viewer || viewer.__typename === "PendingUser") {
        return false;
    }
    return viewer.showActionCenterBanner;
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(29452);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(45597);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(16258);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+profile-picture@1.4.1/node_modules/@govlaunch/profile-picture/index.js + 1 modules
var profile_picture = __webpack_require__(77876);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-select@5.4.0_htkqquepfjiebm7fcuzktnovwm/node_modules/react-select/async/dist/react-select.esm.js + 6 modules
var react_select_esm = __webpack_require__(64552);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
;// CONCATENATED MODULE: ./components/dev/queries/AutoCompleteUsersQuery.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query AutoCompleteUsers($searchQuery: String!) {\n    autoCompleteUsers(\n      searchQuery: $searchQuery\n      scopes: [PENDING, GOVERNMENT, VENDOR, COMMUNITY, CITIZEN, INNOVATOR, DISRUPTOR]\n    ) {\n      __typename\n      ... on PendingUser {\n        _id\n        fullName\n        email\n        avatar\n      }\n      ... on VendorUser {\n        _id\n        fullName\n        email\n        avatar\n      }\n      ... on GovernmentUser {\n        _id\n        fullName\n        email\n        avatar\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var AutoCompleteUsersQuery = ((0,lib/* default */.ZP)(_templateObject()));

;// CONCATENATED MODULE: ./components/dev/queries/ImpersonateMutation.ts

function ImpersonateMutation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation Impersonate($userId: ObjectId!) {\n    impersonate(userId: $userId) {\n      token\n    }\n  }\n"
    ]);
    ImpersonateMutation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var ImpersonateMutation = ((0,lib/* default */.ZP)(ImpersonateMutation_templateObject()));

// EXTERNAL MODULE: ./components/TwoPassRender.ts
var TwoPassRender = __webpack_require__(52947);
;// CONCATENATED MODULE: ./components/dev/ImpersonateBar.tsx
















var UserOption = function(_param) {
    var innerRef = _param.innerRef, innerProps = _param.innerProps, data = _param.data, getStyles = _param.getStyles, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "innerRef",
        "innerProps",
        "data",
        "getStyles"
    ]);
    var tagColors = {
        GovernmentUser: {
            textColor: "white",
            bgColor: "blue.500"
        },
        PendingUser: {
            textColor: "white",
            bgColor: "orange.500"
        },
        VendorUser: {
            textColor: "white",
            bgColor: "cyan.500"
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        ref: innerRef
    }, innerProps), {
        css: getStyles("option", props),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
            display: "flex",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                    size: 32,
                    image: data.value.avatar,
                    name: data.value.fullName
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                    ml: 2,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            fontSize: 14,
                            fontWeight: "bold",
                            children: data.value.fullName
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            fontSize: 12,
                            color: "grey.400",
                            children: data.value.email
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            fontSize: 9,
                            color: tagColors[data.value.__typename].textColor || "grey.400",
                            fontWeight: "bold",
                            backgroundColor: tagColors[data.value.__typename].bgColor || "cyan.400",
                            as: "span",
                            p: 1,
                            borderRadius: 4,
                            children: data.value.__typename
                        })
                    ]
                })
            ]
        })
    }));
};
function ImpersonateBar() {
    var router = (0,next_router.useRouter)();
    var selectInputRef = (0,react.useRef)();
    var ref = (0,react.useState)(""), searchQuery = ref[0], setSearchQuery = ref[1];
    var apolloClient = (0,useApolloClient/* useApolloClient */.x)();
    var login = (0,react.useContext)(Auth/* AuthContext */.Vo).login;
    var ref1 = (0,react.useState)(function() {
        if (router.query["impersonate-bar"] !== undefined) {
            return false;
        }
        if (true) {
            return localStorage.getItem("impersonateToolbarClosed") === "true";
        }
        return true;
    }), isImpersonateToolbarClosed = ref1[0], setIsImpersonateToolbarClosed = ref1[1];
    var searchForUsers = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(inputValue) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return apolloClient.query({
                            query: AutoCompleteUsersQuery,
                            variables: {
                                searchQuery: inputValue
                            }
                        });
                    case 2:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data.autoCompleteUsers.map(function(user) {
                            return {
                                label: user.fullName,
                                value: user
                            };
                        }));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function searchForUsers(inputValue) {
            return _ref.apply(this, arguments);
        };
    }();
    var onChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(option) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSearchQuery("");
                        _ctx.next = 3;
                        return apolloClient.mutate({
                            mutation: ImpersonateMutation,
                            variables: {
                                userId: option.value._id
                            }
                        });
                    case 3:
                        data = _ctx.sent.data;
                        if (data && data.impersonate && data.impersonate.token) {
                            login(data.impersonate.token);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onChange(option) {
            return _ref.apply(this, arguments);
        };
    }();
    if (![
        "qa",
        "development"
    ].includes("production" || 0)) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TwoPassRender/* default */.Z, {
        children: function() {
            if (localStorage.getItem("impersonateToolbarClosed") === "true" && isImpersonateToolbarClosed) {
                return null;
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                backgroundColor: "blue.200",
                p: 4,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                    as: "div",
                    display: "flex",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                            as: "h2",
                            fontWeight: "bold",
                            color: "blue.800",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                    fontSize: 16,
                                    children: "Govlaunch QA"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                    fontSize: 14,
                                    color: "orange.900",
                                    backgroundColor: "orange.100",
                                    px: 2,
                                    borderRadius: 4,
                                    textAlign: "center",
                                    children: "Impersonate"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            ml: 4,
                            width: 400,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_select_esm/* default */.Z, {
                                id: "search-users",
                                ref: selectInputRef,
                                cacheOptions: false,
                                loadOptions: searchForUsers,
                                placeholder: "Search for users to impersonate...",
                                onChange: onChange,
                                value: null,
                                inputValue: searchQuery,
                                onInputChange: setSearchQuery,
                                escapeClearsValue: true,
                                isClearable: true,
                                components: {
                                    Option: UserOption
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                                color: "red.800",
                                onClick: function() {
                                    localStorage.setItem("impersonateToolbarClosed", "true");
                                    setIsImpersonateToolbarClosed(true);
                                    router.replace(router.pathname, {}, {
                                        shallow: true
                                    });
                                },
                                children: "Close"
                            })
                        })
                    ]
                })
            });
        }
    });
};

// EXTERNAL MODULE: ./components/makers/Alert.tsx
var Alert = __webpack_require__(6404);
// EXTERNAL MODULE: ./lib/utils/strongify.tsx
var strongify = __webpack_require__(11135);
;// CONCATENATED MODULE: ./components/makers/OverdueStickyNoticeBanner.tsx







function OverdueStickyNoticeBanner() {
    var pleaseUpdatePaymentMethod = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "/billing/payment",
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            css: {
                color: palette/* innovatorBlue */.LD
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "Please update your payment method",
                id: "ABVuHe"
            })
        })
    });
    var contactSupport = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: "mailto:hello@govlaunch.com",
        css: {
            color: palette/* innovatorBlue */.LD
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "contact support",
            id: "MCkewI"
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Alert/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "<strong>We are having a problem billing your account.</strong> {pleaseUpdatePaymentMethod} or call your payment provider for details on why the transaction failed. You can {contactSupport} with any questions.",
                id: "BneSKz",
                values: {
                    pleaseUpdatePaymentMethod: pleaseUpdatePaymentMethod,
                    contactSupport: contactSupport,
                    strong: function(chunk) {
                        return (0,strongify/* default */.Z)(chunk);
                    }
                }
            })
        })
    });
};

// EXTERNAL MODULE: ./lib/hooks/useIntlDate.ts
var useIntlDate = __webpack_require__(99909);
;// CONCATENATED MODULE: ./components/makers/ScheduledToCancelStickyNoticeBanner.tsx








function ScheduledToCancelStickyNoticeBanner(param) {
    var vendorSlug = param.vendorSlug, willCancelAt = param.willCancelAt;
    var intlDate = (0,useIntlDate/* default */.Z)();
    var contactSupport = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: "mailto:hello@govlaunch.com",
        css: {
            color: palette/* innovatorBlue */.LD
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "contact support",
            id: "MCkewI"
        })
    });
    var linkToAccountSettings = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "/vendors/[vendorSlug]/[[...content]]",
        as: "/vendors/".concat(vendorSlug, "/account"),
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: "mailto:hello@govlaunch.com",
            css: {
                color: palette/* innovatorBlue */.LD
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "account settings",
                id: "f5VIwq"
            })
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Alert/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "Your subscription will be cancelled on <strong>{date}</strong> and all the new content you add as of today will be erased by this date. You can go to {linkToAccountSettings} to reactivate your subscription. If you have any questions you can always {contactSupport}.",
                id: "Lj/gRU",
                values: {
                    date: intlDate.format(willCancelAt),
                    linkToAccountSettings: linkToAccountSettings,
                    contactSupport: contactSupport,
                    strong: function(chunk) {
                        return (0,strongify/* default */.Z)(chunk);
                    }
                }
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/head.js
var head = __webpack_require__(84217);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/seo/HreflangTags.tsx



function HreflangTags() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "alternate",
                hrefLang: "pt",
                href: "https://govlaunch.com/pt-BR/"
            }, "hreflangPT"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "alternate",
                hrefLang: "bg",
                href: "https://govlaunch.com/bg/"
            }, "hreflangBg"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "alternate",
                hrefLang: "de",
                href: "https://govlaunch.com/de/"
            }, "hreflangDe"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "alternate",
                hrefLang: "es",
                href: "https://govlaunch.com/es/"
            }, "hreflangEs"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "alternate",
                hrefLang: "fr",
                href: "https://govlaunch.com/fr/"
            }, "hreflangFr"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "alternate",
                hrefLang: "it",
                href: "https://govlaunch.com/it/"
            }, "hreflangIt"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "alternate",
                hrefLang: "nl",
                href: "https://govlaunch.com/nl/"
            }, "hreflangNl"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "alternate",
                hrefLang: "sv",
                href: "https://govlaunch.com/sv/"
            }, "hreflangSv"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "alternate",
                hrefLang: "x-default",
                href: "https://govlaunch.com/"
            }, "hreflangDefault")
        ]
    });
};

;// CONCATENATED MODULE: ./lib/mutations/DismissGovernmentProfileBanner.ts

function DismissGovernmentProfileBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DismissGovernmentProfileBanner {\n    dismissCompleteGovernmentProfileBanner\n  }\n"
    ]);
    DismissGovernmentProfileBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var DismissGovernmentProfileBanner = ((0,lib/* gql */.Ps)(DismissGovernmentProfileBanner_templateObject()));

// EXTERNAL MODULE: ./lib/queries/SelfieQuery.ts
var SelfieQuery = __webpack_require__(88877);
;// CONCATENATED MODULE: ./components/user/CompleteGovernmentProfileBanner.tsx










function CompleteGovernmentProfileBanner() {
    var viewer = (0,Auth/* useSelfie */.yD)();
    if (!viewer || !(viewer.__typename === "GovernmentUser" && viewer.showCompleteGovernmentProfileBanner)) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
        mutation: DismissGovernmentProfileBanner,
        update: function(proxy) {
            proxy.writeQuery({
                query: SelfieQuery/* default */.Z,
                data: {
                    __typename: "Query",
                    selfie: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, viewer), {
                        showCompleteGovernmentProfileBanner: false
                    })
                }
            });
        },
        children: function(dismissActionCenter) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    position: "relative",
                    padding: "24px 32px",
                    border: "solid 1px #6f5b00",
                    backgroundColor: "rgba(253, 235, 148, 0.5)",
                    color: "#6f5b00",
                    borderRadius: 5,
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Help us! We're missing some key information about your government.",
                        id: "gUl6YV"
                    }),
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: "/governments/[governmentSlug]/[[...content]]",
                        as: "/governments/".concat(viewer.government.slug, "/settings"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                            css: {
                                color: "#6f5b00",
                                fontWeight: 600,
                                ":hover": {
                                    textDecoration: "underline !important"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Add it now",
                                    id: "Nq9h7m"
                                }),
                                " →"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        role: "button",
                        onClick: function() {
                            return dismissActionCenter();
                        },
                        css: {
                            position: "absolute",
                            top: 12,
                            right: 12,
                            textTransform: "uppercase",
                            fontSize: 12,
                            letterSpacing: 0.5,
                            color: "#6f5b00",
                            cursor: "pointer",
                            ":hover": {
                                textDecoration: "underline !important"
                            }
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Dismiss",
                            id: "TDaF6J"
                        })
                    })
                ]
            });
        }
    });
}
/* harmony default export */ var user_CompleteGovernmentProfileBanner = (CompleteGovernmentProfileBanner);

;// CONCATENATED MODULE: ./lib/mutations/DismissOnboarding.ts

function DismissOnboarding_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DismissOnboarding {\n    dismissOnboardingBanner\n  }\n"
    ]);
    DismissOnboarding_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var DismissOnboarding = ((0,lib/* gql */.Ps)(DismissOnboarding_templateObject()));

;// CONCATENATED MODULE: ./components/user/CompleteProfileBanner.tsx










function CompleteProfileBanner() {
    var viewer = (0,Auth/* useSelfie */.yD)();
    if (!viewer) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
        mutation: DismissOnboarding,
        update: function(proxy) {
            proxy.writeQuery({
                query: SelfieQuery/* default */.Z,
                data: {
                    __typename: "Query",
                    selfie: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, viewer), {
                        showOnboardingBanner: false
                    })
                }
            });
        },
        children: function(dismissActionCenter) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    position: "relative",
                    padding: "24px 32px",
                    border: "solid 1px #602400",
                    backgroundColor: "rgba(254, 143, 81, 0.5)",
                    color: "#602400",
                    borderRadius: 5,
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Almost there! We're missing some key information in your profile.",
                        id: "S5qUM/"
                    }),
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        passHref: true,
                        href: "/[userSlug]/[[...tab]]?tab=settings",
                        as: "/@".concat(viewer.slug, "/settings"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                            css: {
                                color: "#602400",
                                fontWeight: 600,
                                ":hover": {
                                    textDecoration: "underline !important"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Add it now",
                                    id: "Nq9h7m"
                                }),
                                "→"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        role: "button",
                        onClick: function() {
                            return dismissActionCenter();
                        },
                        css: {
                            position: "absolute",
                            top: 12,
                            right: 12,
                            textTransform: "uppercase",
                            fontSize: 12,
                            letterSpacing: 0.5,
                            color: "#602400",
                            cursor: "pointer",
                            ":hover": {
                                textDecoration: "underline !important"
                            }
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Dismiss",
                            id: "TDaF6J"
                        })
                    })
                ]
            });
        }
    });
}
/* harmony default export */ var user_CompleteProfileBanner = (CompleteProfileBanner);

// EXTERNAL MODULE: ./lib/hooks/useIsMobile.ts
var useIsMobile = __webpack_require__(67459);
;// CONCATENATED MODULE: ./src/components/navbar/BottomNavbar.tsx








function BottomNavbar() {
    var viewer = (0,Auth/* useSelfie */.yD)();
    if (!viewer) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        position: "fixed",
        zIndex: 1200,
        width: "100%",
        left: 0,
        bottom: 0,
        display: [
            "block",
            "block",
            "none"
        ],
        height: "60px",
        maxHeight: "60px",
        bg: "gray.800",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SimpleGrid */.MI, {
            columns: 5,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarItem, {
                            svgProps: {
                                width: "28px",
                                height: "27px",
                                viewBox: "0 0 28 27"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M14.3499 7.52507C15.3131 7.52507 16.0999 8.29786 16.0999 9.24215V17.437C16.0999 18.382 15.3131 19.1541 14.3499 19.1541C13.3874 19.1541 12.6 18.382 12.6 17.437V9.24215C12.6 8.29716 13.3874 7.52507 14.3499 7.52507ZM14 2.35863e-05C13.6985 -0.00154765 13.4018 0.0754091 13.139 0.223321L0.859023 7.13226C0.0400312 7.59355 -0.244166 8.62464 0.229029 9.42334C0.702925 10.2227 1.76061 10.4992 2.58101 10.0379L14 3.61269L25.419 10.0379C26.2394 10.4992 27.2971 10.2227 27.771 9.42404V9.42334C28.2442 8.62464 27.96 7.59355 27.141 7.13226L14.861 0.223321C14.5982 0.0755893 14.3015 -0.00135485 14 2.35863e-05ZM6.65036 11.6297C7.61285 11.6297 8.40034 12.3843 8.40034 13.3076V21.5801C8.40034 22.5034 7.61285 23.2587 6.65036 23.2587C5.68717 23.2587 4.90037 22.5034 4.90037 21.5801V13.3076C4.90037 12.3843 5.68717 11.6297 6.65036 11.6297ZM21.3498 11.6297C22.3123 11.6297 23.0998 12.3843 23.0998 13.3076V21.5801C23.0998 22.5034 22.3123 23.2587 21.3498 23.2587C20.3874 23.2587 19.5999 22.5034 19.5999 21.5808V13.3076C19.5999 12.3843 20.3874 11.6297 21.3498 11.6297ZM14.3499 20.5223C15.3124 20.5223 16.0999 21.3224 16.0999 22.3003V24.9022C16.0999 25.8801 15.3124 26.6795 14.3499 26.6795C13.3874 26.6795 12.6 25.8801 12.6 24.9022V22.3003C12.6 21.3224 13.3874 20.5223 14.3499 20.5223Z",
                                fill: "white"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    href: "/projects",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavbarItem, {
                            svgProps: {
                                width: "28px",
                                height: "28px",
                                viewBox: "0 0 24 24"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                    d: "M16 10H13V7H11V10H8V12H11V15H13V12H16V10Z",
                                    fill: "currentColor"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                    d: "M15 22H9V24H15V22Z",
                                    fill: "currentColor"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                    d: "M14.6 21H9.40004L7.64004 17.69C6.51998 16.9706 5.59931 15.9806 4.9631 14.8113C4.32689 13.642 3.99567 12.3312 4.00004 11C4.00004 8.87827 4.8429 6.84344 6.34319 5.34315C7.84348 3.84285 9.87831 3 12 3C14.1218 3 16.1566 3.84285 17.6569 5.34315C19.1572 6.84344 20 8.87827 20 11C20.0044 12.3312 19.6732 13.642 19.037 14.8113C18.4008 15.9806 17.4801 16.9706 16.36 17.69L14.6 21ZM10.6 19H13.4L14.85 16.27L15.09 16.13C15.9758 15.5979 16.7091 14.846 17.2189 13.9472C17.7287 13.0485 17.9978 12.0333 18 11C18 9.4087 17.3679 7.88258 16.2427 6.75736C15.1175 5.63214 13.5913 5 12 5C10.4087 5 8.88262 5.63214 7.7574 6.75736C6.63218 7.88258 6.00004 9.4087 6.00004 11C6.00403 12.0316 6.27392 13.0447 6.78366 13.9416C7.2934 14.8384 8.02576 15.5887 8.91004 16.12L9.15004 16.26L10.6 19Z",
                                    fill: "currentColor"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    href: "/podcast",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarItem, {
                            svgProps: {
                                width: "21px",
                                height: "23px",
                                viewBox: "0 0 21 23"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M10.0645 11.8529C11.4559 11.8529 12.5839 10.7905 12.5839 9.47987C12.5839 8.16928 11.4559 7.1068 10.0645 7.1068C8.67298 7.1068 7.54501 8.16928 7.54501 9.47987C7.54501 10.7905 8.67304 11.8529 10.0645 11.8529ZM10.0645 3.55016C6.58764 3.55016 3.76916 6.20496 3.76916 9.47981C3.76916 11.0724 4.43593 12.5183 5.5206 13.5835C5.83096 13.113 6.25952 12.6648 6.85043 12.3211C6.10986 11.5782 5.65543 10.5792 5.65543 9.47981C5.65543 7.18619 7.62942 5.32689 10.0645 5.32689C12.4996 5.32689 14.4735 7.18619 14.4735 9.47981C14.4735 10.5817 14.0171 11.5825 13.2737 12.3259C13.8636 12.6708 14.291 13.1201 14.6003 13.5913C15.6898 12.5252 16.3598 11.0763 16.3598 9.47981C16.3598 6.20503 13.5413 3.55016 10.0645 3.55016ZM10.0645 0C4.50598 0 0 4.24431 0 9.47987C0 12.8966 1.91937 15.8907 4.79764 17.5591C4.74035 17.1483 4.70365 16.7075 4.70365 16.2508C4.70365 16.2508 4.70088 15.8978 4.80165 15.388C3.01332 13.9732 1.87629 11.8518 1.87629 9.47987C1.87629 5.22032 5.54223 1.76734 10.0645 1.76734C14.5868 1.76734 18.2528 5.22032 18.2528 9.47987C18.2528 11.8568 17.1109 13.9822 15.316 15.397C15.4149 15.9019 15.4122 16.2507 15.4122 16.2507C15.4122 16.7105 15.3751 17.1543 15.3172 17.5673C18.2034 15.9007 20.129 12.9023 20.129 9.47987C20.129 4.24425 15.6229 0 10.0645 0ZM10.0645 13.0395C8.15126 13.0395 6.60019 14.5004 6.60019 16.3025C6.60019 18.1045 8.1512 24 10.0645 24C11.9777 24 13.5287 18.1046 13.5287 16.3025C13.5287 14.5004 11.9777 13.0395 10.0645 13.0395Z",
                                fill: "currentColor"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    href: "/products",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavbarItem, {
                            svgProps: {
                                width: "24px",
                                height: "24px",
                                viewBox: "0 0 24 24"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                    d: "M20 10V20H4V10H20ZM22 8H2V22H22V8Z",
                                    fill: "currentColor"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                    d: "M20 5H4V7H20V5Z",
                                    fill: "currentColor"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                    d: "M18 2H6V4H18V2Z",
                                    fill: "currentColor"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    href: "/user?userSlug=".concat(viewer.slug),
                    as: "/@".concat(viewer.slug),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavbarItem, {
                            svgProps: {
                                width: "28px",
                                height: "28px",
                                viewBox: "0 0 28 28"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                    d: "M10.7337 18.6027C8.45644 19.6564 6.78147 21.7781 6.34353 24.321L4.81055 24.057C5.33705 20.9999 7.34874 18.4549 10.0804 17.1909L10.7337 18.6027Z",
                                    fill: "currentColor"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                    d: "M19.5 20.1649C18.8575 19.5217 18.1004 18.9909 17.2646 18.6013L17.9218 17.1914C18.9215 17.6574 19.8287 18.293 20.6002 19.0653M20.6005 19.0656C21.9316 20.3968 22.8577 22.1213 23.1898 24.0571L21.6566 24.3201C21.3806 22.7109 20.6112 21.2761 19.5003 20.1652L19.5 20.1649",
                                    fill: "currentColor"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                    d: "M14 1.55556C7.12712 1.55556 1.55556 7.12712 1.55556 14C1.55556 20.8729 7.12712 26.4444 14 26.4444C20.8729 26.4444 26.4444 20.8729 26.4444 14C26.4444 7.12712 20.8729 1.55556 14 1.55556ZM0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z",
                                    fill: "currentColor"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                    d: "M13.9996 7.77772C11.5165 7.77772 9.3329 10.1145 9.3329 13.2222C9.3329 16.3299 11.5165 18.6666 13.9996 18.6666C16.4826 18.6666 18.6662 16.3299 18.6662 13.2222C18.6662 10.1145 16.4826 7.77772 13.9996 7.77772ZM7.77734 13.2222C7.77734 9.45698 10.4688 6.22217 13.9996 6.22217C17.5303 6.22217 20.2218 9.45698 20.2218 13.2222C20.2218 16.9874 17.5303 20.2222 13.9996 20.2222C10.4688 20.2222 7.77734 16.9874 7.77734 13.2222Z",
                                    fill: "currentColor"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
function NavbarItem(_param) {
    var children = _param.children, svgProps = _param.svgProps, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "children",
        "svgProps"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        as: "a",
        height: "60px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SvgBox */.$C, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, svgProps), {
            color: "gray.100",
            _hover: {
                color: "white"
            },
            children: children
        }))
    }));
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(56262);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/useToggle.js
var useToggle = __webpack_require__(35150);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-powerplug@1.0.0_react@17.0.2/node_modules/react-powerplug/dist/react-powerplug.esm.js
var react_powerplug_esm = __webpack_require__(41491);
// EXTERNAL MODULE: ./components/mobile/index.tsx
var mobile = __webpack_require__(31772);
;// CONCATENATED MODULE: ./src/shared/components/TermsIframeModal.tsx






function TermsIframeModal(param) {
    var policyUrl = param.policyUrl, isOpen = param.isOpen, onClose = param.onClose, title = param.title, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
        initial: false,
        children: function(param) {
            var on = param.on, toggle = param.toggle;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Mobile */.ij, {
                        children: function(isMobile) {
                            return isMobile ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(mobile/* MobileScreen */.vp, {
                                isOpen: isOpen || on,
                                children: function() {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(mobile/* MobileScreenHeader */.uD, {
                                                onRequestClose: onClose || toggle,
                                                children: title
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
                                                src: policyUrl,
                                                frameBorder: 0,
                                                width: "100%",
                                                height: "91%",
                                                style: {
                                                    overflow: "auto"
                                                }
                                            })
                                        ]
                                    });
                                }
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Modal */.u_, {
                                isOpen: isOpen || on,
                                onClose: onClose || toggle,
                                closeOnEsc: true,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ModalOverlay */.ZA, {}),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* ModalContent */.hz, {
                                        minWidth: 800,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ModalCloseButton */.ol, {
                                                onClick: onClose || toggle
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
                                                title: title,
                                                src: policyUrl,
                                                frameBorder: 0,
                                                width: 800,
                                                height: 800
                                            })
                                        ]
                                    })
                                ]
                            });
                        }
                    }),
                    children && children(toggle)
                ]
            });
        }
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./src/shared/hooks/useIntlPolicies.ts
var useIntlPolicies = __webpack_require__(91968);
;// CONCATENATED MODULE: ./src/components/navbar/NavbarPopoverMenu.tsx










function NavbarPopoverMenu() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isTermsOpen = ref[0], toggleTerms = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isPrivacyPolicyOpen = ref1[0], togglePrivacyPolicy = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isCookiePolicyOpen = ref2[0], toggleCookiePolicy = ref2[1];
    var policiesUrls = (0,useIntlPolicies/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Popover */.J2, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PopoverTrigger */.xo, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                            type: "button",
                            color: "gray.100",
                            width: "12px",
                            minWidth: "12px",
                            height: "18px",
                            padding: 0,
                            margin: 0,
                            "aria-label": "dropdown menu",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
                                viewBox: "0 0 384 384",
                                width: "1em",
                                height: "1em",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                                        fill: "currentColor",
                                        cx: 42.667,
                                        cy: 192,
                                        r: 42.667
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                                        fill: "currentColor",
                                        cx: 192,
                                        cy: 192,
                                        r: 42.667
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                                        fill: "currentColor",
                                        cx: 341.333,
                                        cy: 192,
                                        r: 42.667
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* PopoverContent */.yk, {
                        maxWidth: "165px",
                        arrowShadowColor: "#ADB6C3",
                        bg: "gray.900",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PopoverArrow */.QH, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                width: "165px",
                                p: 4,
                                borderRadius: "md",
                                border: "1px solid",
                                overflow: "hidden",
                                minWidth: 0,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Stack */.Kq, {
                                        direction: "column",
                                        spacing: 4,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                    href: "/about",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                                        fontSize: "md",
                                                        color: "white",
                                                        rel: "noreferrer noopener",
                                                        title: "About",
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                            defaultMessage: "About",
                                                            id: "g5pX+a"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuAnchor, {
                                                external: "govlaunch",
                                                href: "https://advertise.govlaunch.com/",
                                                title: "Help",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Advertise",
                                                    id: "2OzlCZ"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuAnchor, {
                                                external: "govlaunch",
                                                href: "https://help.govlaunch.com/en/",
                                                title: "Help",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Help",
                                                    id: "SENRqu"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                    href: "/podcast",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                                        fontSize: "md",
                                                        color: "white",
                                                        rel: "noreferrer noopener",
                                                        title: "Podcast",
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                            id: "uNMm97",
                                                            defaultMessage: "Podcast"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuAnchor, {
                                                external: "govlaunch",
                                                href: "https://blog.govlaunch.com",
                                                title: "Blog",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Blog",
                                                    id: "tv5FG3"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                        height: "1px",
                                        width: "100%",
                                        bg: "gray.300",
                                        my: 4
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        css: {
                                            position: "relative",
                                            display: "grid",
                                            rowGap: 16
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuAnchor, {
                                                onClick: toggleTerms,
                                                rel: "noreferrer noopener",
                                                href: "#",
                                                title: intl.formatMessage({
                                                    defaultMessage: "Terms of Service",
                                                    id: "32rBNK"
                                                }),
                                                css: {
                                                    overflow: "hidden",
                                                    whiteSpace: "nowrap",
                                                    textOverflow: "ellipsis",
                                                    display: "inline"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Terms of Service",
                                                    id: "32rBNK"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuAnchor, {
                                                onClick: togglePrivacyPolicy,
                                                rel: "noreferrer noopener",
                                                href: "#",
                                                title: intl.formatMessage({
                                                    defaultMessage: "Privacy Policy",
                                                    id: "vx0nkZ"
                                                }),
                                                css: {
                                                    overflow: "hidden",
                                                    whiteSpace: "nowrap",
                                                    textOverflow: "ellipsis",
                                                    display: "inline"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Privacy Policy",
                                                    id: "vx0nkZ"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuAnchor, {
                                                onClick: toggleCookiePolicy,
                                                rel: "noreferrer noopener",
                                                href: "#",
                                                title: intl.formatMessage({
                                                    defaultMessage: "Cookie Policy",
                                                    id: "cA0kQY"
                                                }),
                                                css: {
                                                    overflow: "hidden",
                                                    whiteSpace: "nowrap",
                                                    textOverflow: "ellipsis",
                                                    display: "inline"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Cookie Policy",
                                                    id: "cA0kQY"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TermsIframeModal, {
                title: "Terms and Conditions",
                policyUrl: policiesUrls.termsAndConditions,
                isOpen: isTermsOpen,
                onClose: toggleTerms
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TermsIframeModal, {
                title: "Privacy Policy",
                policyUrl: policiesUrls.privacyPolicy,
                isOpen: isPrivacyPolicyOpen,
                onClose: togglePrivacyPolicy
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TermsIframeModal, {
                title: "Cookie Policy",
                policyUrl: policiesUrls.cookiePolicy,
                isOpen: isCookiePolicyOpen,
                onClose: toggleCookiePolicy
            })
        ]
    });
};
function MenuAnchor(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, (0,src_object_spread/* default */.Z)({
        fontSize: "md",
        color: "white"
    }, props));
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(49980);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+algolia@1.5.0_ggl46zudxxlqvmbfh2i2q4ymge/node_modules/@govlaunch/algolia/index.js + 3 modules
var algolia = __webpack_require__(96429);
// EXTERNAL MODULE: ./node_modules/.pnpm/downshift@6.1.7_react@17.0.2/node_modules/downshift/dist/downshift.esm.js
var downshift_esm = __webpack_require__(27242);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/get.js
var fp_get = __webpack_require__(48182);
var get_default = /*#__PURE__*/__webpack_require__.n(fp_get);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@17.0.2_react@17.0.2/node_modules/react-dom/index.js
var react_dom = __webpack_require__(87995);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-outside-click-handler@1.3.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-outside-click-handler/index.js
var react_outside_click_handler = __webpack_require__(5476);
// EXTERNAL MODULE: ./components/HorizontalLine.tsx
var HorizontalLine = __webpack_require__(68231);
;// CONCATENATED MODULE: ./components/search/SearchContext.ts

/* harmony default export */ var SearchContext = ((0,react.createContext)(null));

// EXTERNAL MODULE: ./components/spacings.tsx
var spacings = __webpack_require__(52126);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-highlight-words@0.17.0_react@17.0.2/node_modules/react-highlight-words/dist/main.js
var main = __webpack_require__(25527);
var main_default = /*#__PURE__*/__webpack_require__.n(main);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/escapeRegExp.js
var escapeRegExp = __webpack_require__(2389);
var escapeRegExp_default = /*#__PURE__*/__webpack_require__.n(escapeRegExp);
;// CONCATENATED MODULE: ./components/searchbar/results/HighlightTitle.tsx





function HighlightTitle(param) {
    var title = param.title, query = param.query;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((main_default()), {
        highlightStyle: {
            background: palette/* lightestGray */.v2,
            color: palette/* text */.fL,
            fontWeight: "bold"
        },
        searchWords: [
            escapeRegExp_default()(query || "")
        ],
        textToHighlight: title
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+styled@11.8.1_psntm5zmlvip7zjgnrjqfe3wg4/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js
var emotion_styled_browser_esm = __webpack_require__(43893);
// EXTERNAL MODULE: ./lib/utils/mediaQueries.ts
var mediaQueries = __webpack_require__(29713);
;// CONCATENATED MODULE: ./components/searchbar/results/ResultItem.tsx


/* harmony default export */ var ResultItem = (/*#__PURE__*/(0,emotion_styled_browser_esm["default"])("a", {
    target: "earjqii0"
})((0,mediaQueries/* default */.Z)({
    display: "flex",
    alignItems: "center",
    padding: [
        12,
        "12px 25px"
    ],
    ":hover": {
        backgroundColor: "#F2F4F8"
    }
}), function(param) {
    var highlighted = param.highlighted;
    if (highlighted) {
        return {
            backgroundColor: "#F2F4F8"
        };
    }
}));

;// CONCATENATED MODULE: ./components/searchbar/results/GovernmentResultItem.tsx











var GovernmentResultItem = function(param) {
    var government = param.government, highlighted = param.highlighted, onClick = param.onClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchContext.Consumer, {
        children: function(query) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: "/governments/[governmentSlug]/[[...content]]",
                as: "/governments/".concat(government.slug),
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ResultItem, {
                    onClick: onClick,
                    highlighted: highlighted,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                            position: "relative",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                    image: government.logo,
                                    size: 50,
                                    name: government.name
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                    position: "absolute",
                                    bottom: 1,
                                    right: -3,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CountryFlag */.AW, {
                                        countryCode: government.city.country,
                                        width: 24,
                                        height: 14
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                            ml: 12,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    display: "flex",
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                                        css: {
                                            margin: 0,
                                            color: palette/* text */.fL,
                                            fontWeight: 600,
                                            fontSize: 16
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightTitle, {
                                            title: government.name || "",
                                            query: query
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                        mt: 4,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            css: {
                                                display: "flex"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                css: {
                                                    color: palette/* mediumGray */.rF,
                                                    marginRight: 4,
                                                    fontSize: 14
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Government",
                                                        id: "bh4rlK"
                                                    }),
                                                    " \xb7 ",
                                                    government.city.type,
                                                    " \xb7 ",
                                                    government.country
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            });
        }
    });
};
/* harmony default export */ var results_GovernmentResultItem = (GovernmentResultItem);

;// CONCATENATED MODULE: ./components/searchbar/results/getTagFromQuery.ts
function getTagFromQuery(tags, query) {
    if (tags.length === 0) {
        return null;
    }
    if (tags.length === 1 || !query) {
        return tags[0].name;
    }
    var matchedTag = tags.find(function(param) {
        var name = param.name;
        return (name || "").toLowerCase().includes(query.toLowerCase());
    });
    return matchedTag ? matchedTag.name :  false || tags[0].name;
};

;// CONCATENATED MODULE: ./components/searchbar/results/HighlightTags.tsx






function HighlightTags(param) {
    var tags = param.tags, query = param.query;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((main_default()), {
        highlightStyle: {
            background: palette/* lightestGray */.v2,
            color: palette/* text */.fL,
            fontWeight: "bold"
        },
        searchWords: [
            escapeRegExp_default()(query || "")
        ],
        textToHighlight: getTagFromQuery(tags, query) || ""
    });
};

;// CONCATENATED MODULE: ./components/searchbar/results/ProductResultItem.tsx











var ProductResultItem = function(param) {
    var product = param.product, highlighted = param.highlighted, onClick = param.onClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchContext.Consumer, {
        children: function(query) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: "/products/".concat(product.slug),
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ResultItem, {
                    onClick: onClick,
                    highlighted: highlighted,
                    children: [
                        product.isDisruptor ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                position: "relative"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                size: "md",
                                src: product.logo,
                                name: product.name,
                                variant: product.isDisruptor ? "disruptor" : null
                            })
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                            size: "md",
                            src: product.logo,
                            name: product.name,
                            variant: product.isDisruptor ? "disruptor" : null
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                            ml: 12,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    display: "flex",
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                                        css: {
                                            margin: 0,
                                            color: palette/* text */.fL,
                                            fontWeight: 600,
                                            fontSize: 16
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightTitle, {
                                            title: product.name || "",
                                            query: query
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                        mt: 4,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            css: {
                                                display: "flex"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                css: {
                                                    color: palette/* mediumGray */.rF,
                                                    marginRight: 4,
                                                    fontSize: 14
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Product",
                                                        id: "x/ZVlU"
                                                    }),
                                                    " ",
                                                    product.tags.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                        children: [
                                                            "\xb7 ",
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightTags, {
                                                                tags: product.tags,
                                                                query: query
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            });
        }
    });
};
/* harmony default export */ var results_ProductResultItem = (ProductResultItem);

// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+project@2.37.38_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/project/index.ts + 59 modules
var _govlaunch_project = __webpack_require__(78062);
// EXTERNAL MODULE: ./src/utils/nextLinkHref.ts
var nextLinkHref = __webpack_require__(88196);
;// CONCATENATED MODULE: ./components/searchbar/results/ProjectResultItem.tsx













var ProjectResultItem = function(param) {
    var project = param.project, highlighted = param.highlighted, onClick = param.onClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchContext.Consumer, {
        children: function(query) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: (0,nextLinkHref/* default */.Z)("project", {
                    projectSlug: project.slug
                }),
                as: "/projects/".concat(project.slug),
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ResultItem, {
                    onClick: onClick,
                    highlighted: highlighted,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                display: "inline-flex",
                                width: 50,
                                height: 50
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                name: (0,_govlaunch_project/* getProjectEntityName */.Ue)(project),
                                src: (0,_govlaunch_project/* getProjectEntityLogo */.BE)(project),
                                size: "md"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                            ml: 12,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    display: "flex",
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                                        css: {
                                            margin: 0,
                                            color: palette/* text */.fL,
                                            fontWeight: 600,
                                            fontSize: 16
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightTitle, {
                                            title: project.title || "",
                                            query: query
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                        mt: 4,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                            css: {
                                                color: palette/* mediumGray */.rF,
                                                marginRight: 4,
                                                fontSize: 14
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Project",
                                                    id: "k36uSw"
                                                }),
                                                " \xb7 ",
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightTags, {
                                                    tags: project.tags,
                                                    query: query
                                                }),
                                                " ",
                                                project.__typename === "GovernmentProject" ? "\xb7 ".concat(project.government.name) : ""
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }, project.slug);
        }
    });
};
/* harmony default export */ var results_ProjectResultItem = (ProjectResultItem);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-progressive-image@0.6.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-progressive-image/dist.js
var dist = __webpack_require__(78135);
// EXTERNAL MODULE: ./types/types.ts
var types = __webpack_require__(43845);
;// CONCATENATED MODULE: ./components/searchbar/results/StoryResultItem.tsx












var StoryResultItem = function(param) {
    var story = param.story, highlighted = param.highlighted, onClick = param.onClick;
    var governmentName = story.government && story.government.city && story.government.city.name ? "".concat(story.government.city.name, ", ").concat(story.government.city.state) : null;
    var image = (story.medias || []).find(function(media) {
        var ref;
        return ((ref = media.type) === null || ref === void 0 ? void 0 : ref.toUpperCase()) === types/* IMediaType.Image */.BB.Image;
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchContext.Consumer, {
        children: function(query) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: "/stories/[storySlug]",
                as: "/stories/".concat(story.slug),
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ResultItem, {
                    onClick: onClick,
                    highlighted: highlighted,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* default */.Z, {
                            src: image ? "https://imaginary-ssl.govlaunch.com/resize?quality=100&compression=0&width=326&height=224&url=".concat(image.url, "&force=true") : "",
                            placeholder: "/static/story/story-card-placeholder.png",
                            children: function(src) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                    src: src,
                                    height: 34,
                                    width: 50,
                                    alt: story.title || "",
                                    css: {
                                        minWidth: 50,
                                        minHeight: 34,
                                        pointerEvents: "none",
                                        borderRadius: 5,
                                        objectFit: "cover"
                                    }
                                });
                            }
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                            ml: 12,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    display: "flex",
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                                        css: {
                                            margin: 0,
                                            color: palette/* text */.fL,
                                            fontWeight: 600,
                                            fontSize: 16
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightTitle, {
                                            title: story.title || "",
                                            query: query
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                        mt: 4,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                            css: {
                                                color: palette/* mediumGray */.rF,
                                                marginRight: 4,
                                                fontSize: 14
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Story",
                                                    id: "Bfq+7w"
                                                }),
                                                " \xb7 ",
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightTags, {
                                                    tags: story.tags,
                                                    query: query
                                                }),
                                                " ",
                                                governmentName ? " \xb7 ".concat(governmentName) : ""
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            });
        }
    });
};
/* harmony default export */ var results_StoryResultItem = (StoryResultItem);

;// CONCATENATED MODULE: ./components/icons/MagnifyingClass.tsx




function MagnifyingClass(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 1000 1000",
        width: "1em",
        height: "1em"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M932.8 850l-201-201c56.4-67.6 90.3-154.5 90.3-249.5C822.2 184.2 647.9 10 432.7 10 217.4 10 43.2 184.2 43.2 399.5 43.2 614.7 217.4 789 432.7 789c61.1 0 119-14.1 170.5-39.1 3 4.7 6.6 9.1 10.7 13.2l203 203c32 32 84 32 116 0 31.9-32.1 31.9-84.1-.1-116.1zM125.2 399.5C125.2 229.7 262.9 92 432.7 92s307.5 137.7 307.5 307.5S602.4 707 432.7 707c-169.8 0-307.5-137.7-307.5-307.5z"
        })
    }));
};

;// CONCATENATED MODULE: ./components/searchbar/SearchInput.tsx







function SearchInput(_param) {
    var isFocused = _param.isFocused, onKeyDown = _param.onKeyDown, onClose = _param.onClose, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "isFocused",
        "onKeyDown",
        "onClose"
    ]);
    var inputRef = /*#__PURE__*/ (0,react.createRef)();
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            width: "100%",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                ref: inputRef,
                onKeyDown: function(e) {
                    onKeyDown(e);
                    if (e.key === "Escape") {
                        e.target.blur();
                    }
                },
                placeholder: intl.formatMessage({
                    defaultMessage: "Search the {wiki}...",
                    id: "DRxm+E"
                }, {
                    wiki: "wiki"
                }),
                css: {
                    padding: "0 16px",
                    height: 40,
                    width: "100%",
                    background: isFocused ? "#e3e6eb" : "#3F4A5A",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    borderColor: isFocused ? "#2F3844" : "#5A6677",
                    borderRadius: 4,
                    borderBottomRightRadius: isFocused ? 0 : 4,
                    borderBottomLeftRadius: isFocused ? 0 : 4,
                    color: isFocused ? undefined : "#FAFAF9",
                    outline: 0,
                    fontSize: 16,
                    fontWeight: 500,
                    "::placeholder": {
                        color: "#ADB6C3"
                    }
                }
            })),
            !isFocused && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    position: "absolute",
                    cursor: "pointer",
                    right: 16,
                    top: "50%",
                    transform: "translateY(-50%)"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MagnifyingClass, {
                    width: 20,
                    height: 20,
                    fill: "#ADB6C3",
                    onClick: function() {
                        var ref;
                        return (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                    }
                })
            }),
            isFocused && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    cursor: "pointer",
                    position: "absolute",
                    top: "50%",
                    right: 10,
                    transform: "translateY(-50%)",
                    padding: 6
                },
                onClick: onClose,
                role: "button",
                "aria-label": intl.formatMessage({
                    defaultMessage: "close searchbar",
                    id: "hOnqO9"
                }),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M10.9552 7.99997L15.3882 3.56712C16.2039 2.75098 16.2039 1.42819 15.3882 0.612481C14.5722 -0.20416 13.2489 -0.20416 12.4327 0.612481L8.00004 5.04476L3.56734 0.612481C2.75113 -0.20416 1.42785 -0.20416 0.611783 0.612481C-0.203928 1.42819 -0.203928 2.75098 0.611783 3.56712L5.04491 7.99997L0.611783 12.4328C-0.203928 13.2483 -0.203928 14.5717 0.611783 15.3879C1.42785 16.204 2.75113 16.204 3.56734 15.3879L8.00004 10.955L12.4327 15.3879C13.2489 16.204 14.5722 16.204 15.3882 15.3879C16.2039 14.5717 16.2039 13.2483 15.3882 12.4328L10.9552 7.99997Z",
                        fill: "#1CB7EB"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/searchbar/Searchbar.tsx






















function Searchbar(param) {
    var _initialIsOpen = param.initialIsOpen, initialIsOpen = _initialIsOpen === void 0 ? false : _initialIsOpen, onClose = param.onClose;
    var router = (0,next_router.useRouter)();
    var initialQuery = get_default()("query.query", router) || "";
    var ref = (0,react.useState)({
        governments: [],
        products: [],
        projects: [],
        stories: []
    }), results = ref[0], setResults = ref[1];
    var menuRef = /*#__PURE__*/ (0,react.createRef)();
    var user = (0,Auth/* useSelfie */.yD)();
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(downshift_esm/* default */.ZP, {
        id: "searchbar",
        initialIsOpen: initialIsOpen,
        initialInputValue: initialQuery,
        itemToString: function() {
            return "";
        },
        stateReducer: defaultStateReducer,
        onStateChange: function(changes) {
            if (changes.isOpen === false) {
                if (onClose) {
                    onClose();
                }
            }
        },
        onChange: function(item) {
            if (!item) {
                return;
            }
            if (/signin/i.test(router.route) || /signup/i.test(router.route)) {
                return;
            }
            if (item.__typename === "Story") {
                router.push("/stories/[storySlug]", "/stories/".concat(item.slug));
            }
            if (item.__typename === "Product") {
                router.push("/products/[productSlug]", "/products/".concat(item.slug));
            }
            if (item.__typename === "Government") {
                router.push("/governments/[governmentSlug]", "/governments/".concat(item.slug));
            }
            if (item.__typename === "Project") {
                router.push("/governments/[governmentSlug]/projects/[projectSlug]", "/governments/".concat(item.government.slug, "/projects/").concat(item.slug));
            }
        },
        children: function(param) {
            var getInputProps = param.getInputProps, getRootProps = param.getRootProps, getMenuProps = param.getMenuProps, searchQuery = param.inputValue, getItemProps = param.getItemProps, closeMenu = param.closeMenu, isFocused = param.isOpen, highlightedIndex = param.highlightedIndex, openMenu = param.openMenu;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchContainer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                isFocused: isFocused
            }, getRootProps({
                role: null,
                "aria-labelledby": null
            })), {
                onSubmit: function(e) {
                    e.preventDefault();
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SearchContext.Provider, {
                    value: searchQuery,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_outside_click_handler["default"], {
                            onOutsideClick: function(e) {
                                if (menuRef.current && !menuRef.current.contains(e.target)) {
                                    closeMenu();
                                }
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    height: 81,
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchInput, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, getInputProps({
                                    "aria-label": intl.formatMessage({
                                        defaultMessage: "navbar search input",
                                        id: "ZoaTU9"
                                    }),
                                    "aria-labelledby": null
                                })), {
                                    onFocus: function() {
                                        openMenu();
                                    },
                                    isFocused: isFocused,
                                    value: searchQuery || "",
                                    onClose: function() {
                                        closeMenu();
                                    },
                                    autoFocus: initialIsOpen
                                }))
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(algolia/* AlgoliaFetch */.O, {
                            query: searchQuery || " ",
                            indexes: [
                                "governments",
                                "projects",
                                "stories",
                                "products"
                            ],
                            params: {
                                governments: {
                                    hitsPerPage: 5
                                },
                                projects: {
                                    hitsPerPage: 5
                                },
                                stories: {
                                    hitsPerPage: 5
                                },
                                products: {
                                    hitsPerPage: 5
                                }
                            },
                            onStateChange: function(response) {
                                setResults(filterAlgoliaResults((0,src_object_spread/* default */.Z)({}, results, response.results)));
                            }
                        }),
                        isFocused && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Menu, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            innerRef: menuRef
                        }, getMenuProps({
                            refKey: "innerRef",
                            "aria-label": intl.formatMessage({
                                defaultMessage: "searchbar menu items",
                                id: "z8KDD8"
                            })
                        })), {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalLine/* default */.Z, {
                                    color: palette/* lightestGray */.v2
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    children: mapTypenames(results).map(function(result, index) {
                                        if (result.__typename === "GovernmentProject" || result.__typename === "GroupProject" || result.__typename === "VendorProject") {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(results_ProjectResultItem, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                                project: result
                                            }, getItemProps({
                                                item: result,
                                                onClick: function(e) {
                                                    if (!user) {
                                                        e.preventDefault();
                                                    }
                                                }
                                            })), {
                                                highlighted: highlightedIndex === index
                                            }), result._id);
                                        }
                                        if (result.__typename === "Story") {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(results_StoryResultItem, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                                story: result
                                            }, getItemProps({
                                                item: result,
                                                onClick: function(e) {
                                                    if (!user) {
                                                        e.preventDefault();
                                                    }
                                                }
                                            })), {
                                                highlighted: highlightedIndex === index
                                            }), result._id);
                                        }
                                        if (result.__typename === "Product" && (result.computed.tier > 1 || (searchQuery || "").toLowerCase() === result.name.toLowerCase())) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(results_ProductResultItem, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                                product: result
                                            }, getItemProps({
                                                item: result,
                                                onClick: function(e) {
                                                    if (!user) {
                                                        e.preventDefault();
                                                    }
                                                }
                                            })), {
                                                highlighted: highlightedIndex === index
                                            }), result._id);
                                        }
                                        if (result.__typename === "Government") {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(results_GovernmentResultItem, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                                government: result
                                            }, getItemProps({
                                                item: result,
                                                onClick: function(e) {
                                                    if (!user) {
                                                        e.preventDefault();
                                                    }
                                                }
                                            })), {
                                                highlighted: highlightedIndex === index
                                            }), result._id);
                                        }
                                        return null;
                                    })
                                })
                            ]
                        })),
                        isFocused && /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                position: "fixed",
                                top: 0,
                                bottom: "0%",
                                left: 0,
                                right: 0,
                                background: "rgba(90, 102, 119, 0.6)",
                                zIndex: 302
                            }
                        }), document.body)
                    ]
                })
            }));
        }
    });
}
var SearchContainer = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var isFocused = _param.isFocused, children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "isFocused",
        "children"
    ]);
    if (isFocused) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("form", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            ref: ref,
            style: {
                position: "absolute",
                left: 0,
                top: -4,
                width: "100%",
                height: 81,
                zIndex: 303
            },
            children: children
        }));
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("form", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        ref: ref,
        style: {
            position: "relative"
        },
        children: children
    }));
});
SearchContainer.displayName = "SearchContainer";
function Menu(_param) {
    var children = _param.children, innerRef = _param.innerRef, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "children",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        ref: innerRef,
        css: {
            position: "absolute",
            top: 61,
            left: 0,
            width: "100%",
            background: "#fff",
            border: "1px solid #2F3844",
            borderTop: 0,
            borderBottomLeftRadius: 4,
            borderBottomRightRadius: 4
        },
        children: children
    }));
}
function filterAlgoliaResults(result) {
    var governmentsLength = result.governments.length;
    var storiesLength = result.stories.length;
    var projectsLength = result.projects.length;
    var productsLength = result.products.length;
    var totalLength = governmentsLength + storiesLength + projectsLength + productsLength;
    if (totalLength <= 5) {
        return result;
    }
    if (productsLength > 1) {
        return filterAlgoliaResults((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, result), {
            products: result.products.slice(0, productsLength - 1)
        }));
    }
    if (storiesLength > 1) {
        return filterAlgoliaResults((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, result), {
            stories: result.stories.slice(0, storiesLength - 1)
        }));
    }
    if (projectsLength > 1) {
        return filterAlgoliaResults((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, result), {
            projects: result.projects.slice(0, projectsLength - 1)
        }));
    }
    if (governmentsLength > 1) {
        return filterAlgoliaResults((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, result), {
            governments: result.governments.slice(0, governmentsLength - 1)
        }));
    }
    return result;
}
function mapTypenames(results) {
    return (0,_to_consumable_array/* default */.Z)(results.governments.map(function(government) {
        return (0,src_object_spread/* default */.Z)({
            __typename: "Government"
        }, government);
    })).concat((0,_to_consumable_array/* default */.Z)(results.projects.map(function(project) {
        return (0,src_object_spread/* default */.Z)({
            __typename: getProjectTypename(project)
        }, project);
    })), (0,_to_consumable_array/* default */.Z)(results.stories.map(function(story) {
        return (0,src_object_spread/* default */.Z)({
            __typename: "Story"
        }, story);
    })), (0,_to_consumable_array/* default */.Z)(results.products.map(function(product) {
        return (0,src_object_spread/* default */.Z)({
            __typename: "Product"
        }, product);
    })));
}
function getProjectTypename(project) {
    if (project.government) {
        return "GovernmentProject";
    }
    if (project.vendor) {
        return "VendorProject";
    }
    if (project.group) {
        return "GroupProject";
    }
    throw new Error("Unable to get project typename");
}
function defaultStateReducer(_, changes) {
    switch(changes.type){
        case downshift_esm/* default.stateChangeTypes.keyDownEnter */.ZP.stateChangeTypes.keyDownEnter:
        case downshift_esm/* default.stateChangeTypes.clickItem */.ZP.stateChangeTypes.clickItem:
            {
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, changes), {
                    isOpen: false,
                    inputValue: ""
                });
            }
        default:
            return changes;
    }
}
/* harmony default export */ var searchbar_Searchbar = (Searchbar);

;// CONCATENATED MODULE: ./components/navbar/NavbarSearch.tsx







var NavbarSearch = function() {
    var isMobile = (0,useIsMobile/* default */.Z)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isSearching = ref[0], toggleSearching = ref[1];
    if (isMobile && isSearching) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(searchbar_Searchbar, {
            initialIsOpen: true,
            onClose: function() {
                return toggleSearching(false);
            }
        });
    }
    if (isMobile) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            onClick: function() {
                return toggleSearching();
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MagnifyingClass, {
                width: 20,
                height: 20,
                fill: "#ADB6C3"
            })
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(searchbar_Searchbar, {});
};
/* harmony default export */ var navbar_NavbarSearch = (NavbarSearch);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(99951);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(48465);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(20597);
;// CONCATENATED MODULE: ./src/components/notifications/NotificationSection.tsx





function NotificationSection(_param) {
    var children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        css: {
            fontWeight: 500,
            fontSize: 14,
            padding: "8px 24px",
            backgroundColor: "#E3E6EB",
            borderBottom: "1px solid #ADB6C3",
            color: "#3F4A5A",
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4
        }
    }, props), {
        children: children
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+popover@0.10.2_qlbrybfyutdb3nzvgq5n4v5xcq/node_modules/@govlaunch/popover/index.js + 59 modules
var popover = __webpack_require__(70271);
;// CONCATENATED MODULE: ./src/components/notifications/NotificationIcon.tsx




var NotificationIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.3809 6.3614C20.1939 6.78647 23.2017 8.69358 23.2017 14.3C23.2017 20.2566 24.5574 21.3721 26.4367 22.9184C26.6198 23.069 26.8079 23.2238 27.0001 23.3875H5.00012C5.18978 23.2273 5.37522 23.0758 5.55574 22.9283C7.44739 21.3829 8.79856 20.279 8.79856 14.3115C8.79856 8.70507 11.8236 6.79222 14.6423 6.3614C14.6366 6.33267 14.6366 6.30395 14.6366 6.26949C14.6366 5.56294 15.2381 5 16.0001 5C16.7621 5 17.3866 5.56294 17.3866 6.26949C17.3866 6.28751 17.385 6.30395 17.3835 6.31965C17.3822 6.33398 17.3809 6.34769 17.3809 6.3614ZM18.9731 24.5879C18.807 25.9149 17.5465 27.058 16.011 27.058C14.4756 27.058 13.2094 25.9149 13.049 24.5879H18.9731Z",
            fill: "#73849D"
        })
    }));
};
/* harmony default export */ var notifications_NotificationIcon = (NotificationIcon);

;// CONCATENATED MODULE: ./src/components/notifications/NotificationBell.tsx






function NotificationBell(_param) {
    var onClick = _param.onClick, children = _param.children, innerRef = _param.innerRef, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "onClick",
        "children",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        css: {
            display: "inline-flex",
            position: "relative",
            cursor: "pointer"
        },
        role: "button",
        onClick: onClick,
        "aria-label": "Notifications",
        ref: innerRef
    }, rest), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(notifications_NotificationIcon, {}),
            children
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/notifications/NotificationCount.tsx


function NotificationCount(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        css: {
            backgroundColor: "#28D094",
            color: "#FAFAF9",
            fontSize: 12,
            width: 16,
            height: 16,
            lineHeight: 20,
            borderRadius: 20,
            position: "absolute",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            bottom: 0,
            right: -6
        },
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(38975);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/dist/build/polyfills/fetch/index.js
var fetch = __webpack_require__(29782);
var fetch_default = /*#__PURE__*/__webpack_require__.n(fetch);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp.js
var fp = __webpack_require__(56365);
// EXTERNAL MODULE: ./node_modules/.pnpm/qs@6.11.0/node_modules/qs/lib/index.js
var qs_lib = __webpack_require__(47216);
var lib_default = /*#__PURE__*/__webpack_require__.n(qs_lib);
;// CONCATENATED MODULE: ./src/components/notifications/getNotificationsApiUrl.ts
function getNotificationsApiUrl() {
    var environment = "production" || 0 || 0;
    if (environment === "test") {
        return "http://localhost:4001";
    }
    return "https://wlneihghmb.execute-api.us-west-2.amazonaws.com/production";
};

// EXTERNAL MODULE: ./node_modules/.pnpm/pubnub@4.37.0/node_modules/pubnub/dist/web/pubnub.min.js
var pubnub_min = __webpack_require__(22879);
var pubnub_min_default = /*#__PURE__*/__webpack_require__.n(pubnub_min);
;// CONCATENATED MODULE: ./src/infra/pubnubClient.ts

function getPubNubClient() {
    var environment = "production" || 0 || 0;
    if (environment === "test") {
        return new (pubnub_min_default())({
            subscribeKey: "",
            ssl: true,
            uuid: "66e46024-44b1-4733-965c-1cca9b3d8ea3"
        });
    }
    return new (pubnub_min_default())({
        subscribeKey: "sub-c-3abd99f4-3e6a-11e8-a2e8-d2288b7dcaaf" || 0,
        ssl: true,
        uuid: "0b3cf8f5-a1bc-46d5-9c6d-b024b766423c" || 0
    });
}
/* harmony default export */ var pubnubClient = (getPubNubClient());

;// CONCATENATED MODULE: ./src/components/notifications/NotificationStream.tsx













var NotificationStream = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(NotificationStream, Component);
    var _super = (0,_create_super/* default */.Z)(NotificationStream);
    function NotificationStream() {
        (0,_class_call_check/* default */.Z)(this, NotificationStream);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            loading: false,
            stream: {
                notifications: [],
                groups: {},
                unreadCount: 0,
                hasMore: false
            }
        };
        _this.fetchStream = function(beforeThisId) {
            _this.setState({
                loading: true
            });
            var pagination = buildQueryString({
                beforeThisId: beforeThisId
            });
            return fetch_default()("".concat(getNotificationsApiUrl(), "/stream").concat(pagination), {
                method: "GET",
                headers: {
                    Authorization: "Bearer ".concat(_this.props.token)
                }
            }).then(function(response) {
                if (response.status !== 200) {
                    _this.setState({
                        loading: false
                    });
                } else {
                    return response.json();
                }
            }).then((0,fp.pick)([
                "notifications",
                "groups",
                "unreadCount",
                "hasMore"
            ])).then(function(stream) {
                _this.setState(function(param) {
                    var currentStream = param.stream;
                    if (beforeThisId) {
                        return {
                            loading: false,
                            stream: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, currentStream), {
                                hasMore: stream.hasMore,
                                unreadCount: stream.unreadCount,
                                notifications: currentStream.notifications.concat(stream.notifications),
                                groups: (0,src_object_spread/* default */.Z)({}, currentStream.groups, stream.groups)
                            })
                        };
                    }
                    return {
                        loading: false,
                        stream: stream
                    };
                });
            }).catch(fp.noop);
        };
        _this.handleRead = function(notification) {
            if (notification.readAt || notification.completedAt || notification.deletedAt) {
                return Promise.resolve(notification);
            }
            var promise = fetch_default()("".concat(getNotificationsApiUrl(), "/read"), {
                method: "PUT",
                headers: {
                    Authorization: "Bearer ".concat(_this.props.token),
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    notification: notification._id
                })
            }).then(function() {
                return notification;
            }).catch(fp.noop);
            _this.setState(function(_param) {
                var stream = _param.stream, state = (0,src_object_without_properties/* default */.Z)(_param, [
                    "stream"
                ]);
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                    stream: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, stream), {
                        unreadCount: stream.unreadCount - 1,
                        notifications: stream.notifications.map(function(maybeNotification) {
                            if (notification._id !== maybeNotification._id) {
                                return maybeNotification;
                            }
                            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, notification), {
                                readAt: new Date().toISOString()
                            });
                        })
                    })
                });
            });
            return promise;
        };
        _this.handleReadAll = function() {
            var promise = fetch_default()("".concat(getNotificationsApiUrl(), "/readAll"), {
                method: "PUT",
                headers: {
                    Authorization: "Bearer ".concat(_this.props.token)
                }
            }).catch(fp.noop);
            _this.setState(function(_param) {
                var stream = _param.stream, state = (0,src_object_without_properties/* default */.Z)(_param, [
                    "stream"
                ]);
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                    stream: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, stream), {
                        unreadCount: 0,
                        notifications: stream.notifications.map(function(notification) {
                            if (notification.readAt) {
                                return notification;
                            }
                            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, notification), {
                                readAt: new Date().toISOString()
                            });
                        })
                    })
                });
            });
            return promise;
        };
        _this.readNotifications = function(param) {
            var readAt = param.readAt, groups = param.groups, notifications = param.notifications;
            _this.setState(function(_param) {
                var stream = _param.stream, state = (0,src_object_without_properties/* default */.Z)(_param, [
                    "stream"
                ]);
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                    stream: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, stream), {
                        unreadCount: stream.unreadCount - notifications.length - groups.length,
                        groups: Object.keys(stream.groups).reduce(function(streamGroups, group) {
                            if (groups.includes(group)) {
                                return (0,fp.update)([
                                    group,
                                    "notifications"
                                ], function(notifications) {
                                    return notifications.map((0,fp.set)("readAt", readAt));
                                }, streamGroups);
                            }
                            return streamGroups;
                        }, stream.groups),
                        notifications: stream.notifications.map(function(notification) {
                            if (notifications.includes(notification._id) || groups.includes(notification.group)) {
                                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, notification), {
                                    readAt: readAt
                                });
                            }
                            return notification;
                        })
                    })
                });
            });
        };
        _this.receiveNotification = function(message) {
            _this.setState(function(_param) {
                var stream = _param.stream, state = (0,src_object_without_properties/* default */.Z)(_param, [
                    "stream"
                ]);
                var unreadCount = stream.unreadCount, notifications = stream.notifications, groups = stream.groups;
                if (message.group) {
                    var hasAnyRead = notifications.some(function(param) {
                        var group = param.group, readAt = param.readAt;
                        return group === message.notification.group && readAt !== null;
                    });
                    var hasGroup = (0,fp.has)(message.notification.group, groups);
                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                        stream: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, stream), {
                            unreadCount: unreadCount + (hasAnyRead || !hasGroup ? 1 : 0),
                            notifications: notifications.filter(function(param) {
                                var group = param.group;
                                return group !== message.notification.group;
                            }).concat(message.notification),
                            groups: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, groups), (0,_define_property/* default */.Z)({}, message.notification.group, message.group))
                        })
                    });
                } else {
                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                        stream: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, stream), {
                            unreadCount: unreadCount + 1,
                            notifications: notifications.concat(message.notification)
                        })
                    });
                }
            });
        };
        _this.handleIncomingMessage = function(param) {
            var message = param.message;
            var eventTypes = [
                "com.govlaunch.notifications:read",
                "com.govlaunch.notifications:push"
            ];
            if (eventTypes.includes(message.type)) {
                if (message.type === "com.govlaunch.notifications:read") {
                    _this.readNotifications(message.data);
                } else if (message.type === "com.govlaunch.notifications:push") {
                    _this.receiveNotification(message.data);
                }
            }
        };
        return _this;
    }
    var _proto = NotificationStream.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var channels = this.props.channels;
        pubnubClient.addListener({
            message: this.handleIncomingMessage
        });
        this.fetchStream(null).then(function() {
            pubnubClient.subscribe({
                channels: channels.filter(Boolean),
                withPresence: false
            });
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var channels = this.props.channels;
        pubnubClient.removeListener({
            message: this.handleIncomingMessage
        });
        pubnubClient.unsubscribe({
            channels: channels.filter(Boolean)
        });
    };
    _proto.render = function render() {
        var _this = this;
        var children = this.props.children;
        var _state = this.state, loading = _state.loading, _stream = _state.stream, unreadCount = _stream.unreadCount, notifications = _stream.notifications, groups = _stream.groups, hasMore = _stream.hasMore;
        return children({
            unreadCount: unreadCount,
            notifications: sortNotifications(notifications || []),
            groups: groups,
            read: this.handleRead,
            readAll: this.handleReadAll,
            hasMore: hasMore,
            loading: loading,
            loadMore: function(beforeThisId) {
                return _this.fetchStream(beforeThisId);
            }
        });
    };
    return NotificationStream;
}(react.Component);

function sortNotifications(notificationsToBeSorted) {
    var notifications = notificationsToBeSorted.slice();
    notifications.sort(function(a, b) {
        var prioritySort = b.priority - a.priority;
        var createdAtSort = new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
        if (a.priority === 0 && b.priority === 0) {
            return createdAtSort;
        } else {
            return prioritySort;
        }
    });
    return notifications;
}
function buildQueryString() {
    var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return lib_default().stringify(query, {
        addQueryPrefix: true,
        skipNulls: true
    });
}

;// CONCATENATED MODULE: ./src/components/notifications/NotificationPopover.tsx







function NotificationPopover(param) {
    var channels = param.channels, _token = param.token, token = _token === void 0 ? null : _token, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationStream, {
        token: token,
        channels: channels,
        children: function(param) {
            var notifications = param.notifications, unreadCount = param.unreadCount, loadMore = param.loadMore, read = param.read, readAll = param.readAll, groups = param.groups, loading = param.loading, hasMore = param.hasMore;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Value */.B4, {
                initial: false,
                children: function(param) {
                    var isOpen = param.value, setOpen = param.set;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(popover/* default */.Z, {
                        placement: "bottom",
                        backgroundColor: "#E3E6EB",
                        borderColor: "#E3E6EB",
                        isOpen: isOpen,
                        clickOutsideStrategy: "accessibility",
                        boxStyle: {
                            boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)",
                            minWidth: 375,
                            border: "1px solid #ADB6C3"
                        },
                        onClickOutside: function() {
                            return setOpen(false);
                        },
                        render: function() {
                            return children({
                                notifications: notifications,
                                unreadCount: unreadCount,
                                loadMore: loadMore,
                                read: read,
                                readAll: readAll,
                                groups: groups,
                                loading: loading,
                                hasMore: hasMore,
                                open: function() {
                                    return setOpen(true);
                                },
                                close: function() {
                                    return setOpen(false);
                                }
                            });
                        },
                        children: function(param) {
                            var innerRef = param.innerRef;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationBell, {
                                innerRef: innerRef,
                                onClick: function() {
                                    return setOpen(isOpen ? false : true);
                                },
                                children: unreadCount > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationCount, {
                                    children: unreadCount
                                })
                            });
                        }
                    });
                }
            });
        }
    });
};

;// CONCATENATED MODULE: ./src/components/notifications/NotificationsOverflow.tsx


function NotificationsOverflow(param) {
    var children = param.children, innerRef = param.innerRef;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        ref: innerRef,
        css: {
            maxHeight: 550,
            overflowY: "auto"
        },
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/notifications/NotificationBox.tsx







var className = "govlaunch-notification-box";
// const createNotificationBox = (tag: keyof JSX.IntrinsicElements) =>
var createNotificationBox = function(tag) {
    return /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(tag, {
        target: "e89qc4c0"
    })(function(props) {
        return {
            minHeight: 60,
            boxSizing: "border-box",
            padding: "15px 10px",
            textDecoration: "none",
            fontSize: 12,
            backgroundColor: props.unread ? "rgba(229, 255, 246, 0.5)" : "#fff",
            borderTop: "1px solid ".concat(palette/* lightestSealBlue */.ks),
            borderLeft: props.unread ? "3px solid ".concat(palette/* greenSuccess */.CU) : "3px solid transparent",
            display: "flex",
            cursor: "pointer",
            alignItems: "center"
        };
    });
};
function NotificationBox(_param) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "tag"
    ]);
    var Component = createNotificationBox(tag);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Component, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        className: className
    }));
};

;// CONCATENATED MODULE: ./src/components/notifications/NotificationsWrapper.tsx




function NotificationsWrapper(param) {
    var children = param.children;
    var _obj;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: (_obj = {
            display: "flex",
            flexDirection: "column",
            maxWidth: 425
        }, (0,_define_property/* default */.Z)(_obj, "& .".concat(className, ":first-of-type"), {
            borderTop: 0
        }), (0,_define_property/* default */.Z)(_obj, "background", "#fff"), _obj),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/notifications/fullName.ts
function fullName(names) {
    if (!names) {
        return "";
    }
    return "".concat(names.firstName || "", " ").concat(names.lastName || "").trim();
};

// EXTERNAL MODULE: ./node_modules/.pnpm/moment@2.29.4/node_modules/moment/moment.js
var moment = __webpack_require__(98777);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/shared/components/IntlRelativeTime.tsx
var IntlRelativeTime = __webpack_require__(89989);
;// CONCATENATED MODULE: ./src/components/notifications/NotificationTimeAgo.tsx








var NotificationTimeAgo = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(NotificationTimeAgo, Component);
    var _super = (0,_create_super/* default */.Z)(NotificationTimeAgo);
    function NotificationTimeAgo() {
        (0,_class_call_check/* default */.Z)(this, NotificationTimeAgo);
        var _this;
        _this = _super.apply(this, arguments);
        _this.interval = undefined;
        return _this;
    }
    var _proto = NotificationTimeAgo.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        this.interval = setInterval(function() {
            return _this.forceUpdate();
        }, 60 * 1000);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    };
    _proto.render = function render() {
        var time = this.props.time;
        var datetime = moment_default()(time).toISOString();
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("time", {
            css: {
                margin: 0,
                fontSize: 12,
                lineHeight: "15px",
                color: palette/* mediumGray */.rF
            },
            dateTime: datetime,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlRelativeTime/* default */.Z, {
                value: time
            })
        });
    };
    return NotificationTimeAgo;
}(react.Component);


;// CONCATENATED MODULE: ./src/components/notifications/ProducerNames.tsx




function ProducerNames(param) {
    var notification = param.notification, _group = param.group, group = _group === void 0 ? null : _group, _limitOfNames = param.limitOfNames, limitOfNames = _limitOfNames === void 0 ? 3 : _limitOfNames, pathToProducer = param.pathToProducer, pathToNameProducer = param.pathToNameProducer;
    var intl = (0,useIntl/* default */.Z)();
    if (!group) {
        var producer = pathToNameProducer ? get_default()(pathToNameProducer, notification) : get_default()(pathToProducer || "", notification);
        if (!producer) {
            return null;
        } else {
            if (pathToNameProducer) {
                return producer;
            }
            return fullName(producer);
        }
    }
    var names = group.notifications.slice(0, limitOfNames).map(function(notification) {
        if (pathToNameProducer) {
            return get_default()(pathToNameProducer, notification);
        }
        return fullName(get_default()(pathToProducer || "", notification));
    });
    return naturalStringJoin(intl, names, group.totalCount);
};
function naturalStringJoin(intl, strings, totalCount) {
    var filteredStrings = strings.map(function(string) {
        return string.trim();
    }).filter(Boolean);
    if (filteredStrings.length === 0) {
        return "";
    }
    if (filteredStrings.length === 1) {
        return filteredStrings[0];
    }
    if (filteredStrings.length === 2) {
        var _filteredStrings = (0,_sliced_to_array/* default */.Z)(filteredStrings, 2), first = _filteredStrings[0], second = _filteredStrings[1];
        return intl.formatMessage({
            defaultMessage: "{first} and {second}",
            id: "zK/CbE"
        }, {
            first: first,
            second: second
        });
    }
    if (filteredStrings.length === 3 && totalCount === 3) {
        var _filteredStrings1 = (0,_sliced_to_array/* default */.Z)(filteredStrings, 3), first1 = _filteredStrings1[0], second1 = _filteredStrings1[1], last = _filteredStrings1[2];
        return intl.formatMessage({
            defaultMessage: "{first}, {second} and {last}",
            id: "tu4vwG"
        }, {
            first: first1,
            second: second1,
            last: last
        });
    }
    return intl.formatMessage({
        defaultMessage: "{names} and {totalCount} others",
        id: "gtcWky"
    }, {
        names: filteredStrings.join(", "),
        totalCount: totalCount - 1
    });
}

;// CONCATENATED MODULE: ./src/components/notifications/Notification.tsx












function Notification_Notification(_param) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, notification = _param.notification, group = _param.group, pathToActor = _param.pathToActor, pathToActorName = _param.pathToActorName, pathToAvatar = _param.pathToAvatar, avatarName = _param.avatarName, children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "tag",
        "notification",
        "group",
        "pathToActor",
        "pathToActorName",
        "pathToAvatar",
        "avatarName",
        "children"
    ]);
    var avatarUrl;
    var actorName;
    // if (!pathToActorName && !pathToActor) {
    //   throw new Error("You must provide either `pathToActorName` or `pathToActor`");
    // }
    if (group && group.notifications.length > 0) {
        var firstOfGroup = group.notifications[0];
        avatarUrl = get_default()(pathToAvatar, firstOfGroup);
        if (pathToActorName) {
            actorName = get_default()(pathToActorName, firstOfGroup);
        } else if (pathToActor) {
            actorName = fullName(get_default()(pathToActor, firstOfGroup));
        }
    } else {
        avatarUrl = get_default()(pathToAvatar, notification);
        if (pathToActorName) {
            actorName = get_default()(pathToActorName, notification);
        } else if (pathToActor) {
            actorName = fullName(get_default()(pathToActor, notification));
        }
    }
    var isUnread = !notification.readAt;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NotificationBox, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        tag: tag,
        unread: isUnread
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    marginRight: 15
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                    alt: actorName ? "Profile picture of ".concat(actorName) : "Profile picture",
                    name: avatarName || actorName || "Govlaunch",
                    image: avatarUrl,
                    xsmall: true
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                        css: {
                            margin: 0,
                            color: palette/* mediumGray */.rF,
                            wordBreak: "break-word"
                        },
                        children: [
                            (pathToActorName || pathToActor) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: {
                                    color: palette/* text */.fL,
                                    lineHeight: "15px"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProducerNames, {
                                    pathToProducer: pathToActor,
                                    pathToNameProducer: pathToActorName,
                                    notification: notification,
                                    group: group || null
                                })
                            }),
                            children
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationTimeAgo, {
                        time: notification.createdAt
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/notifications/notifications.tsx









function ReportCommentUpvote(_param) {
    var notification = _param.notification, props = _object_without_properties(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ _jsxs(Notification, _object_spread_props(_object_spread({}, props), {
        notification: notification,
        pathToActor: "payload.upvotedBy",
        pathToAvatar: "payload.upvotedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ _jsx(FormattedMessage, {
                defaultMessage: "upvoted your comment in <highlight>{text}</highlight>",
                id: "3dqVpu",
                values: {
                    text: get("payload.report.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ _jsx(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ReportCommentReply(_param) {
    var notification = _param.notification, props = _object_without_properties(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ _jsxs(Notification, _object_spread_props(_object_spread({}, props), {
        notification: notification,
        pathToActor: "payload.repliedBy",
        pathToAvatar: "payload.repliedBy.avatarUrl",
        children: [
            "  ",
            /*#__PURE__*/ _jsx(FormattedMessage, {
                defaultMessage: "replied to your comment in <highlight>{text}</highlight>",
                id: "ptbt+B",
                values: {
                    text: get("payload.report.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ _jsx(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ProductComment(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.commentedBy",
        pathToAvatar: "payload.commentedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "commented in your product <highlight>{text}</highlight>",
                id: "4pshmz",
                values: {
                    text: get_default()("payload.product.name", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ProductCommentMention(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.mentionedBy",
        pathToAvatar: "payload.mentionedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "mentioned you in a comment on <highlight>{text}</highlight>",
                id: "0f3EBg",
                values: {
                    text: get_default()("payload.product.name", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ProductCommentReply(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.repliedBy",
        pathToAvatar: "payload.repliedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "replied your comment in product <highlight>{text}</highlight>",
                id: "20ja7d",
                values: {
                    text: get_default()("payload.product.name", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ProductCommentUpvote(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.upvotedBy",
        pathToAvatar: "payload.upvotedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "upvoted your comment in <highlight>{text}</highlight>",
                id: "3dqVpu",
                values: {
                    text: get_default()("payload.product.name", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ProductUpvote(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.upvotedBy",
        pathToAvatar: "payload.upvotedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "upvoted your product <highlight>{text}</highlight>",
                id: "Zqp8jY",
                values: {
                    text: get_default()("payload.product.name", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function QuestionComment(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.commentedBy",
        pathToAvatar: "payload.commentedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "answered your question <highlight>{text}</highlight>",
                id: "jyBJ+O",
                values: {
                    text: get_default()("payload.question.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function QuestionCommentMention(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.mentionedBy",
        pathToAvatar: "payload.mentionedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "mentioned you in a answer on <highlight>{text}</highlight>",
                id: "WvKbw0",
                values: {
                    text: get_default()("payload.question.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function QuestionCommentReply(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.repliedBy",
        pathToAvatar: "payload.repliedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "replied your answer on question <highlight>{text}</highlight>",
                id: "p27pk2",
                values: {
                    text: get_default()("payload.question.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function QuestionCommentUpvote(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.upvotedBy",
        pathToAvatar: "payload.upvotedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "upvoted your answer in <highlight>{text}</highlight>",
                id: "l0BdvL",
                values: {
                    text: get_default()("payload.question.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ProductRecommendation(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.recommendedBy",
        pathToAvatar: "payload.recommendedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "recommended <highlight>{name}</highlight> on your question <highlight>{title}</highlight>",
                id: "2BA/os",
                values: {
                    name: get_default()("payload.product.name", notification),
                    title: get_default()("payload.question.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ProductRecommendationUpvote(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.upvotedBy",
        pathToAvatar: "payload.upvotedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "upvoted a recommendation on your question for <highlight>{text}</highlight>",
                id: "bjyyDz",
                values: {
                    text: get_default()("payload.product.name", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function RecommendationEndorsementUpvote(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.upvotedBy",
        pathToAvatar: "payload.upvotedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "marked your recommendation as helpful on question <highlight>{text}</highlight>",
                id: "n81krv",
                values: {
                    text: get_default()("payload.question.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function RecommendationEndorsementComment(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.commentedBy",
        pathToAvatar: "payload.commentedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "commented your recommendation on question <highlight>{text}</highlight>",
                id: "HxFc8q",
                values: {
                    text: get_default()("payload.question.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function RecommendationEndorsementCommentMention(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.mentionedBy",
        pathToAvatar: "payload.mentionedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "mentioned you in a comment on question <highlight>{text}</highlight>",
                id: "BIuJLD",
                values: {
                    text: get_default()("payload.question.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function RecommendationEndorsementCommentReply(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.repliedBy",
        pathToAvatar: "payload.repliedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "replied your recommendation comment on question <highlight>{text}</highlight>",
                id: "eYHlmn",
                values: {
                    text: get_default()("payload.question.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function RecommendationEndorsementCommentUpvote(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.upvotedBy",
        pathToAvatar: "payload.upvotedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "upvoted your comment on question <highlight>{text}</highlight>",
                id: "+m0gml",
                values: {
                    text: get_default()("payload.question.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ResourceComment(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.commentedBy",
        pathToAvatar: "payload.commentedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "commented in your resource <highlight>{text}</highlight>",
                id: "PYazWo",
                values: {
                    text: get_default()("payload.resource.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ResourceCommentMention(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.mentionedBy",
        pathToAvatar: "payload.mentionedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "mentioned you in a comment on <highlight>{text}</highlight>",
                id: "0f3EBg",
                values: {
                    text: get_default()("payload.resource.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ResourceCommentReply(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.repliedBy",
        pathToAvatar: "payload.repliedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "replied your comment in resource <highlight>{text}</highlight>",
                id: "4b7TCJ",
                values: {
                    text: get_default()("payload.resource.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ResourceCommentUpvote(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.upvotedBy",
        pathToAvatar: "payload.upvotedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "upvoted your comment in <highlight>{text}</highlight>",
                id: "3dqVpu",
                values: {
                    text: get_default()("payload.resource.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ResourceUpvote(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.upvotedBy",
        pathToAvatar: "payload.upvotedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "upvoted your resource <highlight>{text}</highlight>",
                id: "TTJ1KE",
                values: {
                    text: get_default()("payload.resource.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function StoryComment(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.commentedBy",
        pathToAvatar: "payload.commentedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "commented in your story <highlight>{text}</highlight>",
                id: "Znr3Rd",
                values: {
                    text: get_default()("payload.story.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ProjectComment(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.commentedBy",
        pathToAvatar: "payload.commentedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "commented in your project <highlight>{text}</highlight>",
                id: "kycEjx",
                values: {
                    text: get_default()("payload.project.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function StoryCommentMention(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.mentionedBy",
        pathToAvatar: "payload.mentionedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "mentioned you in a comment on <highlight>{text}</highlight>",
                id: "0f3EBg",
                values: {
                    text: get_default()("payload.story.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function StoryCommentReply(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.repliedBy",
        pathToAvatar: "payload.repliedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "replied your comment in story <highlight>{text}</highlight>",
                id: "nJMmR+",
                values: {
                    text: get_default()("payload.story.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ProjectCommentReply(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.repliedBy",
        pathToAvatar: "payload.repliedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "replied your comment in project <highlight>{text}</highlight>",
                id: "kta8sr",
                values: {
                    text: get_default()("payload.project.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function StoryCommentUpvote(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.upvotedBy",
        pathToAvatar: "payload.upvotedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "upvoted your comment in <highlight>{text}</highlight>",
                id: "3dqVpu",
                values: {
                    text: get_default()("payload.story.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ProjectCommentUpvote(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.upvotedBy",
        pathToAvatar: "payload.upvotedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "upvoted your comment in <highlight>{text}</highlight>",
                id: "3dqVpu",
                values: {
                    text: get_default()("payload.project.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function StoryUpvote(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.upvotedBy",
        pathToAvatar: "payload.upvotedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "upvoted your story <highlight>{text}</highlight>",
                id: "TFBH3r",
                values: {
                    text: get_default()("payload.story.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ProjectUpvote(_param) {
    var notification = _param.notification, props = _object_without_properties(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ _jsxs(Notification, _object_spread_props(_object_spread({}, props), {
        notification: notification,
        pathToActor: "payload.upvotedBy",
        pathToAvatar: "payload.upvotedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ _jsx(FormattedMessage, {
                defaultMessage: "upvoted your project <highlight>{text}</highlight>",
                id: "jUzr7z",
                values: {
                    text: get("payload.project.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ _jsx(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function PostUpvote(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.upvotedBy",
        pathToAvatar: "payload.upvotedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "upvoted your post <highlight>{text}</highlight>",
                id: "itdfvy",
                values: {
                    text: get_default()("payload.post.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ThreadComment(_param) {
    var notification = _param.notification, props = _object_without_properties(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ _jsxs(Notification, _object_spread_props(_object_spread({}, props), {
        notification: notification,
        pathToActor: "payload.commentedBy",
        pathToAvatar: "payload.commentedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ _jsx(FormattedMessage, {
                defaultMessage: "commented in your thread <highlight>{text}</highlight>",
                id: "AAQHgP",
                values: {
                    text: get("payload.thread.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ _jsx(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ThreadCommentMention(_param) {
    var notification = _param.notification, props = _object_without_properties(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ _jsxs(Notification, _object_spread_props(_object_spread({}, props), {
        notification: notification,
        pathToActor: "payload.mentionedBy",
        pathToAvatar: "payload.mentionedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ _jsx(FormattedMessage, {
                defaultMessage: "mentioned you in a comment on <highlight>{text}</highlight>",
                id: "0f3EBg",
                values: {
                    text: get("payload.thread.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ _jsx(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ThreadCommentReply(_param) {
    var notification = _param.notification, props = _object_without_properties(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ _jsxs(Notification, _object_spread_props(_object_spread({}, props), {
        notification: notification,
        pathToActor: "payload.repliedBy",
        pathToAvatar: "payload.repliedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ _jsx(FormattedMessage, {
                defaultMessage: "replied your comment in thread <highlight>{text}</highlight>",
                id: "c46b1q",
                values: {
                    text: get("payload.thread.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ _jsx(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ThreadCommentUpvote(_param) {
    var notification = _param.notification, props = _object_without_properties(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ _jsxs(Notification, _object_spread_props(_object_spread({}, props), {
        notification: notification,
        pathToActor: "payload.upvotedBy",
        pathToAvatar: "payload.upvotedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ _jsx(FormattedMessage, {
                defaultMessage: "upvoted your comment in thread <highlight>{text}</highlight>",
                id: "gkgTI4",
                values: {
                    text: get("payload.thread.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ _jsx(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ThreadMention(_param) {
    var notification = _param.notification, props = _object_without_properties(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ _jsxs(Notification, _object_spread_props(_object_spread({}, props), {
        notification: notification,
        pathToActor: "payload.mentionedBy",
        pathToAvatar: "payload.mentionedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ _jsx(FormattedMessage, {
                defaultMessage: "mentioned you in <highlight>{text}</highlight>",
                id: "bkWtrs",
                values: {
                    text: get("payload.thread.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ _jsx(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function ThreadUpvote(_param) {
    var notification = _param.notification, props = _object_without_properties(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ _jsxs(Notification, _object_spread_props(_object_spread({}, props), {
        notification: notification,
        pathToActor: "payload.upvotedBy",
        pathToAvatar: "payload.upvotedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ _jsx(FormattedMessage, {
                defaultMessage: "upvoted your thread <highlight>{text}</highlight>",
                id: "PjBG2t",
                values: {
                    text: get("payload.thread.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ _jsx(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function StoryWasEdited(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.editedBy",
        pathToAvatar: "payload.editedBy.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "edited the Story <highlight>{text}</highlight>",
                id: "E9F0iz",
                values: {
                    text: get_default()("payload.story.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function AddedAsCollaborator(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToAvatar: "payload.story.government.logo",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "You have been added as collaborator on Story <highlight>{text}</highlight>",
                id: "KG6Lbn",
                values: {
                    text: get_default()("payload.story.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function AddedAsAuthor(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToAvatar: "payload.story.government.logo",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "You have been added as author on Story <highlight>{text}</highlight>",
                id: "KzY+OS",
                values: {
                    text: get_default()("payload.story.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function WelcomeToGroup(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToAvatar: "payload.logo",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "Welcome to <highlight>{text}</highlight>!",
            id: "p/S0tp",
            values: {
                text: get_default()("payload.name", notification),
                highlight: function(text) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                        children: text
                    });
                }
            }
        })
    }));
}
function AccessRequestAccepted(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToAvatar: "payload.logo",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "Congratulations! Your access is now granted for <highlight>{text}</highlight>",
            id: "SBcMuN",
            values: {
                text: get_default()("payload.account.name", notification),
                highlight: function(text) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                        children: text
                    });
                }
            }
        })
    }));
}
function AccessRequestDeclined(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToAvatar: "payload.logo",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "Your access was declined for <highlight>{text}</highlight>. If you feel this was an error, please <mailto>contact us</mailto>",
            id: "oC9aem",
            values: {
                text: get_default()("payload.account.name", notification),
                highlight: function(text) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                        children: text
                    });
                },
                mailto: function(text) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                        href: "mailto:hello@govlaunch.com",
                        children: text
                    });
                }
            }
        })
    }));
}
function AccountVerified(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToAvatar: "payload.logo",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "Your account is now verified on Govlaunch",
            id: "fpKN1k"
        })
    }));
}
function AccountUnverified(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToAvatar: "payload.logo",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "We couldn't verify your account on Govlaunch. If you think that was a mistake, please <mailto>contact us</mailto>",
            id: "BPaXXZ",
            values: {
                mailto: function(text) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                        href: "mailto:hello@govlaunch.com",
                        children: text
                    });
                }
            }
        })
    }));
}
function HighlightNotificationPart(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        css: {
            color: palette/* text */.fL,
            lineHeight: "15px"
        }
    }));
}
function ProductApproved(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToAvatar: "payload.product.logo",
        avatarName: get_default()("payload.product.name", notification),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "Your product <highlight>{text}</highlight> has been approved \uD83C\uDF89",
            id: "+R2M9l",
            values: {
                text: get_default()("payload.product.name", notification),
                highlight: function(text) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                        children: text
                    });
                }
            }
        })
    }));
}
// -- Invites / Collaborators ------
function JoinedAsCollaboratorOnProject(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.collaborator",
        pathToAvatar: "payload.collaborator.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "joined as a collaborator on Project <highlight>{text}</highlight>",
                id: "oAqqwr",
                values: {
                    text: get_default()("payload.project.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function JoinedAsCollaboratorOnStory(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.collaborator",
        pathToAvatar: "payload.collaborator.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "joined as a collaborator on Story <highlight>{text}</highlight>",
                id: "g4R3LD",
                values: {
                    text: get_default()("payload.story.title", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function JoinedAsGovernmentMember(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.member",
        pathToAvatar: "payload.member.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "joined as a member of <highlight>{text}</highlight>",
                id: "gf6EHX",
                values: {
                    text: get_default()("payload.government.name", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function JoinedAsVendorMember(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActor: "payload.member",
        pathToAvatar: "payload.member.avatarUrl",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "joined as a member of <highlight>{text}</highlight>",
                id: "gf6EHX",
                values: {
                    text: get_default()("payload.vendor.name", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function GovernmentAcceptedGroupRequest(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActorName: "payload.government.name",
        pathToAvatar: "payload.group.logo",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "joined group <highlight>{text}</highlight>",
                id: "RfPGNM",
                values: {
                    text: get_default()("payload.group.name", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function VendorAcceptedGroupRequest(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActorName: "payload.vendor.name",
        pathToAvatar: "payload.group.logo",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "joined group <highlight>{text}</highlight>",
                id: "RfPGNM",
                values: {
                    text: get_default()("payload.group.name", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function GovernmentVerifiedProject(_param) {
    var notification = _param.notification, group = _param.group, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification",
        "group"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        group: group,
        notification: notification,
        pathToActorName: "payload.government.name",
        pathToAvatar: "payload.group.logo",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "{totalCount, plural, =0 {has} =1 {has} other {have}} verified <highlight>{text}</highlight> Project",
                id: "3e/FM8",
                values: {
                    text: get_default()("payload.group.name", notification),
                    totalCount: group ? group.totalCount : 0,
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function GovernmentVerifiedVendorProject(_param) {
    var notification = _param.notification, group = _param.group, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification",
        "group"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        group: group,
        notification: notification,
        pathToActorName: "payload.government.name",
        pathToAvatar: "payload.vendor.logo",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "{totalCount, plural, =0 {has} =1 {has} other {have}} verified <highlight>{text}</highlight> Project",
                id: "3e/FM8",
                values: {
                    text: get_default()("payload.vendor.name", notification),
                    totalCount: group ? group.totalCount : 0,
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function VendorVerifiedProject(_param) {
    var notification = _param.notification, group = _param.group, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification",
        "group"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        group: group,
        notification: notification,
        pathToActorName: "payload.vendor.name",
        pathToAvatar: "payload.vendor.logo",
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "{totalCount, plural, =0 {has} =1 {has} other {have}} verified <highlight>{text}</highlight> Project",
                id: "3e/FM8",
                values: {
                    text: get_default()("payload.group.name", notification),
                    totalCount: group ? group.totalCount : 0,
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function GovernmentAcceptedProductInvitation(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActorName: "payload.government.name",
        pathToAvatar: "payload.product.logo",
        avatarName: get_default()("payload.product.name", notification),
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "accepted your invitation to <highlight>{text}</highlight>",
                id: "dGFLZZ",
                values: {
                    text: get_default()("payload.product.name", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}
function GovernmentDeniedProductInvitation(_param) {
    var notification = _param.notification, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification_Notification, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        notification: notification,
        pathToActorName: "payload.government.name",
        pathToAvatar: "payload.product.logo",
        avatarName: get_default()("payload.product.name", notification),
        children: [
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "denied your invitation to <highlight>{text}</highlight>",
                id: "tO5tup",
                values: {
                    text: get_default()("payload.product.name", notification),
                    highlight: function(text) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNotificationPart, {
                            children: text
                        });
                    }
                }
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./src/components/notifications/index.ts










// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/last.js
var last = __webpack_require__(87923);
var last_default = /*#__PURE__*/__webpack_require__.n(last);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-visibility-sensor@5.1.1_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(56192);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/pick.js
var pick = __webpack_require__(4074);
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);
// EXTERNAL MODULE: ./lib/utils/getGovlaunchBaseUrl.ts
var getGovlaunchBaseUrl = __webpack_require__(44673);
;// CONCATENATED MODULE: ./components/notifications/Notification.tsx








var COMMENT_ON_RESOURCE = "commentOnResource";
var COMMENT_ON_STORY = "commentOnStory";
var COMMENT_ON_PRODUCT = "commentOnProduct";
var COMMENT_ON_QUESTION = "commentOnQuestion";
var COMMENT_ON_RECOMMENDATION_ENDORSEMENT = "commentOnRecommendationEndorsement";
var REPLY_ON_RESOURCE_COMMENT = "replyOnResourceComment";
var REPLY_ON_STORY_COMMENT = "replyOnStoryComment";
var REPLY_ON_PRODUCT_COMMENT = "replyOnProductComment";
var REPLY_ON_QUESTION_COMMENT = "replyOnQuestionComment";
var REPLY_ON_RECOMMENDATION_ENDORSEMENT_COMMENT = "replyOnRecommendationEndorsementComment";
var MENTION_ON_STORY_COMMENT = "mentionOnStoryComment";
var MENTION_ON_RESOURCE_COMMENT = "mentionOnResourceComment";
var MENTION_ON_PRODUCT_COMMENT = "mentionOnProductComment";
var MENTION_ON_QUESTION_COMMENT = "mentionOnQuestionComment";
var MENTION_ON_RECOMMENDATION_ENDORSEMENT_COMMENT = "mentionOnRecommendationEndorsementComment";
var UPVOTE_ON_RESOURCE_COMMENT = "upvoteOnResourceComment";
var UPVOTE_ON_STORY_COMMENT = "upvoteOnStoryComment";
var UPVOTE_ON_PRODUCT_COMMENT = "upvoteOnProductComment";
var UPVOTE_ON_QUESTION_COMMENT = "upvoteOnQuestionComment";
var UPVOTE_ON_RECOMMENDATION_ENDORSEMENT_COMMENT = "upvoteOnRecommendationEndorsementComment";
var UPVOTE_ON_RESOURCE = "upvoteOnResource";
var UPVOTE_ON_STORY = "upvoteOnStory";
var UPVOTE_ON_POST = "upvoteOnPost";
var UPVOTE_ON_PRODUCT = "upvoteOnProduct";
var UPVOTE_ON_RECOMMENDATION_ENDORSEMENT = "upvoteOnRecommendationEndorsement";
var UPVOTE_ON_PRODUCT_RECOMMENDATION = "upvoteOnProductRecommendation";
var PRODUCT_RECOMMENDATION = "productRecommendation";
var STORY_WAS_EDITED = "storyWasEdited";
var ADDED_AS_COLLABORATOR = "addedAsCollaborator";
var ADDED_AS_AUTHOR = "addedAsAuthor";
var ACCEPTED_ACCESS_REQUEST = "acceptedAccessRequest";
var DECLINED_ACCESS_REQUEST = "declinedAccessRequest";
var VERIFIED_ACCOUNT = "verifiedAccount";
var UNVERIFIED_ACCOUNT = "unverifiedAccount";
var PRODUCT_APPROVED = "productWasApproved";
var WELCOME_TO_GROUP = "welcomeToGroup";
var COMMENT_ON_PROJECT = "commentOnProject";
var REPLY_ON_PROJECT_COMMENT = "replyOnProjectComment";
var UPVOTE_ON_PROJECT_COMMENT = "upvoteOnProjectComment";
var JOINED_AS_COLLABORATOR_ON_STORY = "joinedAsCollaboratorOnStory";
var JOINED_AS_COLLABORATOR_ON_PROJECT = "joinedAsCollaboratorOnProject";
var JOINED_AS_GOVERNMENT_MEMBER = "joinedAsGovernmentMember";
var JOINED_AS_VENDOR_MEMBER = "joinedAsVendorMember";
var GOVERNMENT_ACCEPTED_GROUP_REQUEST = "governmentAcceptedGroupRequest";
var GOVERNMENT_VERIFIED_PROJECT = "governmentVerifiedProject";
var GOVERNMENT_VERIFIED_VENDOR_PROJECT = "governmentVerifiedVendorProject";
var VENDOR_ACCEPTED_GROUP_REQUEST = "vendorAcceptedGroupRequest";
var VENDOR_VERIFIED_PROJECT = "vendorVerifiedProject";
var GOVERNMENT_ACCEPTED_PRODUCT_INVITATION = "governmentAcceptedProductInvitation";
var GOVERNMENT_DENIED_PRODUCT_INVITATION = "governmentDeniedProductInvitation";
function linkToInnovatorShare(notification) {
    return "".concat((0,getGovlaunchBaseUrl/* default */.Z)("innovators"), "/share/").concat(notification.payload.resource.slug);
}
function linkToStory(notification) {
    return "/stories/".concat(notification.payload.story.slug);
}
function linkToPost(notification) {
    return "/posts/".concat(notification.payload.post._id);
}
function linkToProduct(notification) {
    return "/products/".concat(notification.payload.product.slug);
}
function linkToQuestion(notification) {
    return "".concat((0,getGovlaunchBaseUrl/* default */.Z)("innovators"), "/ask/").concat(notification.payload.question.slug);
}
function linkToRecommendationEndorsement(notification) {
    var _payload = notification.payload, question = _payload.question, recommendationEndorsement = _payload.recommendationEndorsement;
    return "".concat((0,getGovlaunchBaseUrl/* default */.Z)("innovators"), "/ask/").concat(question.slug, "/endorsements/").concat(recommendationEndorsement._id);
}
function linkToProductRecommendation(notification) {
    var _payload = notification.payload, question = _payload.question, productRecommendation = _payload.productRecommendation;
    return "".concat((0,getGovlaunchBaseUrl/* default */.Z)("innovators"), "/ask/").concat(question.slug, "/recommendations/").concat(productRecommendation._id);
}
var _obj;
var NotificationMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, COMMENT_ON_RESOURCE, {
    component: ResourceComment,
    url: linkToInnovatorShare
}), (0,_define_property/* default */.Z)(_obj, UPVOTE_ON_RESOURCE_COMMENT, {
    component: ResourceCommentUpvote,
    url: linkToInnovatorShare
}), (0,_define_property/* default */.Z)(_obj, REPLY_ON_RESOURCE_COMMENT, {
    component: ResourceCommentReply,
    url: linkToInnovatorShare
}), (0,_define_property/* default */.Z)(_obj, MENTION_ON_RESOURCE_COMMENT, {
    component: ResourceCommentMention,
    url: linkToInnovatorShare
}), (0,_define_property/* default */.Z)(_obj, UPVOTE_ON_RESOURCE, {
    component: ResourceUpvote,
    url: linkToInnovatorShare
}), (0,_define_property/* default */.Z)(_obj, MENTION_ON_STORY_COMMENT, {
    component: StoryCommentMention,
    url: linkToStory
}), (0,_define_property/* default */.Z)(_obj, COMMENT_ON_STORY, {
    component: StoryComment,
    url: linkToStory
}), (0,_define_property/* default */.Z)(_obj, COMMENT_ON_PRODUCT, {
    component: ProductComment,
    url: linkToProduct
}), (0,_define_property/* default */.Z)(_obj, REPLY_ON_STORY_COMMENT, {
    component: StoryCommentReply,
    url: linkToStory
}), (0,_define_property/* default */.Z)(_obj, REPLY_ON_PRODUCT_COMMENT, {
    component: ProductCommentReply,
    url: linkToProduct
}), (0,_define_property/* default */.Z)(_obj, MENTION_ON_PRODUCT_COMMENT, {
    component: ProductCommentMention,
    url: linkToProduct
}), (0,_define_property/* default */.Z)(_obj, UPVOTE_ON_STORY_COMMENT, {
    component: StoryCommentUpvote,
    url: linkToStory
}), (0,_define_property/* default */.Z)(_obj, UPVOTE_ON_PRODUCT_COMMENT, {
    component: ProductCommentUpvote,
    url: linkToProduct
}), (0,_define_property/* default */.Z)(_obj, UPVOTE_ON_STORY, {
    component: StoryUpvote,
    url: linkToStory
}), (0,_define_property/* default */.Z)(_obj, UPVOTE_ON_PRODUCT, {
    component: ProductUpvote,
    url: linkToProduct
}), (0,_define_property/* default */.Z)(_obj, UPVOTE_ON_POST, {
    component: PostUpvote,
    url: linkToPost
}), (0,_define_property/* default */.Z)(_obj, COMMENT_ON_QUESTION, {
    component: QuestionComment,
    url: linkToQuestion
}), (0,_define_property/* default */.Z)(_obj, REPLY_ON_QUESTION_COMMENT, {
    component: QuestionCommentReply,
    url: linkToQuestion
}), (0,_define_property/* default */.Z)(_obj, MENTION_ON_QUESTION_COMMENT, {
    component: QuestionCommentMention,
    url: linkToQuestion
}), (0,_define_property/* default */.Z)(_obj, UPVOTE_ON_QUESTION_COMMENT, {
    component: QuestionCommentUpvote,
    url: linkToQuestion
}), (0,_define_property/* default */.Z)(_obj, COMMENT_ON_RECOMMENDATION_ENDORSEMENT, {
    component: RecommendationEndorsementComment,
    url: linkToRecommendationEndorsement
}), (0,_define_property/* default */.Z)(_obj, REPLY_ON_RECOMMENDATION_ENDORSEMENT_COMMENT, {
    component: RecommendationEndorsementCommentReply,
    url: linkToRecommendationEndorsement
}), (0,_define_property/* default */.Z)(_obj, MENTION_ON_RECOMMENDATION_ENDORSEMENT_COMMENT, {
    component: RecommendationEndorsementCommentMention,
    url: linkToRecommendationEndorsement
}), (0,_define_property/* default */.Z)(_obj, UPVOTE_ON_RECOMMENDATION_ENDORSEMENT_COMMENT, {
    component: RecommendationEndorsementCommentUpvote,
    url: linkToRecommendationEndorsement
}), (0,_define_property/* default */.Z)(_obj, UPVOTE_ON_RECOMMENDATION_ENDORSEMENT, {
    component: RecommendationEndorsementUpvote,
    url: linkToRecommendationEndorsement
}), (0,_define_property/* default */.Z)(_obj, UPVOTE_ON_PRODUCT_RECOMMENDATION, {
    component: ProductRecommendationUpvote,
    url: linkToProductRecommendation
}), (0,_define_property/* default */.Z)(_obj, PRODUCT_RECOMMENDATION, {
    component: ProductRecommendation,
    url: linkToProductRecommendation
}), (0,_define_property/* default */.Z)(_obj, STORY_WAS_EDITED, {
    component: StoryWasEdited,
    url: linkToStory
}), (0,_define_property/* default */.Z)(_obj, ADDED_AS_COLLABORATOR, {
    component: AddedAsCollaborator,
    url: linkToStory
}), (0,_define_property/* default */.Z)(_obj, ADDED_AS_AUTHOR, {
    component: AddedAsAuthor,
    url: linkToStory
}), (0,_define_property/* default */.Z)(_obj, ACCEPTED_ACCESS_REQUEST, {
    component: AccessRequestAccepted,
    url: function(param) {
        var payload = param.payload;
        if (payload.government) {
            return "".concat((0,getGovlaunchBaseUrl/* default */.Z)("portal"), "/governments/").concat(payload.government.slug);
        }
        if (payload.group) {
            return "".concat((0,getGovlaunchBaseUrl/* default */.Z)("portal"), "/groups/").concat(payload.group.slug);
        }
        return "".concat((0,getGovlaunchBaseUrl/* default */.Z)("portal"), "/vendors/").concat(payload.company.slug);
    }
}), (0,_define_property/* default */.Z)(_obj, WELCOME_TO_GROUP, {
    component: WelcomeToGroup,
    url: function(param) {
        var payload = param.payload;
        return "".concat((0,getGovlaunchBaseUrl/* default */.Z)("portal"), "/groups/").concat(payload.slug);
    }
}), (0,_define_property/* default */.Z)(_obj, DECLINED_ACCESS_REQUEST, {
    component: AccessRequestDeclined,
    url: function(param) {
        var payload = param.payload;
        return "".concat((0,getGovlaunchBaseUrl/* default */.Z)("portal"), "/governments/").concat(payload.government.slug);
    }
}), (0,_define_property/* default */.Z)(_obj, VERIFIED_ACCOUNT, {
    component: AccountVerified,
    url: function() {
        return (0,getGovlaunchBaseUrl/* default */.Z)("portal");
    }
}), (0,_define_property/* default */.Z)(_obj, UNVERIFIED_ACCOUNT, {
    component: AccountUnverified,
    url: function() {
        return (0,getGovlaunchBaseUrl/* default */.Z)("portal");
    }
}), (0,_define_property/* default */.Z)(_obj, PRODUCT_APPROVED, {
    component: ProductApproved,
    url: function(param) {
        var payload = param.payload;
        return "/products/".concat(payload.product.slug);
    }
}), (0,_define_property/* default */.Z)(_obj, COMMENT_ON_PROJECT, {
    component: ProjectComment,
    url: projectUrl
}), (0,_define_property/* default */.Z)(_obj, REPLY_ON_PROJECT_COMMENT, {
    component: ProjectCommentReply,
    url: projectUrl
}), (0,_define_property/* default */.Z)(_obj, UPVOTE_ON_PROJECT_COMMENT, {
    component: ProjectCommentUpvote,
    url: projectUrl
}), (0,_define_property/* default */.Z)(_obj, JOINED_AS_COLLABORATOR_ON_PROJECT, {
    component: JoinedAsCollaboratorOnProject,
    url: function(param) {
        var payload = param.payload;
        if (payload.project.government) {
            return "/governments/".concat(payload.project.government.slug, "/projects/").concat(payload.project.slug);
        }
        if (payload.project.group) {
            return "/groups/".concat(payload.project.group.slug, "/projects/").concat(payload.project.slug);
        }
        throw new Error("Unable to generate Project URL");
    }
}), (0,_define_property/* default */.Z)(_obj, JOINED_AS_COLLABORATOR_ON_STORY, {
    component: JoinedAsCollaboratorOnStory,
    url: function(param) {
        var payload = param.payload;
        return "/stories/".concat(payload.story.slug);
    }
}), (0,_define_property/* default */.Z)(_obj, JOINED_AS_GOVERNMENT_MEMBER, {
    component: JoinedAsGovernmentMember,
    url: function(param) {
        var payload = param.payload;
        return "/governments/".concat(payload.government.slug);
    }
}), (0,_define_property/* default */.Z)(_obj, JOINED_AS_VENDOR_MEMBER, {
    component: JoinedAsVendorMember,
    url: function(param) {
        var payload = param.payload;
        return "/vendors/".concat(payload.vendor.slug);
    }
}), (0,_define_property/* default */.Z)(_obj, GOVERNMENT_ACCEPTED_GROUP_REQUEST, {
    component: GovernmentAcceptedGroupRequest,
    url: function(param) {
        var payload = param.payload;
        return "/groups/".concat(payload.group.slug);
    }
}), (0,_define_property/* default */.Z)(_obj, GOVERNMENT_VERIFIED_PROJECT, {
    component: GovernmentVerifiedProject,
    url: projectUrl
}), (0,_define_property/* default */.Z)(_obj, GOVERNMENT_VERIFIED_VENDOR_PROJECT, {
    component: GovernmentVerifiedVendorProject,
    url: projectUrl
}), (0,_define_property/* default */.Z)(_obj, VENDOR_ACCEPTED_GROUP_REQUEST, {
    component: VendorAcceptedGroupRequest,
    url: function(param) {
        var payload = param.payload;
        return "/groups/".concat(payload.group.slug);
    }
}), (0,_define_property/* default */.Z)(_obj, VENDOR_VERIFIED_PROJECT, {
    component: VendorVerifiedProject,
    url: projectUrl
}), (0,_define_property/* default */.Z)(_obj, GOVERNMENT_ACCEPTED_PRODUCT_INVITATION, {
    component: GovernmentAcceptedProductInvitation,
    url: productUrl
}), (0,_define_property/* default */.Z)(_obj, GOVERNMENT_DENIED_PRODUCT_INVITATION, {
    component: GovernmentDeniedProductInvitation,
    url: productUrl
}), _obj);
function notifications_Notification_Notification(_param) {
    var notification = _param.notification, group = _param.group, onRead = _param.onRead, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "notification",
        "group",
        "onRead"
    ]);
    var ref = pick_default()([
        "component",
        "url"
    ], NotificationMap[notification.type]), Component = ref.component, url = ref.url;
    if (!Component) {
        return null;
    }
    if (typeof url === "function") {
        var notificationUrl = url(notification);
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Component, (0,src_object_spread/* default */.Z)({
            notification: notification,
            group: group,
            tag: "a",
            href: notificationUrl,
            onClick: function(event) {
                event.preventDefault();
                onRead({
                    notificationUrl: notificationUrl
                });
            }
        }, props));
    }
    return null;
};
function productUrl(param) {
    var payload = param.payload;
    return "/products/".concat(payload.product.slug);
}
function projectUrl(param) {
    var payload = param.payload;
    return "/projects/".concat(payload.project.slug);
}

;// CONCATENATED MODULE: ./components/notifications/DesktopNotifications.tsx












var DesktopNotifications = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(DesktopNotifications, Component);
    var _super = (0,_create_super/* default */.Z)(DesktopNotifications);
    function DesktopNotifications() {
        (0,_class_call_check/* default */.Z)(this, DesktopNotifications);
        var _this;
        _this = _super.apply(this, arguments);
        _this.overflow = null;
        return _this;
    }
    var _proto = DesktopNotifications.prototype;
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, token = _props.token, channels = _props.channels;
        if (!token) {
            return null;
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationPopover, {
            token: token,
            channels: channels,
            children: function(param) {
                var notifications = param.notifications, loading = param.loading, groups = param.groups, unreadCount = param.unreadCount, close = param.close, loadMore = param.loadMore, hasMore = param.hasMore, read = param.read, readAll = param.readAll;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationSection, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    display: "flex",
                                    justifyContent: "space-between"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Notifications",
                                            id: "NAidKb"
                                        })
                                    }),
                                    unreadCount > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        href: "#",
                                        css: {
                                            color: palette/* darkGray */.O5,
                                            textDecoration: "underline"
                                        },
                                        onClick: function(event) {
                                            event.preventDefault();
                                            readAll();
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Mark all as read",
                                            id: "/af+jQ"
                                        })
                                    })
                                ]
                            })
                        }),
                        notifications.length === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                padding: 15,
                                display: "flex",
                                justifyContent: "center",
                                background: "#fff",
                                borderBottomRightRadius: 4,
                                borderBottomLeftRadius: 4
                            },
                            children: loading ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* LoadingIndicator */.TF, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                css: {
                                    margin: 0,
                                    fontSize: 14,
                                    color: palette/* darkGray */.O5
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "No new notifications",
                                    id: "layEo+"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationsOverflow, {
                            innerRef: function(node) {
                                _this.overflow = node;
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationsWrapper, {
                                children: notifications.map(function(notification, index) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(notifications_Notification_Notification, {
                                                notification: notification,
                                                group: groups[notification.group],
                                                onRead: function(param) {
                                                    var notificationUrl = param.notificationUrl;
                                                    read(notification).then(function() {
                                                        close();
                                                        window.location.href = notificationUrl;
                                                    });
                                                }
                                            }),
                                            index === notifications.length - 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((visibility_sensor_default()), {
                                                delayedCall: true,
                                                intervalDelay: 1200,
                                                partialVisibility: false,
                                                containment: _this.overflow || undefined,
                                                scrollCheck: true,
                                                onChange: function(isVisible) {
                                                    if (isVisible && hasMore && !loading) {
                                                        var lastNotification = last_default()(notifications);
                                                        if (lastNotification) {
                                                            loadMore(lastNotification._id);
                                                        }
                                                    }
                                                }
                                            }),
                                            shouldDisplaySpinner(index, notifications.length) && hasMore && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                css: {
                                                    backgroundColor: palette/* white */.ix,
                                                    display: "flex",
                                                    height: 50
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* LoadingIndicator */.TF, {
                                                    margin: "auto"
                                                })
                                            })
                                        ]
                                    }, notification._id);
                                })
                            })
                        })
                    ]
                });
            }
        });
    };
    return DesktopNotifications;
}(react.Component);

function shouldDisplaySpinner(index, length) {
    var size = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    var currentPage = Math.ceil(length / size);
    var lastItemInCurrentPage = currentPage * 10 - 1;
    return index === lastItemInCurrentPage;
}

;// CONCATENATED MODULE: ./components/notifications/MobileNotifications.tsx












function MobileNotifications(param) {
    var token = param.token, channels = param.channels;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isOpen = ref[0], toggle = ref[1];
    if (!token) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationStream, {
        token: token,
        channels: channels,
        children: function(param) {
            var notifications = param.notifications, unreadCount = param.unreadCount, loadMore = param.loadMore, read = param.read, groups = param.groups, loading = param.loading, hasMore = param.hasMore;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationBell, {
                        onClick: toggle,
                        children: unreadCount > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationCount, {
                            children: unreadCount
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(mobile/* MobileScreen */.vp, {
                        isOpen: isOpen,
                        children: function() {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(mobile/* MobileScreenHeader */.uD, {
                                        onRequestClose: toggle,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Notifications",
                                            id: "NAidKb"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(mobile/* MobileScreenBody */.Ly, {
                                        style: {
                                            padding: 0
                                        },
                                        children: notifications.map(function(notification, index) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(notifications_Notification_Notification, {
                                                        notification: notification,
                                                        group: groups[notification.group],
                                                        onRead: function(param) {
                                                            var notificationUrl = param.notificationUrl;
                                                            read(notification).then(function() {
                                                                close();
                                                                window.location.href = notificationUrl;
                                                            });
                                                        }
                                                    }),
                                                    index === notifications.length - 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((visibility_sensor_default()), {
                                                        delayedCall: true,
                                                        intervalDelay: 1200,
                                                        partialVisibility: false,
                                                        scrollCheck: true,
                                                        onChange: function(isVisible) {
                                                            if (isVisible && hasMore && !loading) {
                                                                var lastNotification = last_default()(notifications);
                                                                if (lastNotification) {
                                                                    loadMore(lastNotification._id);
                                                                }
                                                            }
                                                        }
                                                    }),
                                                    MobileNotifications_shouldDisplaySpinner(index, notifications.length) && hasMore && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                        css: {
                                                            backgroundColor: palette/* white */.ix,
                                                            display: "flex",
                                                            height: 50
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* LoadingIndicator */.TF, {
                                                            margin: "auto"
                                                        })
                                                    })
                                                ]
                                            }, notification._id);
                                        })
                                    })
                                ]
                            });
                        }
                    })
                ]
            });
        }
    });
};
function MobileNotifications_shouldDisplaySpinner(index, length) {
    var size = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    var currentPage = Math.ceil(length / size);
    var lastItemInCurrentPage = currentPage * 10 - 1;
    return index === lastItemInCurrentPage;
}

;// CONCATENATED MODULE: ./components/notifications/UserNotifications.tsx







function UserNotifications() {
    var isMobile = (0,useIsMobile/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Auth/* default */.ZP, {
        children: function(param) {
            var user = param.user, token = param.token;
            if (!user) {
                return null;
            }
            var channels = [
                user._id,
                get_default()("government._id", user),
                get_default()("company._id", user)
            ].filter(Boolean);
            if (isMobile) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileNotifications, {
                    token: token,
                    channels: channels
                });
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNotifications, {
                token: token,
                channels: channels
            });
        }
    });
};

;// CONCATENATED MODULE: ./components/icons/UserIcons.tsx



var Icon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "e13y6zc30"
})("display:inline-flex;width:32px;min-width:32px;");
/* harmony default export */ var UserIcons = (Icon);
function UserIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        width: "22",
        height: "20",
        viewBox: "0 0 22 20",
        fill: "none",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M20.9 13.9C20.5 11.5 18.6 9.7 16.3 9.1C16.8 8.1 17 7 17 6C17 2.7 14.3 0 11 0C7.7 0 5 2.7 5 6C5 7 5.2 8.1 5.7 9.2C3.4 9.7 1.6 11.6 1.1 14L0 20H22L20.9 13.9ZM11 2C13.2 2 15 3.8 15 6.1C15 9 12.6 12.2 11 12.2C9.3 12.2 6.9 9 6.9 6.1C6.9 3.8 8.8 2 11 2ZM2.4 18L3.1 14.3C3.4 12.5 4.9 11.2 6.7 11.1C7.8 12.8 9.3 14.1 11.1 14.1C12.9 14.1 14.4 12.8 15.5 11.1C17.3 11.3 18.7 12.6 19.1 14.3L19.8 18H2.4Z",
            fill: "#ADB6C3"
        })
    });
}
function CogIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M21 13V11H17.91C17.766 10.1121 17.4243 9.26797 16.91 8.53L19.09 6.35L17.66 4.93L15.47 7.11C14.732 6.59574 13.8879 6.25398 13 6.11V3H11V6.09C10.1121 6.23398 9.26797 6.57574 8.53 7.09L6.34 4.93L4.93 6.34L7.11 8.53C6.59574 9.26797 6.25398 10.1121 6.11 11H3V13H6.09C6.23398 13.8879 6.57574 14.732 7.09 15.47L4.93 17.66L6.34 19.07L8.52 16.89C9.25797 17.4043 10.1021 17.746 10.99 17.89V21H12.99V17.91C13.8779 17.766 14.722 17.4243 15.46 16.91L17.64 19.09L19.05 17.68L16.87 15.5C17.3843 14.762 17.726 13.9179 17.87 13.03H21V13ZM7.81 12C7.81 11.1713 8.05574 10.3612 8.51614 9.67216C8.97654 8.98312 9.63093 8.44608 10.3966 8.12894C11.1622 7.81181 12.0046 7.72884 12.8174 7.89051C13.6302 8.05218 14.3768 8.45124 14.9628 9.03722C15.5488 9.6232 15.9478 10.3698 16.1095 11.1826C16.2712 11.9954 16.1882 12.8378 15.8711 13.6034C15.5539 14.3691 15.0169 15.0235 14.3278 15.4839C13.6388 15.9443 12.8287 16.19 12 16.19C10.8896 16.1874 9.82535 15.7451 9.04014 14.9599C8.25493 14.1747 7.81264 13.1104 7.81 12Z",
                fill: "#ADB6C3"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
                fill: "#ADB6C3"
            })
        ]
    });
}
function LogOutIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M10 8.70992L11.8 10.5099L12.97 10.9999H3V12.9999H12.95L11.76 13.5299L9.99 15.2899L11.34 16.5699L15.91 11.9999L11.33 7.41992L10 8.70992Z",
                fill: "#ADB6C3"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M9 3H7V5V7H9V5H18V19H9V17H7V19V21H9H20V3H9Z",
                fill: "#ADB6C3"
            })
        ]
    });
}
function ReferralsIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M17.6569 7.75796L16.2427 6.34375L6.34318 16.2432L7.75739 17.6575L17.6569 7.75796Z",
                fill: "#ADB6C3"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M16.24 14.8299L14.12 12.7099L15.54 11.2899L16.24 11.9999L20.48 7.75994L16.24 3.51994L12 7.75994L12.71 8.45994L11.29 9.87994L9.17004 7.75994L16.24 0.689941L23.31 7.75994L16.24 14.8299Z",
                fill: "#ADB6C3"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M7.75994 23.3099L0.689941 16.2399L7.75994 9.16992L9.87994 11.2899L8.45994 12.7099L7.75994 11.9999L3.51994 16.2399L7.75994 20.4799L11.9999 16.2399L11.2899 15.5399L12.7099 14.1199L14.8299 16.2399L7.75994 23.3099Z",
                fill: "#ADB6C3"
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/TwitterShareButton.js
var TwitterShareButton = __webpack_require__(5000);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/TwitterIcon.js
var TwitterIcon = __webpack_require__(22770);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/FacebookShareButton.js
var FacebookShareButton = __webpack_require__(18648);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/FacebookIcon.js
var FacebookIcon = __webpack_require__(74239);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/LinkedinShareButton.js
var LinkedinShareButton = __webpack_require__(51299);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/LinkedinIcon.js
var LinkedinIcon = __webpack_require__(80022);
;// CONCATENATED MODULE: ./components/navbar/Referrals.tsx






function Referrals(param) {
    var referralUrl = param.referralUrl, isOpen = param.isOpen, onRequestClose = param.onRequestClose;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Modal */.u_, {
        isOpen: isOpen,
        ariaHideApp: false,
        onRequestClose: onRequestClose,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                width: 370,
                padding: 20
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                            css: {
                                fontWeight: "bold",
                                margin: 0
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Referrals",
                                id: "CrJOJJ"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* ModalClose */.A3, {
                            onClick: onRequestClose,
                            style: {
                                top: 0,
                                right: 0,
                                marginLeft: "auto",
                                position: "relative",
                                cursor: "pointer"
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h4", {
                    css: {
                        fontWeight: 400,
                        margin: 0,
                        fontSize: 16,
                        marginTop: 8,
                        marginBottom: 8
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Share your link",
                        id: "iHV7p1"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                    css: {
                        margin: 0,
                        marginTop: 8,
                        marginBottom: 8,
                        color: palette/* sealBlue */.N9
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Copy your personal referral link and share it with your colleagues.",
                        id: "4tt8B7"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                    css: {
                        textTransform: "uppercase",
                        fontSize: 12,
                        color: palette/* darkGray */.O5
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Referral link",
                        id: "zUezD5"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        marginTop: 12,
                        marginBottom: 12,
                        padding: 12,
                        width: "100%",
                        border: "solid 1px ".concat(palette/* lightSealBlue */.oz),
                        borderRadius: 4,
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap"
                    },
                    onClick: function(event) {
                        event.preventDefault();
                        if (window && window.getSelection()) {
                            window.getSelection().selectAllChildren(event.currentTarget);
                        }
                    },
                    children: referralUrl
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        gridTemplateColumns: "repeat(3, 48px)"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TwitterShareButton/* default */.Z, {
                            url: referralUrl,
                            title: intl.formatMessage({
                                defaultMessage: "Join to search, compare and review technology solutions using my link",
                                id: "cPZZLM"
                            }),
                            css: {
                                cursor: "pointer",
                                outline: 0
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TwitterIcon/* default */.Z, {
                                round: true,
                                size: 42
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FacebookShareButton/* default */.Z, {
                            url: referralUrl,
                            css: {
                                cursor: "pointer",
                                outline: 0
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FacebookIcon/* default */.Z, {
                                round: true,
                                size: 42
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkedinShareButton/* default */.Z, {
                            url: referralUrl,
                            css: {
                                cursor: "pointer",
                                outline: 0
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkedinIcon/* default */.Z, {
                                round: true,
                                size: 42
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/navbar/UserProfileDropdown.tsx













function UserProfileDropdown(param) {
    var user = param.user;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isReferralsOpen = ref[0], toggleReferralsOpen = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            isReferralsOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Referrals, {
                isOpen: isReferralsOpen,
                onRequestClose: function() {
                    return toggleReferralsOpen();
                },
                referralUrl: "".concat((0,getGovlaunchBaseUrl/* default */.Z)("portal"), "?referral=").concat(user._id)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Popover */.J2, {
                placement: "bottom-end",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PopoverTrigger */.xo, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            href: "#",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                name: user.fullName,
                                src: user.avatar,
                                size: "sm"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* PopoverContent */.yk, {
                        arrowShadowColor: "#3F4A5A",
                        css: {
                            position: "absolute"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PopoverArrow */.QH, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                bg: "gray.900",
                                borderRadius: "md",
                                position: "relative",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                        bg: "gray.600",
                                        borderTopLeftRadius: "md",
                                        borderTopRightRadius: "md",
                                        p: 3,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: {
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                margin: 0,
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                                    src: user.avatar,
                                                    name: user.fullName,
                                                    size: "sm"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                    fontWeight: "bold",
                                                    color: "white",
                                                    ml: 2,
                                                    fontSize: "lg",
                                                    isTruncated: true,
                                                    children: user.fullName
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                                        css: {
                                            listStyle: "none",
                                            margin: 0,
                                            padding: 12,
                                            borderBottomLeftRadius: 4,
                                            borderBottomRightRadius: 4
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Item, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                    passHref: true,
                                                    href: "/[userSlug]/[[...tab]]",
                                                    as: "/@".concat(user.slug),
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                                        css: {
                                                            display: "flex",
                                                            alignItems: "center"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserIcons, {
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserIcon, {})
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "My Profile",
                                                                id: "YzZa8+"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            user.__typename === "GovernmentUser" && user.government && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Item, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                    href: "/governments/[governmentSlug]/[[...content]]",
                                                    as: "/governments/".concat(user.government.slug),
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                                        css: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            overflow: "hidden"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserIcons, {
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                                                    size: "xs",
                                                                    src: user.government.logo,
                                                                    name: user.government.name
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                                fontSize: "md",
                                                                isTruncated: true,
                                                                children: user.government.name
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            user.__typename === "VendorUser" && user.company && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Item, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                    href: "/vendors/[vendorSlug]",
                                                    as: "/vendors/".concat(user.company.slug),
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                                        css: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            overflow: "hidden"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserIcons, {
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                                                    size: "xs",
                                                                    src: user.company.logo,
                                                                    name: user.company.name
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                                fontSize: "md",
                                                                isTruncated: true,
                                                                children: user.company.name
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            user.groups.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider, {}),
                                                    user.groups.map(function(group) {
                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Item, {
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                                passHref: true,
                                                                href: "/groups/[groupSlug]",
                                                                as: "/groups/".concat(group.slug),
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                                                    css: {
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        overflow: "hidden"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserIcons, {
                                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                                                                size: "xs",
                                                                                src: group.logo,
                                                                                name: group.name
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                                            fontSize: "md",
                                                                            isTruncated: true,
                                                                            children: group.name
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }, group._id);
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Item, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                    passHref: true,
                                                    href: "/@".concat(user.slug, "/settings"),
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                                        css: {
                                                            display: "flex",
                                                            alignItems: "center"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserIcons, {
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CogIcon, {})
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "Settings",
                                                                id: "D3idYv"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Item, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                                    href: "#",
                                                    onClick: function() {
                                                        toggleReferralsOpen();
                                                    },
                                                    css: {
                                                        display: "flex",
                                                        alignItems: "center"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserIcons, {
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReferralsIcon, {})
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                            defaultMessage: "Referrals",
                                                            id: "CrJOJJ"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Item, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Auth/* default */.ZP, {
                                                    children: function(param) {
                                                        var logout = param.logout;
                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                                            href: "#",
                                                            onClick: function(event) {
                                                                event.preventDefault();
                                                                logout();
                                                            },
                                                            css: {
                                                                display: "flex",
                                                                alignItems: "center"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserIcons, {
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogOutIcon, {})
                                                                }),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                    defaultMessage: "Log Out",
                                                                    id: "H0JBH6"
                                                                })
                                                            ]
                                                        });
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
function Divider() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        height: "1px",
        width: "100%",
        bg: "gray.200"
    });
}
function Item(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        fontSize: "md",
        px: 1,
        py: 3,
        color: "gray.100",
        display: "flex",
        alignItems: "center"
    }, props), {
        fontWeight: "semibold"
    }));
}

;// CONCATENATED MODULE: ./src/components/navbar/icons.tsx




function ActivityIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M19 24H21L17.59 16L15.98 16.91L19 24Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M3 24H5L8.07 16.72L6.38 16L3 24Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M16.8901 22.0001H7.11008L6.11008 14.1101C5.97014 13.0078 5.97014 11.8923 6.11008 10.7901C6.54234 7.5519 8.02477 4.54487 10.3301 2.23009L12.0001 0.590088L13.6501 2.24009C15.9554 4.55487 17.4378 7.5619 17.8701 10.8001C18.01 11.9023 18.01 13.0178 17.8701 14.1201L16.8901 22.0001ZM8.69008 20.0001H15.3201L16.0601 13.8701C16.1773 12.9371 16.1773 11.9931 16.0601 11.0601C15.6151 8.1797 14.267 5.515 12.2101 3.45009L12.0001 3.21009L11.7601 3.45009C9.70318 5.515 8.35508 8.1797 7.91008 11.0601C7.79285 11.9931 7.79285 12.9371 7.91008 13.8701L8.69008 20.0001Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M11 24H13L13 16H11V24Z",
                fill: "currentColor"
            })
        ]
    });
}
function ProjectsIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M16 10H13V7H11V10H8V12H11V15H13V12H16V10Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M15 22H9V24H15V22Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M14.6 21H9.40004L7.64004 17.69C6.51998 16.9706 5.59931 15.9806 4.9631 14.8113C4.32689 13.642 3.99567 12.3312 4.00004 11C4.00004 8.87827 4.8429 6.84344 6.34319 5.34315C7.84348 3.84285 9.87831 3 12 3C14.1218 3 16.1566 3.84285 17.6569 5.34315C19.1572 6.84344 20 8.87827 20 11C20.0044 12.3312 19.6732 13.642 19.037 14.8113C18.4008 15.9806 17.4801 16.9706 16.36 17.69L14.6 21ZM10.6 19H13.4L14.85 16.27L15.09 16.13C15.9758 15.5979 16.7091 14.846 17.2189 13.9472C17.7287 13.0485 17.9978 12.0333 18 11C18 9.4087 17.3679 7.88258 16.2427 6.75736C15.1175 5.63214 13.5913 5 12 5C10.4087 5 8.88262 5.63214 7.7574 6.75736C6.63218 7.88258 6.00004 9.4087 6.00004 11C6.00403 12.0316 6.27392 13.0447 6.78366 13.9416C7.2934 14.8384 8.02576 15.5887 8.91004 16.12L9.15004 16.26L10.6 19Z",
                fill: "#ADB6C3"
            })
        ]
    });
}
function CollectionsIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.30769 2C3.67521 2 3.07368 2.2244 2.64904 2.64904C2.2244 3.07368 2 3.67521 2 4.30769V7.38462V10.4615V19.6923C2 20.3248 2.2244 20.9263 2.64904 21.351C3.07368 21.7756 3.67521 22 4.30769 22H7H19.6923H20C21.1046 22 22 21.1046 22 20V19.6923V11.2308V10.4615V10V8.92308V7.38462C22 6.75214 21.7756 6.1506 21.351 5.72596C20.9263 5.30132 20.3248 5.07692 19.6923 5.07692H11.2308V4.30769C11.2308 3.67521 11.0064 3.07368 10.5817 2.64904C10.1571 2.2244 9.55556 2 8.92308 2H4.30769ZM20 8C20.1589 8 20.3134 8.01852 20.4615 8.05352V7.38462C20.4615 7.09402 20.377 6.92752 20.2632 6.8137C20.1494 6.69988 19.9829 6.61538 19.6923 6.61538H11.2308C10.8291 6.61538 10.418 6.46971 10.128 6.17969C9.83798 5.88966 9.69231 5.47863 9.69231 5.07692V4.30769C9.69231 4.01709 9.60781 3.8506 9.49399 3.73678C9.38017 3.62296 9.21368 3.53846 8.92308 3.53846H4.30769C4.01709 3.53846 3.8506 3.62296 3.73678 3.73678C3.62296 3.8506 3.53846 4.01709 3.53846 4.30769V7.38462V10.4615V19.6923C3.53846 19.9829 3.62296 20.1494 3.73678 20.2632C3.8506 20.377 4.01709 20.4615 4.30769 20.4615C4.59829 20.4615 4.76478 20.377 4.87861 20.2632C4.92616 20.2157 4.9686 20.1589 5.00189 20.0878C5.00064 20.0587 5 20.0294 5 20V10C5 8.89543 5.89543 8 7 8H20ZM14.9548 13.4977L13.5 11L12.0452 13.4977L9.22025 14.1094L11.1461 16.2648L10.855 19.1406L13.5 17.975L16.145 19.1406L15.8539 16.2648L17.7798 14.1094L14.9548 13.4977Z",
            fill: "currentColor"
        })
    });
}
function ProductsIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M20 10V20H4V10H20ZM22 8H2V22H22V8Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M20 5H4V7H20V5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M18 2H6V4H18V2Z",
                fill: "currentColor"
            })
        ]
    });
}
function StoriesIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M5 5V23H17L23 17V5H5ZM17 20.17V17H20.17L17 20.17ZM21 15H15V21H7V7H21V15Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M11 10H9V12H11V10Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M18 10H13V12H18V10Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M13 14H9V16H13V14Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M1 1V15.03V17H3H5V15.03H3V3H14V5H16V1H1Z",
                fill: "currentColor"
            })
        ]
    });
}
function SettingsIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M21 13V11H17.91C17.766 10.1121 17.4243 9.26797 16.91 8.53L19.09 6.35L17.66 4.93L15.47 7.11C14.732 6.59574 13.8879 6.25398 13 6.11V3H11V6.09C10.1121 6.23398 9.26797 6.57574 8.53 7.09L6.34 4.93L4.93 6.34L7.11 8.53C6.59574 9.26797 6.25398 10.1121 6.11 11H3V13H6.09C6.23398 13.8879 6.57574 14.732 7.09 15.47L4.93 17.66L6.34 19.07L8.52 16.89C9.25797 17.4043 10.1021 17.746 10.99 17.89V21H12.99V17.91C13.8779 17.766 14.722 17.4243 15.46 16.91L17.64 19.09L19.05 17.68L16.87 15.5C17.3843 14.762 17.726 13.9179 17.87 13.03H21V13ZM7.81 12C7.81 11.1713 8.05574 10.3612 8.51614 9.67216C8.97654 8.98312 9.63093 8.44608 10.3966 8.12894C11.1622 7.81181 12.0046 7.72884 12.8174 7.89051C13.6302 8.05218 14.3768 8.45124 14.9628 9.03722C15.5488 9.6232 15.9478 10.3698 16.1095 11.1826C16.2712 11.9954 16.1882 12.8378 15.8711 13.6034C15.5539 14.3691 15.0169 15.0235 14.3278 15.4839C13.6388 15.9443 12.8287 16.19 12 16.19C10.8896 16.1874 9.82535 15.7451 9.04014 14.9599C8.25493 14.1747 7.81264 13.1104 7.81 12Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
                fill: "currentColor"
            })
        ]
    });
}
function ActionsIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M16 10H13V7H11V10H8V12H11V15H13V12H16V10Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M15 22H9V24H15V22Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M14.6 21H9.40004L7.64004 17.69C6.51998 16.9706 5.59931 15.9806 4.9631 14.8113C4.32689 13.642 3.99567 12.3312 4.00004 11C4.00004 8.87827 4.8429 6.84344 6.34319 5.34315C7.84348 3.84285 9.87831 3 12 3C14.1218 3 16.1566 3.84285 17.6569 5.34315C19.1572 6.84344 20 8.87827 20 11C20.0044 12.3312 19.6732 13.642 19.037 14.8113C18.4008 15.9806 17.4801 16.9706 16.36 17.69L14.6 21ZM10.6 19H13.4L14.85 16.27L15.09 16.13C15.9758 15.5979 16.7091 14.846 17.2189 13.9472C17.7287 13.0485 17.9978 12.0333 18 11C18 9.4087 17.3679 7.88258 16.2427 6.75736C15.1175 5.63214 13.5913 5 12 5C10.4087 5 8.88262 5.63214 7.7574 6.75736C6.63218 7.88258 6.00004 9.4087 6.00004 11C6.00403 12.0316 6.27392 13.0447 6.78366 13.9416C7.2934 14.8384 8.02576 15.5887 8.91004 16.12L9.15004 16.26L10.6 19Z",
                fill: "#ADB6C3"
            })
        ]
    });
}
function MenuIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "16",
        height: "14",
        viewBox: "0 0 16 14",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16 2H0V0H16V2Z",
                fill: "#FAFAF9"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16 8H0V6H16V8Z",
                fill: "#FAFAF9"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16 14H0V12H16V14Z",
                fill: "#FAFAF9"
            })
        ]
    }));
}
function CloseIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.364 2.77817C14.7545 2.38765 14.7545 1.75448 14.364 1.36396C13.9734 0.973437 13.3403 0.973437 12.9497 1.36396L8 6.31371L3.05025 1.36396C2.65973 0.973437 2.02656 0.973437 1.63604 1.36396C1.24552 1.75448 1.24551 2.38765 1.63604 2.77817L6.58579 7.72792L1.63604 12.6777C1.24552 13.0682 1.24552 13.7014 1.63604 14.0919C2.02656 14.4824 2.65973 14.4824 3.05025 14.0919L8 9.14214L12.9497 14.0919C13.3403 14.4824 13.9734 14.4824 14.364 14.0919C14.7545 13.7014 14.7545 13.0682 14.364 12.6777L9.41421 7.72792L14.364 2.77817Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M0 0H16V16H0V0Z",
                        fill: "white"
                    })
                })
            })
        ]
    }));
}
function icons_UserIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "26",
        height: "26",
        viewBox: "0 0 26 26",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M5.35535 22.247C5.79299 19.7058 7.46594 17.5881 9.73888 16.5364",
                stroke: "#FAFAF9",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M16.2612 16.5364C17.0942 16.9246 17.8495 17.454 18.4911 18.0964C19.5993 19.2046 20.3688 20.6383 20.6448 22.247",
                stroke: "#FAFAF9",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z",
                stroke: "#FAFAF9",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M13 17.9411C15.729 17.9411 17.9412 15.4128 17.9412 12.294C17.9412 9.17525 15.729 6.64697 13 6.64697C10.2711 6.64697 8.05884 9.17525 8.05884 12.294C8.05884 15.4128 10.2711 17.9411 13 17.9411Z",
                stroke: "#FAFAF9",
                strokeMiterlimit: "10"
            })
        ]
    });
}
function icons_LogOutIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "23",
        height: "22",
        viewBox: "0 0 23 22",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M1.875 1.2915L10.9832 4.93297C11.6476 5.19824 12.0833 5.84188 12.0833 6.55664V19.2493C12.0833 20.4491 10.9027 21.2927 9.76692 20.9045L2.18358 18.3118C1.47542 18.0699 1 17.4047 1 16.6567V2.74902C1 1.78298 1.784 1 2.75 1H14.4167C15.3827 1 16.1667 1.78298 16.1667 2.74902V16.1582C16.1667 17.1242 15.3827 17.9072 14.4167 17.9072H12.0833",
                stroke: "#FAFAF9",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M9.97917 12.3687C9.97917 12.6557 9.74624 12.8889 9.45833 12.8889C9.17042 12.8889 8.9375 12.6557 8.9375 12.3687C8.9375 12.0816 9.17042 11.8484 9.45833 11.8484C9.74624 11.8484 9.97917 12.0816 9.97917 12.3687Z",
                fill: "black",
                stroke: "#FAFAF9"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M19.375 7.12158L22 9.74512L19.375 12.3687",
                stroke: "#FAFAF9",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M21.7084 9.74512H16.4584",
                stroke: "#FAFAF9",
                strokeMiterlimit: "10"
            })
        ]
    });
}
function icons_ReferralsIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "20",
        height: "19",
        viewBox: "0 0 20 19",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M10.0003 4.65945L12.9897 1.8356C14.1695 0.721466 16.0819 0.721466 17.261 1.8356L18.1152 2.64225C19.2949 3.75639 19.2949 5.56251 18.1152 6.67665L13.4174 11.1132C12.2377 12.2274 10.3252 12.2274 9.14613 11.1132L8.29199 10.3066",
                stroke: "#FAFAF9",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M10.0003 14.3409L7.01082 17.1647C5.8311 18.2783 3.91865 18.2783 2.73953 17.1647L1.88479 16.3581C0.705069 15.244 0.705069 13.4378 1.88479 12.3237L6.58255 7.88712C7.76227 6.77298 9.67471 6.77298 10.8538 7.88712L11.708 8.69377",
                stroke: "#FAFAF9",
                strokeMiterlimit: "10"
            })
        ]
    });
}
function DesktopNavbarLogo() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        width: 155,
        height: 35,
        viewBox: "0 0 911 148",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "#FFF",
            fillRule: "nonzero",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M462.52 126.09V21.05h16.535v105.04z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M462.52 126.09V21.05h16.535v105.04z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M462.52 126.09V21.05h16.535v105.04zM531.811 48.136c16.85 0 31.654 7.087 31.654 27.56v50.393h-16.536V117.9c-5.67 6.457-14.488 10.079-24.567 10.079-12.44 0-26.456-8.346-26.456-25.197 0-17.48 14.015-24.724 26.456-24.724 10.236 0 19.055 3.307 24.567 9.764v-11.34c0-8.818-7.244-14.172-17.795-14.172-8.504 0-15.906 3.15-22.52 9.606l-6.771-11.496c8.818-8.347 19.842-12.284 31.968-12.284zm-2.992 41.26c-9.291 0-16.22 5.355-16.22 13.701 0 8.19 6.929 13.543 16.22 13.543 7.244 0 14.33-2.677 18.11-7.874V97.27c-3.78-5.197-10.866-7.874-18.11-7.874z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M531.811 48.136c16.85 0 31.654 7.087 31.654 27.56v50.393h-16.536V117.9c-5.67 6.457-14.488 10.079-24.567 10.079-12.44 0-26.456-8.346-26.456-25.197 0-17.48 14.015-24.724 26.456-24.724 10.236 0 19.055 3.307 24.567 9.764v-11.34c0-8.818-7.244-14.172-17.795-14.172-8.504 0-15.906 3.15-22.52 9.606l-6.771-11.496c8.818-8.347 19.842-12.284 31.968-12.284zm-2.992 41.26c-9.291 0-16.22 5.355-16.22 13.701 0 8.19 6.929 13.543 16.22 13.543 7.244 0 14.33-2.677 18.11-7.874V97.27c-3.78-5.197-10.866-7.874-18.11-7.874z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M531.811 48.136c16.85 0 31.654 7.087 31.654 27.56v50.393h-16.536V117.9c-5.67 6.457-14.488 10.079-24.567 10.079-12.44 0-26.456-8.346-26.456-25.197 0-17.48 14.015-24.724 26.456-24.724 10.236 0 19.055 3.307 24.567 9.764v-11.34c0-8.818-7.244-14.172-17.795-14.172-8.504 0-15.906 3.15-22.52 9.606l-6.771-11.496c8.818-8.347 19.842-12.284 31.968-12.284zm-2.992 41.26c-9.291 0-16.22 5.355-16.22 13.701 0 8.19 6.929 13.543 16.22 13.543 7.244 0 14.33-2.677 18.11-7.874V97.27c-3.78-5.197-10.866-7.874-18.11-7.874zM636.22 126.09v-10.08c-5.511 6.142-14.96 11.969-26.929 11.969-16.378 0-24.41-8.504-24.41-24.094V50.026h16.536V97.9c0 11.811 5.985 15.433 15.276 15.433 8.346 0 15.59-4.724 19.527-9.92V50.025h16.536v76.063H636.22z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M636.22 126.09v-10.08c-5.511 6.142-14.96 11.969-26.929 11.969-16.378 0-24.41-8.504-24.41-24.094V50.026h16.536V97.9c0 11.811 5.985 15.433 15.276 15.433 8.346 0 15.59-4.724 19.527-9.92V50.025h16.536v76.063H636.22z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M636.22 126.09v-10.08c-5.511 6.142-14.96 11.969-26.929 11.969-16.378 0-24.41-8.504-24.41-24.094V50.026h16.536V97.9c0 11.811 5.985 15.433 15.276 15.433 8.346 0 15.59-4.724 19.527-9.92V50.025h16.536v76.063H636.22z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M725.512 126.09V78.53c0-11.81-5.984-15.748-15.276-15.748-8.504 0-15.748 5.04-19.527 10.236v53.071h-16.536V50.026h16.536V60.42c5.039-5.984 14.803-12.284 26.771-12.284 16.378 0 24.567 8.82 24.567 24.41v53.543h-16.535z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M725.512 126.09V78.53c0-11.81-5.984-15.748-15.276-15.748-8.504 0-15.748 5.04-19.527 10.236v53.071h-16.536V50.026h16.536V60.42c5.039-5.984 14.803-12.284 26.771-12.284 16.378 0 24.567 8.82 24.567 24.41v53.543h-16.535z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M725.512 126.09V78.53c0-11.81-5.984-15.748-15.276-15.748-8.504 0-15.748 5.04-19.527 10.236v53.071h-16.536V50.026h16.536V60.42c5.039-5.984 14.803-12.284 26.771-12.284 16.378 0 24.567 8.82 24.567 24.41v53.543h-16.535z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M758.74 87.979c0-22.992 16.22-39.843 39.37-39.843 14.803 0 23.78 6.3 29.134 13.544l-10.866 10.079c-4.252-5.985-10.079-8.977-17.48-8.977-13.859 0-22.992 10.394-22.992 25.197 0 14.803 9.133 25.354 22.992 25.354 7.401 0 13.228-3.15 17.48-8.976l10.866 10.079c-5.354 7.244-14.33 13.543-29.134 13.543-23.15 0-39.37-16.85-39.37-40z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M758.74 87.979c0-22.992 16.22-39.843 39.37-39.843 14.803 0 23.78 6.3 29.134 13.544l-10.866 10.079c-4.252-5.985-10.079-8.977-17.48-8.977-13.859 0-22.992 10.394-22.992 25.197 0 14.803 9.133 25.354 22.992 25.354 7.401 0 13.228-3.15 17.48-8.976l10.866 10.079c-5.354 7.244-14.33 13.543-29.134 13.543-23.15 0-39.37-16.85-39.37-40z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M758.74 87.979c0-22.992 16.22-39.843 39.37-39.843 14.803 0 23.78 6.3 29.134 13.544l-10.866 10.079c-4.252-5.985-10.079-8.977-17.48-8.977-13.859 0-22.992 10.394-22.992 25.197 0 14.803 9.133 25.354 22.992 25.354 7.401 0 13.228-3.15 17.48-8.976l10.866 10.079c-5.354 7.244-14.33 13.543-29.134 13.543-23.15 0-39.37-16.85-39.37-40z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M327.402 48.136c24.409 0 39.212 18.11 39.212 39.843 0 21.89-14.803 40-39.212 40-24.095 0-39.056-18.11-39.056-40 0-21.732 14.961-39.843 39.056-39.843zm0 14.646c-14.016 0-21.89 11.811-21.89 25.197 0 13.543 7.874 25.354 21.89 25.354 14.173 0 22.047-11.81 22.047-25.354 0-13.386-7.874-25.197-22.047-25.197z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M327.402 48.136c24.409 0 39.212 18.11 39.212 39.843 0 21.89-14.803 40-39.212 40-24.095 0-39.056-18.11-39.056-40 0-21.732 14.961-39.843 39.056-39.843zm0 14.646c-14.016 0-21.89 11.811-21.89 25.197 0 13.543 7.874 25.354 21.89 25.354 14.173 0 22.047-11.81 22.047-25.354 0-13.386-7.874-25.197-22.047-25.197z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M327.402 48.136c24.409 0 39.212 18.11 39.212 39.843 0 21.89-14.803 40-39.212 40-24.095 0-39.056-18.11-39.056-40 0-21.732 14.961-39.843 39.056-39.843zm0 14.646c-14.016 0-21.89 11.811-21.89 25.197 0 13.543 7.874 25.354 21.89 25.354 14.173 0 22.047-11.81 22.047-25.354 0-13.386-7.874-25.197-22.047-25.197z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M403.307 126.09l-31.024-76.064h17.638l22.205 57.008 22.205-57.008h17.795l-31.024 76.063z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M403.307 126.09l-31.024-76.064h17.638l22.205 57.008 22.205-57.008h17.795l-31.024 76.063z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M403.307 126.09l-31.024-76.064h17.638l22.205 57.008 22.205-57.008h17.795l-31.024 76.063z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M175.906 73.648c0-32.913 24.724-54.33 55.118-54.33 20.472 0 33.858 9.763 42.362 21.89l-15.118 8.503c-5.512-7.874-15.433-14.015-27.244-14.015-20.788 0-36.22 15.905-36.22 37.952 0 22.048 15.432 38.11 36.22 38.11 10.708 0 20.157-5.039 24.882-9.448V85.932h-31.34v-16.22h49.765v39.37c-10.394 11.495-25.04 19.054-43.307 19.054-30.394 0-55.118-21.574-55.118-54.488z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M175.906 73.648c0-32.913 24.724-54.33 55.118-54.33 20.472 0 33.858 9.763 42.362 21.89l-15.118 8.503c-5.512-7.874-15.433-14.015-27.244-14.015-20.788 0-36.22 15.905-36.22 37.952 0 22.048 15.432 38.11 36.22 38.11 10.708 0 20.157-5.039 24.882-9.448V85.932h-31.34v-16.22h49.765v39.37c-10.394 11.495-25.04 19.054-43.307 19.054-30.394 0-55.118-21.574-55.118-54.488z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M175.906 73.648c0-32.913 24.724-54.33 55.118-54.33 20.472 0 33.858 9.763 42.362 21.89l-15.118 8.503c-5.512-7.874-15.433-14.015-27.244-14.015-20.788 0-36.22 15.905-36.22 37.952 0 22.048 15.432 38.11 36.22 38.11 10.708 0 20.157-5.039 24.882-9.448V85.932h-31.34v-16.22h49.765v39.37c-10.394 11.495-25.04 19.054-43.307 19.054-30.394 0-55.118-21.574-55.118-54.488z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M893.228 126.09V78.214c0-11.81-6.141-15.433-15.433-15.433-8.346 0-15.59 5.04-19.527 10.236v53.071h-16.536V21.05h16.536v39.37c5.04-5.983 14.96-12.283 26.929-12.283 16.378 0 24.567 8.504 24.567 24.095v53.858h-16.536z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M893.228 126.09V78.214c0-11.81-6.141-15.433-15.433-15.433-8.346 0-15.59 5.04-19.527 10.236v53.071h-16.536V21.05h16.536v39.37c5.04-5.983 14.96-12.283 26.929-12.283 16.378 0 24.567 8.504 24.567 24.095v53.858h-16.536z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M893.228 126.09V78.214c0-11.81-6.141-15.433-15.433-15.433-8.346 0-15.59 5.04-19.527 10.236v53.071h-16.536V21.05h16.536v39.37c5.04-5.983 14.96-12.283 26.929-12.283 16.378 0 24.567 8.504 24.567 24.095v53.858h-16.536z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M38.838 62.568c-5.044 0-9.171 4.133-9.171 9.184v45.26c0 5.051 4.127 9.185 9.171 9.185s9.171-4.134 9.171-9.184v-45.26c0-5.052-4.127-9.185-9.171-9.185zM112.212 126.197h-.004c-5.044 0-9.171-4.134-9.171-9.184v-45.26c0-5.052 4.127-9.185 9.17-9.185h.005c5.044 0 9.167 4.133 9.167 9.184v45.26c0 5.051-4.123 9.185-9.167 9.185zM75.312 104.914h.004c5.044 0 9.171-4.133 9.171-9.184V50.47c0-5.051-4.127-9.185-9.171-9.185h-.004c-5.044 0-9.167 4.134-9.167 9.184v45.26c0 5.052 4.123 9.185 9.167 9.185zM84.694 138.223v-13.446c0-5.05-4.127-9.184-9.171-9.184-5.048 0-9.171 4.134-9.171 9.184v13.446c0 5.051 4.123 9.185 9.171 9.185 5.044 0 9.171-4.134 9.171-9.185z",
                    stroke: "#FFF",
                    strokeWidth: 0.656
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M75.523.367a9.106 9.106 0 00-4.586 1.222L5.51 39.42C1.143 41.945-.37 47.587 2.153 51.965c2.522 4.373 8.16 5.887 12.528 3.361l60.842-35.175 60.842 35.175c4.367 2.526 10.006 1.012 12.528-3.361 2.522-4.378 1.01-10.02-3.357-12.546L80.11 1.59A9.106 9.106 0 0075.523.367z"
                    })
                })
            ]
        })
    });
}
function MobileNavbarLogo() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        width: "100%",
        height: 19,
        viewBox: "0 0 736 112",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "#FFF",
            fillRule: "nonzero",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M287.52 108.09V3.05h16.535v105.04z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M287.52 108.09V3.05h16.535v105.04z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M287.52 108.09V3.05h16.535v105.04zM356.811 30.136c16.85 0 31.654 7.087 31.654 27.56v50.393h-16.536V99.9c-5.67 6.457-14.488 10.079-24.567 10.079-12.44 0-26.456-8.346-26.456-25.197 0-17.48 14.015-24.724 26.456-24.724 10.236 0 19.055 3.307 24.567 9.764v-11.34c0-8.818-7.244-14.172-17.795-14.172-8.504 0-15.906 3.15-22.52 9.606l-6.771-11.496c8.818-8.347 19.842-12.284 31.968-12.284zm-2.992 41.26c-9.291 0-16.22 5.355-16.22 13.701 0 8.19 6.929 13.543 16.22 13.543 7.244 0 14.33-2.677 18.11-7.874V79.27c-3.78-5.197-10.866-7.874-18.11-7.874z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M356.811 30.136c16.85 0 31.654 7.087 31.654 27.56v50.393h-16.536V99.9c-5.67 6.457-14.488 10.079-24.567 10.079-12.44 0-26.456-8.346-26.456-25.197 0-17.48 14.015-24.724 26.456-24.724 10.236 0 19.055 3.307 24.567 9.764v-11.34c0-8.818-7.244-14.172-17.795-14.172-8.504 0-15.906 3.15-22.52 9.606l-6.771-11.496c8.818-8.347 19.842-12.284 31.968-12.284zm-2.992 41.26c-9.291 0-16.22 5.355-16.22 13.701 0 8.19 6.929 13.543 16.22 13.543 7.244 0 14.33-2.677 18.11-7.874V79.27c-3.78-5.197-10.866-7.874-18.11-7.874z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M356.811 30.136c16.85 0 31.654 7.087 31.654 27.56v50.393h-16.536V99.9c-5.67 6.457-14.488 10.079-24.567 10.079-12.44 0-26.456-8.346-26.456-25.197 0-17.48 14.015-24.724 26.456-24.724 10.236 0 19.055 3.307 24.567 9.764v-11.34c0-8.818-7.244-14.172-17.795-14.172-8.504 0-15.906 3.15-22.52 9.606l-6.771-11.496c8.818-8.347 19.842-12.284 31.968-12.284zm-2.992 41.26c-9.291 0-16.22 5.355-16.22 13.701 0 8.19 6.929 13.543 16.22 13.543 7.244 0 14.33-2.677 18.11-7.874V79.27c-3.78-5.197-10.866-7.874-18.11-7.874zM461.22 108.09V98.01c-5.511 6.142-14.96 11.969-26.929 11.969-16.378 0-24.41-8.504-24.41-24.094V32.026h16.536V79.9c0 11.811 5.985 15.433 15.276 15.433 8.346 0 15.59-4.724 19.527-9.92V32.025h16.536v76.063H461.22z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M461.22 108.09V98.01c-5.511 6.142-14.96 11.969-26.929 11.969-16.378 0-24.41-8.504-24.41-24.094V32.026h16.536V79.9c0 11.811 5.985 15.433 15.276 15.433 8.346 0 15.59-4.724 19.527-9.92V32.025h16.536v76.063H461.22z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M461.22 108.09V98.01c-5.511 6.142-14.96 11.969-26.929 11.969-16.378 0-24.41-8.504-24.41-24.094V32.026h16.536V79.9c0 11.811 5.985 15.433 15.276 15.433 8.346 0 15.59-4.724 19.527-9.92V32.025h16.536v76.063H461.22z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M550.512 108.09V60.53c0-11.81-5.984-15.748-15.276-15.748-8.504 0-15.748 5.04-19.527 10.236v53.071h-16.536V32.026h16.536V42.42c5.039-5.984 14.803-12.284 26.771-12.284 16.378 0 24.567 8.82 24.567 24.41v53.543h-16.535z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M550.512 108.09V60.53c0-11.81-5.984-15.748-15.276-15.748-8.504 0-15.748 5.04-19.527 10.236v53.071h-16.536V32.026h16.536V42.42c5.039-5.984 14.803-12.284 26.771-12.284 16.378 0 24.567 8.82 24.567 24.41v53.543h-16.535z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M550.512 108.09V60.53c0-11.81-5.984-15.748-15.276-15.748-8.504 0-15.748 5.04-19.527 10.236v53.071h-16.536V32.026h16.536V42.42c5.039-5.984 14.803-12.284 26.771-12.284 16.378 0 24.567 8.82 24.567 24.41v53.543h-16.535z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M583.74 69.979c0-22.992 16.22-39.843 39.37-39.843 14.803 0 23.78 6.3 29.134 13.544l-10.866 10.079c-4.252-5.985-10.079-8.977-17.48-8.977-13.859 0-22.992 10.394-22.992 25.197 0 14.803 9.133 25.354 22.992 25.354 7.401 0 13.228-3.15 17.48-8.976l10.866 10.079c-5.354 7.244-14.33 13.543-29.134 13.543-23.15 0-39.37-16.85-39.37-40z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M583.74 69.979c0-22.992 16.22-39.843 39.37-39.843 14.803 0 23.78 6.3 29.134 13.544l-10.866 10.079c-4.252-5.985-10.079-8.977-17.48-8.977-13.859 0-22.992 10.394-22.992 25.197 0 14.803 9.133 25.354 22.992 25.354 7.401 0 13.228-3.15 17.48-8.976l10.866 10.079c-5.354 7.244-14.33 13.543-29.134 13.543-23.15 0-39.37-16.85-39.37-40z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M583.74 69.979c0-22.992 16.22-39.843 39.37-39.843 14.803 0 23.78 6.3 29.134 13.544l-10.866 10.079c-4.252-5.985-10.079-8.977-17.48-8.977-13.859 0-22.992 10.394-22.992 25.197 0 14.803 9.133 25.354 22.992 25.354 7.401 0 13.228-3.15 17.48-8.976l10.866 10.079c-5.354 7.244-14.33 13.543-29.134 13.543-23.15 0-39.37-16.85-39.37-40z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M152.402 30.136c24.409 0 39.212 18.11 39.212 39.843 0 21.89-14.803 40-39.212 40-24.095 0-39.056-18.11-39.056-40 0-21.732 14.961-39.843 39.056-39.843zm0 14.646c-14.016 0-21.89 11.811-21.89 25.197 0 13.543 7.874 25.354 21.89 25.354 14.173 0 22.047-11.81 22.047-25.354 0-13.386-7.874-25.197-22.047-25.197z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M152.402 30.136c24.409 0 39.212 18.11 39.212 39.843 0 21.89-14.803 40-39.212 40-24.095 0-39.056-18.11-39.056-40 0-21.732 14.961-39.843 39.056-39.843zm0 14.646c-14.016 0-21.89 11.811-21.89 25.197 0 13.543 7.874 25.354 21.89 25.354 14.173 0 22.047-11.81 22.047-25.354 0-13.386-7.874-25.197-22.047-25.197z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M152.402 30.136c24.409 0 39.212 18.11 39.212 39.843 0 21.89-14.803 40-39.212 40-24.095 0-39.056-18.11-39.056-40 0-21.732 14.961-39.843 39.056-39.843zm0 14.646c-14.016 0-21.89 11.811-21.89 25.197 0 13.543 7.874 25.354 21.89 25.354 14.173 0 22.047-11.81 22.047-25.354 0-13.386-7.874-25.197-22.047-25.197z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M228.307 108.09l-31.024-76.064h17.638l22.205 57.008 22.205-57.008h17.795l-31.024 76.063z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M228.307 108.09l-31.024-76.064h17.638l22.205 57.008 22.205-57.008h17.795l-31.024 76.063z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M228.307 108.09l-31.024-76.064h17.638l22.205 57.008 22.205-57.008h17.795l-31.024 76.063z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M.906 55.648c0-32.913 24.724-54.33 55.118-54.33 20.472 0 33.858 9.763 42.362 21.89L83.268 31.71c-5.512-7.874-15.433-14.015-27.244-14.015-20.788 0-36.22 15.905-36.22 37.952 0 22.048 15.432 38.11 36.22 38.11 10.708 0 20.157-5.039 24.882-9.448V67.932h-31.34v-16.22h49.765v39.37c-10.394 11.495-25.04 19.054-43.307 19.054C25.63 110.136.906 88.562.906 55.648z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M.906 55.648c0-32.913 24.724-54.33 55.118-54.33 20.472 0 33.858 9.763 42.362 21.89L83.268 31.71c-5.512-7.874-15.433-14.015-27.244-14.015-20.788 0-36.22 15.905-36.22 37.952 0 22.048 15.432 38.11 36.22 38.11 10.708 0 20.157-5.039 24.882-9.448V67.932h-31.34v-16.22h49.765v39.37c-10.394 11.495-25.04 19.054-43.307 19.054C25.63 110.136.906 88.562.906 55.648z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M.906 55.648c0-32.913 24.724-54.33 55.118-54.33 20.472 0 33.858 9.763 42.362 21.89L83.268 31.71c-5.512-7.874-15.433-14.015-27.244-14.015-20.788 0-36.22 15.905-36.22 37.952 0 22.048 15.432 38.11 36.22 38.11 10.708 0 20.157-5.039 24.882-9.448V67.932h-31.34v-16.22h49.765v39.37c-10.394 11.495-25.04 19.054-43.307 19.054C25.63 110.136.906 88.562.906 55.648z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M718.228 108.09V60.214c0-11.81-6.141-15.433-15.433-15.433-8.346 0-15.59 5.04-19.527 10.236v53.071h-16.536V3.05h16.536v39.37c5.04-5.983 14.96-12.283 26.929-12.283 16.378 0 24.567 8.504 24.567 24.095v53.858h-16.536z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M718.228 108.09V60.214c0-11.81-6.141-15.433-15.433-15.433-8.346 0-15.59 5.04-19.527 10.236v53.071h-16.536V3.05h16.536v39.37c5.04-5.983 14.96-12.283 26.929-12.283 16.378 0 24.567 8.504 24.567 24.095v53.858h-16.536z"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M718.228 108.09V60.214c0-11.81-6.141-15.433-15.433-15.433-8.346 0-15.59 5.04-19.527 10.236v53.071h-16.536V3.05h16.536v39.37c5.04-5.983 14.96-12.283 26.929-12.283 16.378 0 24.567 8.504 24.567 24.095v53.858h-16.536z"
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/navbar/JoinButtons.tsx








function JoinButtons(_param) {
    var _isMobile = _param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "isMobile"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        children: [
            !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: "/signup",
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                    variant: "primary",
                    rounded: "xl",
                    px: 3,
                    height: 6,
                    lineHeight: "tall",
                    mr: 2,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Join",
                        id: "P6PLpi"
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: "/signin",
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                    variant: "primary",
                    rounded: "xl",
                    px: 3,
                    height: 6,
                    lineHeight: "tall",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Sign In",
                        id: "Ub+AGc"
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/navbar/DesktopNavbar.tsx















function Navbar() {
    var user = (0,Auth/* useSelfie */.yD)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        bg: "gray.700",
        as: "header",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
            maxWidth: "1224px",
            display: "flex",
            mx: "auto",
            alignItems: "center",
            position: "relative",
            width: "100%",
            height: "81px",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("header", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: "/",
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                            display: "inline-flex",
                            "aria-label": "homepage",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavbarLogo, {})
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                    flex: 1,
                    ml: 8,
                    mr: 6,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(navbar_NavbarSearch, {})
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("nav", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Stack */.Kq, {
                        as: "ul",
                        listStyleType: "none",
                        direction: "row",
                        display: "flex",
                        spacing: 6,
                        ml: "auto",
                        mr: user ? 8 : 0,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                as: "li",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: "/collections",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarAnchor, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Collections",
                                            id: "ulh3kf"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                as: "li",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: "/projects",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarAnchor, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Projects",
                                            id: "UxTJRa"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                as: "li",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: "/products",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarAnchor, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            id: "7NFfmz",
                                            defaultMessage: "Products"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                as: "li",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: "/stories",
                                    as: "/stories",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarAnchor, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Stories",
                                            id: "Ldxym4"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                as: "li",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarPopoverMenu, {})
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("nav", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        display: "flex",
                        alignItems: "center",
                        ml: "auto",
                        children: user ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                                    mr: 3,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserNotifications, {})
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserProfileDropdown, {
                                    user: user
                                })
                            ]
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JoinButtons, {
                            ml: 4
                        })
                    })
                })
            ]
        })
    });
};
var NavbarAnchor = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        color: "gray.100",
        fontWeight: "semibold",
        fontSize: "lg",
        ref: ref
    }, props), {
        children: children
    }));
});
NavbarAnchor.displayName = "NavbarAnchor";

;// CONCATENATED MODULE: ./lib/hooks/useWindowDimensions.ts

function useWindowDimensions() {
    var getWindowDimensions = function getWindowDimensions() {
        var width = hasWindow ? window.innerWidth : null;
        var height = hasWindow ? window.innerHeight : null;
        return {
            width: width,
            height: height
        };
    };
    var handleResize = function handleResize() {
        setWindowDimensions(getWindowDimensions());
    };
    var hasWindow = "object" !== "undefined";
    var ref = (0,react.useState)(getWindowDimensions()), windowDimensions = ref[0], setWindowDimensions = ref[1];
    (0,react.useEffect)(function() {
        if (hasWindow) {
            window.addEventListener("resize", handleResize);
            return function() {
                return window.removeEventListener("resize", handleResize);
            };
        }
    }, [
        hasWindow
    ]);
    return windowDimensions;
};

// EXTERNAL MODULE: ./components/Terms.tsx
var Terms = __webpack_require__(23805);
;// CONCATENATED MODULE: ./src/components/navbar/MobileMenu.tsx

















function MobileMenu() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isOpen = ref[0], toggleOpen = ref[1];
    var user = (0,Auth/* useSelfie */.yD)();
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuContext.Provider, {
        value: {
            isOpen: isOpen,
            toggleOpen: toggleOpen
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                    type: "button",
                    "aria-label": isOpen ? "Close menu" : "Open menu",
                    css: {
                        background: "none",
                        border: 0,
                        outline: 0,
                        cursor: "pointer",
                        display: "inline-flex"
                    },
                    onClick: function() {
                        return toggleOpen();
                    },
                    children: !isOpen ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuIcon, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseIcon, {})
                }),
                isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                    bg: "gray.900",
                    position: "absolute",
                    top: "55px",
                    left: -20,
                    pt: 3,
                    width: "305px",
                    zIndex: 101,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileMenu_Menu, {
                            expanded: true,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                                    text: intl.formatMessage({
                                        defaultMessage: "Collections",
                                        id: "ulh3kf"
                                    }),
                                    icon: CollectionsIcon,
                                    href: "/collections",
                                    as: "/"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                                    text: intl.formatMessage({
                                        defaultMessage: "Projects",
                                        id: "UxTJRa"
                                    }),
                                    icon: ProjectsIcon,
                                    href: "/projects",
                                    as: "/projects"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                                    text: intl.formatMessage({
                                        id: "7NFfmz",
                                        defaultMessage: "Products"
                                    }),
                                    icon: ProductsIcon,
                                    href: "/products",
                                    as: "/products"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                                    text: intl.formatMessage({
                                        defaultMessage: "Stories",
                                        id: "Ldxym4"
                                    }),
                                    icon: StoriesIcon,
                                    href: "/stories",
                                    as: "/stories"
                                })
                            ]
                        }),
                        user && user.__typename === "VendorUser" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorMenuSection, {
                            user: user
                        }),
                        user && user.__typename === "GovernmentUser" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentMenuSection, {
                            user: user
                        }),
                        user && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserMenuSection, {
                            user: user
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppMenuSection, {})
                    ]
                })
            ]
        })
    });
};
var MenuContext = /*#__PURE__*/ react.createContext({
    isOpen: false,
    toggleOpen: function() {}
});
function CollapsibleMenu(param) {
    var image = param.image, name = param.name, children = param.children, _defaultExpanded = param.defaultExpanded, defaultExpanded = _defaultExpanded === void 0 ? false : _defaultExpanded;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(defaultExpanded), 2), expanded = ref[0], toggleExpanded = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        onClick: toggleExpanded,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                display: "flex",
                alignItems: "center",
                px: 8,
                py: 4,
                borderTop: "1px",
                borderTopColor: "gray.500",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                        size: "sm",
                        src: image,
                        name: name
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                        fontSize: "lg",
                        isTruncated: true,
                        ml: 3,
                        fontWeight: "bold",
                        color: "white",
                        children: name
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Chevron, {
                        css: {
                            marginLeft: "auto",
                            paddingLeft: 8,
                            transform: expanded ? "none" : "rotate(180deg)",
                            transition: "transform 0.3s ease-out;"
                        },
                        width: 24
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: children({
                    expanded: expanded,
                    toggle: toggleExpanded
                })
            })
        ]
    });
}
function AppMenuSection() {
    var intl = (0,useIntl/* default */.Z)();
    var policiesUrls = (0,useIntlPolicies/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        color: "gray.200",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileMenu_Menu, {
            expanded: true,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: "/about",
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                            color: "gray.200",
                            external: "govlaunch",
                            href: "https://help.govlaunch.com",
                            fontSize: "md",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "About",
                                id: "g5pX+a"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                        color: "gray.200",
                        external: "govlaunch",
                        href: "https://advertise.govlaunch.com/",
                        fontSize: "md",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Advertise",
                            id: "2OzlCZ"
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                        color: "gray.200",
                        external: "govlaunch",
                        href: "https://help.govlaunch.com",
                        fontSize: "md",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Help",
                            id: "SENRqu"
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: "/podcast",
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                            color: "gray.200",
                            fontSize: "md",
                            rel: "noreferrer noopener",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Podcast",
                                id: "uNMm97"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                        color: "gray.200",
                        external: "govlaunch",
                        href: "https://blog.govlaunch.com",
                        fontSize: "md",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Blog",
                            id: "tv5FG3"
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Terms/* default */.Z, {
                        title: intl.formatMessage({
                            defaultMessage: "Terms of Service",
                            id: "32rBNK"
                        }),
                        policyUrl: policiesUrls.termsAndConditions,
                        children: function(toggleOpen) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                color: "gray.200",
                                href: "#",
                                onClick: function(event) {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    toggleOpen();
                                },
                                css: {
                                    fontSize: 16
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Terms of Service",
                                        id: "32rBNK"
                                    })
                                })
                            });
                        }
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Terms/* default */.Z, {
                        title: intl.formatMessage({
                            defaultMessage: "Privacy Policy",
                            id: "vx0nkZ"
                        }),
                        policyUrl: policiesUrls.privacyPolicy,
                        children: function(toggleOpen) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                color: "gray.200",
                                href: "#",
                                onClick: function(event) {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    toggleOpen();
                                },
                                fontSize: "md",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Privacy Policy",
                                        id: "vx0nkZ"
                                    })
                                })
                            });
                        }
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Terms/* default */.Z, {
                        title: intl.formatMessage({
                            defaultMessage: "Cookie Policy",
                            id: "cA0kQY"
                        }),
                        policyUrl: policiesUrls.cookiePolicy,
                        children: function(toggleOpen) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                color: "gray.200",
                                href: "#",
                                onClick: function(event) {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    toggleOpen();
                                },
                                css: {
                                    fontSize: 16
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Cookie Policy",
                                        id: "cA0kQY"
                                    })
                                })
                            });
                        }
                    })
                })
            ]
        })
    });
}
function UserMenuSection(param) {
    var user = param.user;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isReferralsOpen = ref[0], toggleReferralsOpen = ref[1];
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            isReferralsOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Referrals, {
                isOpen: isReferralsOpen,
                onRequestClose: function() {
                    return toggleReferralsOpen();
                },
                referralUrl: "".concat((0,getGovlaunchBaseUrl/* default */.Z)("portal"), "?referral=").concat(user._id)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollapsibleMenu, {
                defaultExpanded: true,
                image: user.avatar,
                name: user.fullName,
                children: function(param) {
                    var expanded = param.expanded;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileMenu_Menu, {
                        expanded: expanded,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                                text: intl.formatMessage({
                                    defaultMessage: "My Profile",
                                    id: "YzZa8+"
                                }),
                                icon: icons_UserIcon,
                                href: "/user?userSlug=".concat(user.slug),
                                as: "/@".concat(user.slug)
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                                text: intl.formatMessage({
                                    defaultMessage: "Settings",
                                    id: "D3idYv"
                                }),
                                icon: SettingsIcon,
                                href: "/user?userSlug=".concat(user.slug, "&tab=settings"),
                                as: "/@".concat(user.slug, "/settings")
                            }),
                            user.groups.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                borderTop: "1px",
                                borderBottom: "1px",
                                borderTopColor: "gray.500",
                                borderBottomColor: "gray.500",
                                my: 2,
                                css: {
                                    "> div": {
                                        padding: "8px 0"
                                    }
                                },
                                children: user.groups.map(function(group) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                                        text: group.name,
                                        icon: function() {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                                src: group.logo,
                                                name: group.name,
                                                size: "xs"
                                            });
                                        },
                                        href: "/group?groupSlug=".concat(group.slug)
                                    }, group._id);
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                                text: intl.formatMessage({
                                    defaultMessage: "Referrals",
                                    id: "CrJOJJ"
                                }),
                                icon: icons_ReferralsIcon,
                                onClick: toggleReferralsOpen
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Auth/* default */.ZP, {
                                children: function(param) {
                                    var logout = param.logout;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                                        text: intl.formatMessage({
                                            defaultMessage: "Log Out",
                                            id: "H0JBH6"
                                        }),
                                        icon: icons_LogOutIcon,
                                        onClick: logout
                                    });
                                }
                            })
                        ]
                    });
                }
            })
        ]
    });
}
function GovernmentMenuSection(param) {
    var user = param.user;
    var intl = (0,useIntl/* default */.Z)();
    var government = user.government;
    if (!government) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollapsibleMenu, {
        image: government.logo,
        name: government.name,
        defaultExpanded: true,
        children: function(param) {
            var expanded = param.expanded;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileMenu_Menu, {
                expanded: expanded,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                        text: intl.formatMessage({
                            defaultMessage: "Activity",
                            id: "ZmlNQ3"
                        }),
                        icon: ActivityIcon,
                        count: government.feedCount,
                        href: "/government?governmentSlug=".concat(government.slug),
                        as: "/governments/".concat(government.slug)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                        text: intl.formatMessage({
                            defaultMessage: "Projects",
                            id: "UxTJRa"
                        }),
                        icon: ProjectsIcon,
                        count: government.projectsCount || 0,
                        href: "/government?governmentSlug=".concat(government.slug, "&content=projects"),
                        as: "/governments/".concat(government.slug, "/projects")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                        text: intl.formatMessage({
                            defaultMessage: "Products",
                            id: "7NFfmz"
                        }),
                        icon: ProductsIcon,
                        count: government.productsCount || 0,
                        href: "/government?governmentSlug=".concat(government.slug, "&content=products"),
                        as: "/governments/".concat(government.slug, "/products")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                        text: intl.formatMessage({
                            defaultMessage: "Actions",
                            id: "wL7VAE"
                        }),
                        icon: ActionsIcon,
                        count: government.actionsCount || 0,
                        href: "/government?governmentSlug=".concat(government.slug, "&content=actions"),
                        as: "/governments/".concat(government.slug, "/actions")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                        text: intl.formatMessage({
                            defaultMessage: "Settings",
                            id: "D3idYv"
                        }),
                        icon: SettingsIcon,
                        href: "/government?governmentSlug=".concat(government.slug, "&content=settings"),
                        as: "/governments/".concat(government.slug, "/settings")
                    })
                ]
            });
        }
    });
}
function VendorMenuSection(param) {
    var user = param.user;
    var intl = (0,useIntl/* default */.Z)();
    var company = user.company;
    if (!company) {
        return null;
    }
    var userHasOwnerRights = user.role === "COMPANY_OWNER" || company.usersCanAccessAccountPage;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollapsibleMenu, {
        image: company.logo,
        name: company.name,
        defaultExpanded: true,
        children: function(param) {
            var expanded = param.expanded;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileMenu_Menu, {
                expanded: expanded,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                        text: intl.formatMessage({
                            defaultMessage: "Activity",
                            id: "ZmlNQ3"
                        }),
                        icon: ActivityIcon,
                        count: company.feedCount,
                        href: "/vendor?vendorSlug=".concat(company.slug, "&content=connect"),
                        as: "/vendors/".concat(company.slug, "/connect")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                        text: intl.formatMessage({
                            defaultMessage: "Products",
                            id: "7NFfmz"
                        }),
                        icon: ProductsIcon,
                        count: company.productsCount || 0,
                        href: "/vendor?vendorSlug=".concat(company.slug, "&content=products"),
                        as: "/vendors/".concat(company.slug, "/products")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                        text: intl.formatMessage({
                            defaultMessage: "Projects",
                            id: "UxTJRa"
                        }),
                        icon: ProjectsIcon,
                        count: company.projectsCount || 0,
                        href: "/vendor?vendorSlug=".concat(company.slug, "&content=projects"),
                        as: "/vendors/".concat(company.slug, "/projects")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                        text: intl.formatMessage({
                            defaultMessage: "Stories",
                            id: "Ldxym4"
                        }),
                        icon: StoriesIcon,
                        count: company.storiesCount || 0,
                        href: "/vendor?vendorSlug=".concat(company.slug, "&content=stories"),
                        as: "/vendors/".concat(company.slug, "/stories")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                        text: intl.formatMessage({
                            defaultMessage: "Actions",
                            id: "wL7VAE"
                        }),
                        icon: ActionsIcon,
                        count: company.actionsCount,
                        href: "/vendor?vendorSlug=".concat(company.slug, "&content=actions"),
                        as: "/vendors/".concat(company.slug, "/actions")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MenuItemGroup, {
                        text: intl.formatMessage({
                            defaultMessage: "Settings",
                            id: "D3idYv"
                        }),
                        icon: SettingsIcon,
                        href: "/vendor/[vendorSlug]/[[...content]]",
                        as: "/vendors/".concat(company.slug, "/").concat(userHasOwnerRights ? "account" : "edit-vendor"),
                        children: [
                            userHasOwnerRights && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                                text: intl.formatMessage({
                                    defaultMessage: "Account",
                                    id: "TwyMau"
                                }),
                                href: "/vendor?vendorSlug=".concat(company.slug, "&content=account"),
                                as: "/vendors/".concat(company.slug, "/account")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                                text: intl.formatMessage({
                                    defaultMessage: "Edit Profile",
                                    id: "usAvMr"
                                }),
                                href: "/vendor?vendorSlug=".concat(company.slug, "&content=edit-vendor"),
                                as: "/vendors/".concat(company.slug, "/edit-vendor")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                                text: intl.formatMessage({
                                    defaultMessage: "Preview Profile",
                                    id: "Uve4oA"
                                }),
                                href: "/vendor?vendorSlug=".concat(company.slug, "&preview=1&maker=1"),
                                as: "/vendors/".concat(company.slug, "?preview=1&maker=1")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                                text: intl.formatMessage({
                                    defaultMessage: "Team",
                                    id: "wsUmh9"
                                }),
                                href: "/vendor?vendorSlug=".concat(company.slug, "&content=team"),
                                as: "/vendors/".concat(company.slug, "/team")
                            })
                        ]
                    })
                ]
            });
        }
    });
}
function MenuItemGroup(_param) {
    var children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, (0,src_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: (0,mediaQueries/* default */.Z)({
                    marginLeft: 24,
                    paddingLeft: 12,
                    "> div": {
                        padding: 0
                    },
                    "> div:not(:first-of-type)": {
                        marginTop: 16
                    },
                    marginTop: 8,
                    textAlign: "left"
                }),
                children: children
            })
        ]
    });
}
function MobileMenu_Menu(_param) {
    var expanded = _param.expanded, children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "expanded",
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuContext.Consumer, {
        children: function(param) {
            var toggleOpen = param.toggleOpen;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                css: {
                    display: "flex",
                    flexDirection: "column",
                    "> div": {
                        padding: "8px 32px"
                    },
                    "> div:first-of-type": {
                        paddingTop: 0
                    },
                    "> div:last-child": {
                        paddingBottom: 16
                    },
                    transition: "max-height 0.3s ease-out;",
                    overflow: "hidden",
                    height: "auto",
                    maxHeight: expanded ? 2000 : 0
                }
            }, props), {
                onClick: function() {
                    setTimeout(toggleOpen, 200);
                },
                children: children
            }));
        }
    });
}
function MenuItem(_param) {
    var text = _param.text, tmp = _param.icon, Icon = tmp === void 0 ? null : tmp, _onClick = _param.onClick, onClick = _onClick === void 0 ? function() {} : _onClick, _count = _param.count, count = _count === void 0 ? null : _count, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, href = _param.href, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "text",
        "icon",
        "onClick",
        "count",
        "disabled",
        "href"
    ]);
    if (href) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                href: href,
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Anchor */.ee, {
                    onClick: onClick,
                    css: {
                        display: "flex",
                        alignItems: "center"
                    },
                    color: "gray.200",
                    _hover: {
                        color: "white"
                    },
                    children: [
                        Icon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            mr: 3,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
                                width: 24,
                                height: 24
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Text */.xv, {
                            as: "div",
                            fontWeight: "semibold",
                            fontSize: "md",
                            children: [
                                text,
                                " ",
                                !!count && count > 0 && !disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CountBadge, {
                                    children: count > 99 ? "99+" : count
                                })
                            ]
                        })
                    ]
                })
            }))
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Anchor */.ee, {
            onClick: onClick,
            css: {
                display: "flex",
                alignItems: "center"
            },
            color: "gray.200",
            _hover: {
                color: "white"
            },
            children: [
                Icon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                    mr: 3,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
                        width: 24,
                        height: 24
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Text */.xv, {
                    fontWeight: "semibold",
                    fontSize: "md",
                    children: [
                        text,
                        " ",
                        !!count && count > 0 && !disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CountBadge, {
                            children: count > 99 ? "99+" : count
                        })
                    ]
                })
            ]
        })
    });
}
function CountBadge(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        bg: "blue.600",
        fontSize: "xs",
        fontWeight: "semibold",
        width: "16px",
        height: "16px",
        borderRadius: "full",
        textAlign: "center",
        color: "white",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        ml: 2,
        children: children
    });
}
function Chevron(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "24",
        height: "11",
        viewBox: "0 0 24 11",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M23.2357 9.85051C23.7054 9.16809 23.5329 8.23413 22.8505 7.76447L12.5941 0.705643C12.071 0.345634 11.3779 0.354009 10.8637 0.726553L1.12009 7.78538C0.449212 8.2714 0.299358 9.20925 0.78538 9.88012C1.2714 10.551 2.20925 10.7009 2.88013 10.2148L11.7659 3.77747L21.1497 10.2357C21.8321 10.7054 22.7661 10.5329 23.2357 9.85051Z",
            fill: "#ADB6C3"
        })
    }));
}

;// CONCATENATED MODULE: ./src/components/navbar/MobileNavbar.tsx











function MobileNavbar() {
    var user = (0,Auth/* useSelfie */.yD)();
    var width = useWindowDimensions().width;
    var hideSignUpButton = width && width < 480 ? true : false;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        bg: "gray.700",
        px: 5,
        as: "header",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
            maxWidth: "1224px",
            display: "flex",
            mx: "auto",
            alignItems: "center",
            position: "relative",
            width: "100%",
            height: "56px",
            zIndex: 305,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("nav", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileMenu, {})
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("header", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: "/",
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                            display: "inline-flex",
                            ml: 4,
                            maxWidth: "115px",
                            "aria-label": "homepage",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileNavbarLogo, {})
                        })
                    })
                }),
                user ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                    flex: 1,
                    ml: 8,
                    align: "center",
                    justify: "flex-end",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(navbar_NavbarSearch, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            display: "flex",
                            alignItems: "center",
                            ml: 6,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserNotifications, {})
                        })
                    ]
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("nav", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                        flex: 1,
                        align: "center",
                        justify: "flex-end",
                        minWidth: hideSignUpButton ? "" : "170px",
                        marginLeft: 2,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JoinButtons, {
                                mr: 2,
                                isMobile: hideSignUpButton
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(navbar_NavbarSearch, {})
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/mediaQueries.ts
var components_mediaQueries = __webpack_require__(92418);
// EXTERNAL MODULE: ./lib/withIntl.tsx + 9 modules
var withIntl = __webpack_require__(21505);
// EXTERNAL MODULE: ./components/icons/DropdownArrowUp.tsx
var DropdownArrowUp = __webpack_require__(61499);
// EXTERNAL MODULE: ./components/icons/DropdownArrowDown.tsx
var DropdownArrowDown = __webpack_require__(85819);
;// CONCATENATED MODULE: ./components/accessibility/ScreenReaderOnlyLabel.tsx



function ScreenReaderOnlyLabel(param) {
    var id = param.id, text = param.text, color = param.color;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
        id: id,
        css: {
            position: "absolute",
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0,0,0,0)",
            border: 0,
            color: color || palette/* white */.ix
        },
        children: text
    });
};

;// CONCATENATED MODULE: ./src/components/intl/LanguageSelectDropDown.tsx










function LanguageSelectDropDown(_param) {
    var locales = _param.locales, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "locales"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ScreenReaderOnlyLabel, {
                id: "languageSelect-label",
                text: "Select language"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(downshift_esm/* default */.ZP, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                id: "languageSelect",
                itemToString: function(locale) {
                    return (locale === null || locale === void 0 ? void 0 : locale.name) || "";
                }
            }, props), {
                children: function(param) {
                    var getItemProps = param.getItemProps, highlightedIndex = param.highlightedIndex, isOpen = param.isOpen, openMenu = param.openMenu, closeMenu = param.closeMenu, selectedItem = param.selectedItem;
                    var globalIndex = -1;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    display: "flex",
                                    flexDirection: "column",
                                    border: "1px solid",
                                    borderColor: isOpen ? web/* palette.blue.500 */.DG.blue[500] : web/* palette.gray.600 */.DG.gray[600],
                                    borderRadius: 4
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                    as: "button",
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    backgroundColor: web/* palette.white */.DG.white,
                                    borderRadius: 3,
                                    minWidth: 200,
                                    padding: 1,
                                    onClick: function() {
                                        if (isOpen) {
                                            closeMenu();
                                        } else {
                                            openMenu();
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            css: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: selectedItem && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlagImage, {
                                                        countryCode: selectedItem.countryCode
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                        css: {
                                                            fontSize: "1rem"
                                                        },
                                                        children: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropdownArrow, {
                                            isOpen: isOpen
                                        })
                                    ]
                                })
                            }),
                            isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    position: "relative"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                    position: "absolute",
                                    width: "100%",
                                    bottom: 45,
                                    left: 0,
                                    as: "div",
                                    boxShadow: "lg",
                                    border: "1px solid",
                                    borderColor: "gray.200",
                                    bg: "white",
                                    listStyleType: "none",
                                    maxHeight: 200,
                                    overflowY: "auto",
                                    borderRadius: 3,
                                    paddingTop: 3,
                                    css: {
                                        "&::-webkit-scrollbar": {
                                            width: 10
                                        },
                                        "&::-webkit-scrollbar-track": {
                                            background: web/* palette.gray.100 */.DG.gray[100]
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: web/* palette.gray.300 */.DG.gray[300],
                                            borderRadius: 1
                                        },
                                        "&::-webkit-scrollbar-thumb:hover": {
                                            background: web/* palette.gray.400 */.DG.gray[400]
                                        }
                                    },
                                    children: sortLocales(locales).map(function(locale) {
                                        globalIndex += 1;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LocaleSelectOption, (0,src_object_spread/* default */.Z)({
                                            locale: locale,
                                            active: highlightedIndex === globalIndex
                                        }, getItemProps({
                                            index: globalIndex,
                                            item: locale
                                        })), locale.id);
                                    })
                                })
                            })
                        ]
                    });
                }
            }))
        ]
    });
};
function LocaleSelectOption(_param) {
    var locale = _param.locale, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "locale"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        as: "li",
        _hover: {
            color: "blue.600"
        },
        cursor: "pointer",
        height: 30,
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        marginBottom: 3
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FlagImage, {
                countryCode: locale.countryCode
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                css: {
                    fontSize: "1rem"
                },
                children: locale.name
            })
        ]
    }));
}
function DropdownArrow(param) {
    var isOpen = param.isOpen;
    if (isOpen) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropdownArrowUp/* default */.Z, {
            width: "14px",
            height: "14px",
            marginRight: 1
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropdownArrowDown/* default */.Z, {
        width: "14px",
        height: "14px",
        marginRight: 1,
        fill: web/* palette.gray.600 */.DG.gray[600]
    });
}
function FlagImage(param) {
    var countryCode = param.countryCode;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            width: "30px",
            height: "30px",
            position: "relative",
            overflow: "hidden",
            borderRadius: "50%",
            padding: 0,
            border: "1px solid",
            borderColor: "#eee",
            marginLeft: "0.75rem",
            marginRight: "0.75rem"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "https://static.govlaunch.com/flags/squared/".concat(countryCode, ".svg"),
            alt: "".concat(countryCode, " flag"),
            height: "100%",
            css: {
                display: "block",
                position: "absolute",
                height: "100%",
                width: "auto",
                marginLeft: "-5px",
                maxWidth: "200px !important"
            }
        })
    });
}
function sortLocales(locales) {
    var sorted = locales.sort(function(a, b) {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    });
    sorted.forEach(function(locale, index) {
        if (locale.id === "en-US") {
            sorted.splice(index, 1);
            sorted.unshift(locale);
        }
    });
    return sorted;
}

;// CONCATENATED MODULE: ./src/components/intl/LanguageSelect.tsx





var LanguageSelect = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,withIntl/* useIntlLocale */.U)(), locale = ref.locale, locales = ref.locales, changeLocale = ref.changeLocale;
    var currentLocale = locales.find(function(l) {
        return l.id === router.locale;
    }) || locales.find(function(l) {
        return l.id === locale;
    }) || {
        id: "en-US",
        apiLanguage: "en-US",
        name: "English",
        countryCode: "US",
        disabled: false
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: (0,components_mediaQueries/* default */.Z)({
            width: [
                "100%",
                "100%",
                "250px",
                "250px"
            ]
        }),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LanguageSelectDropDown, {
            locales: locales,
            initialSelectedItem: currentLocale,
            onChange: function(selectedItem) {
                if (selectedItem) {
                    changeLocale(selectedItem.id);
                }
            }
        })
    });
};
/* harmony default export */ var intl_LanguageSelect = (LanguageSelect);

;// CONCATENATED MODULE: ./src/shared/components/Footer.tsx












function Footer() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isTermsOpen = ref[0], toggleTerms = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isPrivacyPolicyOpen = ref1[0], togglePrivacyPolicy = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isCookiePolicyOpen = ref2[0], toggleCookiePolicy = ref2[1];
    var policiesUrls = (0,useIntlPolicies/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                bg: "gray.700",
                py: [
                    8,
                    8,
                    "60px"
                ],
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PageGridContainer */.pf, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                        justify: "space-between",
                        align: [
                            "flex-start",
                            "flex-start",
                            "center"
                        ],
                        direction: [
                            "column",
                            "column",
                            "row"
                        ],
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                order: [
                                    2,
                                    2,
                                    0
                                ],
                                width: [
                                    "100%",
                                    "100%",
                                    "auto"
                                ],
                                mt: [
                                    5,
                                    5,
                                    0
                                ],
                                px: [
                                    12,
                                    12,
                                    0
                                ],
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                        as: "ul",
                                        color: "white",
                                        display: "flex",
                                        flexDirection: [
                                            "column",
                                            "column",
                                            "row"
                                        ],
                                        listStyleType: "none",
                                        fontWeight: "semibold",
                                        fontSize: "md",
                                        css: (0,components_mediaQueries/* default */.Z)({
                                            "& li:not(:first-of-type)": {
                                                "&:before": {
                                                    content: [
                                                        null,
                                                        null,
                                                        "'•'"
                                                    ],
                                                    marginRight: [
                                                        null,
                                                        null,
                                                        8
                                                    ]
                                                },
                                                marginLeft: [
                                                    0,
                                                    0,
                                                    8
                                                ]
                                            },
                                            "& li": {
                                                "&:before": {
                                                    content: [
                                                        "'•'",
                                                        '""',
                                                        '""'
                                                    ],
                                                    marginRight: [
                                                        "8px",
                                                        "8px",
                                                        0
                                                    ]
                                                }
                                            }
                                        }),
                                        whiteSpace: "nowrap",
                                        mr: 2,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                as: "li",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                    href: "/about",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                                        color: "white",
                                                        rel: "noreferrer noopener",
                                                        title: "Podcast",
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                            defaultMessage: "About",
                                                            id: "g5pX+a"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                as: "li",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                                    color: "white",
                                                    external: "govlaunch",
                                                    href: "https://advertise.govlaunch.com/",
                                                    title: "Advertise",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Advertise",
                                                        id: "2OzlCZ"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                as: "li",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                                    color: "white",
                                                    external: "govlaunch",
                                                    href: "https://help.govlaunch.com/en/",
                                                    title: "Help",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Help",
                                                        id: "SENRqu"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                as: "li",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                                    color: "white",
                                                    external: "govlaunch",
                                                    href: "https://blog.govlaunch.com",
                                                    title: "Blog",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Blog",
                                                        id: "tv5FG3"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                as: "li",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                                    color: "white",
                                                    onClick: toggleTerms,
                                                    href: "#",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Terms of Service",
                                                        id: "32rBNK"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                as: "li",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                                    color: "white",
                                                    onClick: togglePrivacyPolicy,
                                                    href: "#",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Privacy",
                                                        id: "cXBJ7U"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                as: "li",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                                    color: "white",
                                                    onClick: toggleCookiePolicy,
                                                    href: "#",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Cookie Policy",
                                                        id: "cA0kQY"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                as: "li",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                                    color: "white",
                                                    href: "mailto:contact@govlaunch.com",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Contact",
                                                        id: "zFegDD"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Text */.xv, {
                                        fontSize: "md",
                                        fontWeight: "semibold",
                                        color: "white",
                                        mt: [
                                            "50px",
                                            "50px",
                                            4
                                        ],
                                        textAlign: [
                                            "center",
                                            "center",
                                            "left"
                                        ],
                                        children: [
                                            "\xa9 ",
                                            new Date().getFullYear(),
                                            " Govlaunch Inc."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                        mt: 4,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(intl_LanguageSelect, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                                align: "center",
                                mb: "auto",
                                width: [
                                    "100%",
                                    "100%",
                                    "100%",
                                    "auto"
                                ],
                                direction: [
                                    "column",
                                    "column",
                                    "column",
                                    "row"
                                ],
                                pb: [
                                    "65px",
                                    "65px",
                                    0,
                                    0
                                ],
                                borderBottom: [
                                    "1px",
                                    "1px",
                                    "none",
                                    "none"
                                ],
                                borderBottomColor: "gray.100",
                                children: [
                                     false && /*#__PURE__*/ 0,
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Stack */.Kq, {
                                        direction: "row",
                                        spacing: 2,
                                        ml: [
                                            0,
                                            0,
                                            0,
                                            6
                                        ],
                                        mb: [
                                            6,
                                            6,
                                            4,
                                            0
                                        ],
                                        order: [
                                            0,
                                            0,
                                            0,
                                            1
                                        ],
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                                external: "govlaunch",
                                                href: "https://www.facebook.com/teamgovlaunch",
                                                "aria-label": "facebook",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FacebookIcon/* default */.Z, {
                                                    size: 32,
                                                    round: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                                external: "govlaunch",
                                                href: "https://twitter.com/govlaunch",
                                                "aria-label": "twitter",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TwitterIcon/* default */.Z, {
                                                    size: 32,
                                                    round: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                                external: "govlaunch",
                                                href: "https://www.linkedin.com/company/govlaunch/",
                                                "aria-label": "linkedin",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkedinIcon/* default */.Z, {
                                                    size: 32,
                                                    round: true
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TermsIframeModal, {
                title: "Terms and Conditions",
                policyUrl: policiesUrls.termsAndConditions,
                isOpen: isTermsOpen,
                onClose: toggleTerms
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TermsIframeModal, {
                title: "Privacy Policy",
                policyUrl: policiesUrls.privacyPolicy,
                isOpen: isPrivacyPolicyOpen,
                onClose: togglePrivacyPolicy
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TermsIframeModal, {
                title: "Cookie Policy",
                policyUrl: policiesUrls.cookiePolicy,
                isOpen: isCookiePolicyOpen,
                onClose: toggleCookiePolicy
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/navbar/NavbarLayout.tsx





















function NavbarLayout(_param) {
    var children = _param.children, _withActionCenterBanner = _param.withActionCenterBanner, withActionCenterBanner = _withActionCenterBanner === void 0 ? true : _withActionCenterBanner, _withOnboardingBanner = _param.withOnboardingBanner, withOnboardingBanner = _withOnboardingBanner === void 0 ? true : _withOnboardingBanner, _withoutOverdueStickyNoticeBanner = _param.withoutOverdueStickyNoticeBanner, withoutOverdueStickyNoticeBanner = _withoutOverdueStickyNoticeBanner === void 0 ? false : _withoutOverdueStickyNoticeBanner, _navbarProps = _param.navbarProps, navbarProps = _navbarProps === void 0 ? {} : _navbarProps, _isOnboarding = _param.isOnboarding, isOnboarding = _isOnboarding === void 0 ? false : _isOnboarding, _isLoggingIn = _param.isLoggingIn, isLoggingIn = _isLoggingIn === void 0 ? false : _isLoggingIn, _showBanners = _param.showBanners, showBanners = _showBanners === void 0 ? true : _showBanners, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "children",
        "withActionCenterBanner",
        "withOnboardingBanner",
        "withoutOverdueStickyNoticeBanner",
        "navbarProps",
        "isOnboarding",
        "isLoggingIn",
        "showBanners"
    ]);
    var isMobile = (0,useIsMobile/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var viewer = (0,Auth/* useSelfie */.yD)();
    var showActionBanner = showBanners && withActionCenterBanner && showActionCenterBanner(viewer);
    // government profile banner should only appear if user is seeing the government profile or has already completed his profile
    var isGovernmentRoute = (router === null || router === void 0 ? void 0 : router.pathname) === "/government";
    var showGovernmentBanner = showBanners && viewer && viewer.__typename === "GovernmentUser" && viewer.showCompleteGovernmentProfileBanner && (isGovernmentRoute || !viewer.showOnboardingBanner);
    var showOverdueStickyBanner = showBanners && viewer && viewer.__typename === "VendorUser" && viewer.company && viewer.company.subscription && viewer.company.subscription.__typename === "OverdueSubscription" && !withoutOverdueStickyNoticeBanner;
    var showScheduledToCancelStickyNoticeBanner = showBanners && viewer !== null && viewer.__typename === "VendorUser" && viewer.company !== null && viewer.company.subscription !== null && viewer.company.subscription.__typename === "ScheduledToCancelSubscription";
    var showCompleteProfileBanner = showBanners && withOnboardingBanner && viewer !== null && viewer.showOnboardingBanner;
    var showCompleteGovernmentProfileBanner = showBanners && withOnboardingBanner && showGovernmentBanner;
    var hasBannerToShow = showActionBanner || showGovernmentBanner || showOverdueStickyBanner || showScheduledToCancelStickyNoticeBanner || showCompleteProfileBanner || showCompleteGovernmentProfileBanner;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HreflangTags, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImpersonateBar, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                minHeight: [
                    "calc(100vh + 375px)",
                    "100vh",
                    "100vh"
                ],
                display: "flex",
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        pb: 16
                    }, props), {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                mb: isOnboarding || isLoggingIn ? [
                                    0,
                                    0,
                                    0,
                                    0
                                ] : [
                                    4,
                                    4,
                                    4,
                                    8
                                ]
                            }, navbarProps), {
                                children: isMobile ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileNavbar, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar, {})
                            })),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("main", {
                                children: [
                                    viewer && !isOnboarding && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* PageGridContainer */.pf, {
                                        mt: [
                                            4,
                                            4,
                                            4,
                                            8
                                        ],
                                        mb: [
                                            4,
                                            4,
                                            4,
                                            8
                                        ],
                                        spacingY: 3,
                                        css: {
                                            "&:empty": {
                                                display: "none"
                                            }
                                        },
                                        children: [
                                            showActionBanner && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(actions_ActionCenterBanner, {}),
                                            showCompleteProfileBanner && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(user_CompleteProfileBanner, {}),
                                            withOnboardingBanner && showGovernmentBanner && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(user_CompleteGovernmentProfileBanner, {}),
                                            viewer.__typename === "PendingUser" && viewer.viewerCouldNotJoinReason && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Alert/* default */.Z, {
                                                children: viewer.viewerCouldNotJoinReason
                                            }),
                                            showOverdueStickyBanner && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverdueStickyNoticeBanner, {}),
                                            viewer !== null && viewer.__typename === "VendorUser" && viewer.company !== null && viewer.company.subscription !== null && viewer.company.subscription.__typename === "ScheduledToCancelSubscription" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ScheduledToCancelStickyNoticeBanner, {
                                                vendorSlug: viewer.company.slug,
                                                willCancelAt: viewer.company.subscription.willCancelAt
                                            })
                                        ]
                                    }),
                                    hasBannerToShow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                        mt: "auto",
                                        zIndex: 11,
                                        bg: "gray.700",
                                        pb: [
                                            10,
                                            10,
                                            0
                                        ]
                                    }),
                                    children
                                ]
                            })
                        ]
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BottomNavbar, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("footer", {
                        css: {
                            marginTop: "auto"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            mt: "auto",
                            zIndex: 11,
                            bg: "gray.700",
                            pb: [
                                10,
                                10,
                                0
                            ],
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer, {})
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 89989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IntlRelativeTime; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85040);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98777);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);




function IntlRelativeTime(param) {
    var value = param.value;
    var ref = getTimeAndUnit(value), time = ref.time, unit = ref.unit;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        value: time,
        unit: unit
    });
};
function getTimeAndUnit(value) {
    var deltaYears = moment__WEBPACK_IMPORTED_MODULE_1___default()().diff(value, "year");
    var deltaMonths = moment__WEBPACK_IMPORTED_MODULE_1___default()().diff(value, "month");
    var deltaDays = moment__WEBPACK_IMPORTED_MODULE_1___default()().diff(value, "day");
    var deltaHours = moment__WEBPACK_IMPORTED_MODULE_1___default()().diff(value, "hour");
    var deltaMinutes = moment__WEBPACK_IMPORTED_MODULE_1___default()().diff(value, "minute");
    var deltaSeconds = moment__WEBPACK_IMPORTED_MODULE_1___default()().diff(value, "second");
    if (deltaYears > 0) {
        return {
            time: -deltaYears,
            unit: "year"
        };
    }
    if (deltaMonths > 0) {
        return {
            time: -deltaMonths,
            unit: "month"
        };
    }
    if (deltaDays > 0) {
        return {
            time: -deltaDays,
            unit: "day"
        };
    }
    if (deltaHours > 0) {
        return {
            time: -deltaHours,
            unit: "hour"
        };
    }
    if (deltaMinutes > 0) {
        return {
            time: -deltaMinutes,
            unit: "minute"
        };
    }
    return {
        time: -deltaSeconds,
        unit: "second"
    };
}


/***/ }),

/***/ 91968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIntlPolicies; }
/* harmony export */ });
/* harmony import */ var _lib_withIntl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21505);

function useIntlPolicies() {
    var locale = (0,_lib_withIntl__WEBPACK_IMPORTED_MODULE_0__/* .useIntlLocale */ .U)().locale;
    if (locale.startsWith("pt")) {
        return {
            termsAndConditions: "https://www.iubenda.com/termos-e-condicoes/86933505?an=no&height=800",
            privacyPolicy: "https://www.iubenda.com/privacy-policy/86933505?an=no&height=800",
            cookiePolicy: "https://www.iubenda.com/privacy-policy/86933505/cookie-policy?an=no&height=800"
        };
    }
    if (locale.startsWith("de")) {
        return {
            termsAndConditions: "https://www.iubenda.com/terms-and-conditions/8224354?an=no&height=800",
            privacyPolicy: "https://www.iubenda.com/privacy-policy/8224354?an=no&height=800",
            cookiePolicy: "https://www.iubenda.com/privacy-policy/8224354/cookie-policy?an=no&height=800"
        };
    }
    return {
        termsAndConditions: "https://www.iubenda.com/terms-and-conditions/8224354?an=no&height=800",
        privacyPolicy: "https://www.iubenda.com/privacy-policy/8224354?an=no&height=800",
        cookiePolicy: "https://www.iubenda.com/privacy-policy/8224354/cookie-policy?an=no&height=800"
    };
};


/***/ }),

/***/ 88196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ nextLinkHref; },
/* harmony export */   "o": function() { return /* binding */ appendNextLinkHrefParams; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93712);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97150);


function nextLinkHref(filesystemRoute, params) {
    var searchParams = querystring__WEBPACK_IMPORTED_MODULE_0__.stringify(params, "&");
    return searchParams ? "".concat(filesystemRoute, "?").concat(searchParams) : filesystemRoute;
};
function appendNextLinkHrefParams(router, params) {
    return nextLinkHref(router.route, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, router.query, params));
}


/***/ }),

/***/ 43845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ IProjectAudience; },
/* harmony export */   "BB": function() { return /* binding */ IMediaType; },
/* harmony export */   "Cw": function() { return /* binding */ IBookmarkType; },
/* harmony export */   "G6": function() { return /* binding */ ICollectionSponsoringSponsorshipLevel; },
/* harmony export */   "H0": function() { return /* binding */ IAboutContentType; },
/* harmony export */   "KH": function() { return /* binding */ ISolutionStatus; },
/* harmony export */   "Ns": function() { return /* binding */ ICollectionSponsoringType; },
/* harmony export */   "O$": function() { return /* binding */ INewsletterFrequency; },
/* harmony export */   "QY": function() { return /* binding */ IConnectTargetType; },
/* harmony export */   "Tx": function() { return /* binding */ IGroupKind; },
/* harmony export */   "VZ": function() { return /* binding */ ICommentTargetType; },
/* harmony export */   "aj": function() { return /* binding */ IUpvoteTargetType; },
/* harmony export */   "cP": function() { return /* binding */ IBlockLayoutType; },
/* harmony export */   "fq": function() { return /* binding */ IPlanTier; },
/* harmony export */   "gS": function() { return /* binding */ ICollectionMethod; },
/* harmony export */   "hq": function() { return /* binding */ ICollectionFeaturedStatus; },
/* harmony export */   "kU": function() { return /* binding */ IWorkPlaceType; },
/* harmony export */   "mG": function() { return /* binding */ ITagType; },
/* harmony export */   "nH": function() { return /* binding */ ICollectionSponsoring; },
/* harmony export */   "oO": function() { return /* binding */ IPlanRecurrency; },
/* harmony export */   "sC": function() { return /* binding */ ICollectionItemType; },
/* harmony export */   "tl": function() { return /* binding */ IGroupVisibility; },
/* harmony export */   "vK": function() { return /* binding */ ICollectionPackaging; },
/* harmony export */   "w1": function() { return /* binding */ IProcessStatusType; },
/* harmony export */   "zB": function() { return /* binding */ IInvoiceStatus; }
/* harmony export */ });
/* unused harmony exports IAllSponsorshipsFilter, IAssistiveTechnology, IBulkTaggingEntityType, IBulkTaggingModifyStrategy, IChargeStatus, ICollectionBookmarkStatus, ICollectionNewContentLastVisitAnchor, ICollectionPublishedStatus, ICollectionSponsoringPaymentSchedule, ICollectionStatus, ICommentRepliesFilter, IEntityType, IFeaturedTargetType, IFollowType, IGovernmentSearchScope, IGovernmentVerificationRequestSearchTarget, IGovernmentVerificationRequestSortBy, IGovernmentVerificationRequestSortByDirection, IGovernmentVerificationRequestStatus, IGovlaunchEnvironment, IGroupRequestStatus, IGroupsFilter, IImageSourceType, IImagesQueryTab, INewsletterCampaignFrequency, IOutsideProductStatus, IPostAudience, IProductFilter, IProductSearchScope, IProductStackRequestStatus, IProductStatus, IProductStatusFilter, IProfileCoverTarget, IProjectType, ISortType, IStoryAudience, IStoryFilter, IStoryStatus, ISubscriptionStatus, IUserRole, IUserSearchScope, IUserType, IVendorSearchScope, IVerificationInput */
var IAboutContentType;
(function(IAboutContentType) {
    IAboutContentType["Image"] = "IMAGE";
    IAboutContentType["Podcast"] = "PODCAST";
    IAboutContentType["Video"] = "VIDEO";
})(IAboutContentType || (IAboutContentType = {}));
var IAllSponsorshipsFilter;
(function(IAllSponsorshipsFilter) {
    IAllSponsorshipsFilter["All"] = "ALL";
    IAllSponsorshipsFilter["Archived"] = "ARCHIVED";
})(IAllSponsorshipsFilter || (IAllSponsorshipsFilter = {}));
var IAssistiveTechnology;
(function(IAssistiveTechnology) {
    IAssistiveTechnology["AlternativeInputDevice"] = "ALTERNATIVE_INPUT_DEVICE";
    IAssistiveTechnology["ScreenMagnification"] = "SCREEN_MAGNIFICATION";
    IAssistiveTechnology["ScreenReader"] = "SCREEN_READER";
    IAssistiveTechnology["SpeechInput"] = "SPEECH_INPUT";
    IAssistiveTechnology["TextReader"] = "TEXT_READER";
})(IAssistiveTechnology || (IAssistiveTechnology = {}));
var IBlockLayoutType;
(function(IBlockLayoutType) {
    IBlockLayoutType["Advertisement"] = "ADVERTISEMENT";
    IBlockLayoutType["EmptySpaceBlock"] = "EMPTY_SPACE_BLOCK";
    IBlockLayoutType["Events"] = "EVENTS";
    IBlockLayoutType["ExternalLinks"] = "EXTERNAL_LINKS";
    IBlockLayoutType["FeaturedStories"] = "FEATURED_STORIES";
    IBlockLayoutType["Image"] = "IMAGE";
    IBlockLayoutType["NewProjects"] = "NEW_PROJECTS";
    IBlockLayoutType["PlusBlock"] = "PLUS_BLOCK";
    IBlockLayoutType["Podcast"] = "PODCAST";
    IBlockLayoutType["StatCounters"] = "STAT_COUNTERS";
    IBlockLayoutType["TrendingCollections"] = "TRENDING_COLLECTIONS";
    IBlockLayoutType["TrendingGovernments"] = "TRENDING_GOVERNMENTS";
})(IBlockLayoutType || (IBlockLayoutType = {}));
var IBookmarkType;
(function(IBookmarkType) {
    IBookmarkType["Collection"] = "COLLECTION";
    IBookmarkType["Post"] = "POST";
    IBookmarkType["Product"] = "PRODUCT";
    IBookmarkType["Project"] = "PROJECT";
    IBookmarkType["Story"] = "STORY";
})(IBookmarkType || (IBookmarkType = {}));
var IBulkTaggingEntityType;
(function(IBulkTaggingEntityType) {
    IBulkTaggingEntityType["Project"] = "PROJECT";
})(IBulkTaggingEntityType || (IBulkTaggingEntityType = {}));
var IBulkTaggingModifyStrategy;
(function(IBulkTaggingModifyStrategy) {
    IBulkTaggingModifyStrategy["Add"] = "ADD";
    IBulkTaggingModifyStrategy["Overwrite"] = "OVERWRITE";
    IBulkTaggingModifyStrategy["Remove"] = "REMOVE";
})(IBulkTaggingModifyStrategy || (IBulkTaggingModifyStrategy = {}));
var IChargeStatus;
(function(IChargeStatus) {
    IChargeStatus["Failed"] = "FAILED";
    IChargeStatus["Pending"] = "PENDING";
    IChargeStatus["Succeeded"] = "SUCCEEDED";
})(IChargeStatus || (IChargeStatus = {}));
var ICollectionBookmarkStatus;
(function(ICollectionBookmarkStatus) {
    ICollectionBookmarkStatus["Saved"] = "SAVED";
    ICollectionBookmarkStatus["Unsaved"] = "UNSAVED";
})(ICollectionBookmarkStatus || (ICollectionBookmarkStatus = {}));
var ICollectionFeaturedStatus;
(function(ICollectionFeaturedStatus) {
    ICollectionFeaturedStatus["All"] = "ALL";
    ICollectionFeaturedStatus["FeaturedOnly"] = "FEATURED_ONLY";
    ICollectionFeaturedStatus["NotFeatured"] = "NOT_FEATURED";
})(ICollectionFeaturedStatus || (ICollectionFeaturedStatus = {}));
var ICollectionItemType;
(function(ICollectionItemType) {
    ICollectionItemType["Government"] = "GOVERNMENT";
    ICollectionItemType["Group"] = "GROUP";
    ICollectionItemType["Product"] = "PRODUCT";
    ICollectionItemType["Project"] = "PROJECT";
    ICollectionItemType["Story"] = "STORY";
})(ICollectionItemType || (ICollectionItemType = {}));
var ICollectionMethod;
(function(ICollectionMethod) {
    ICollectionMethod["ChargeAutomatically"] = "CHARGE_AUTOMATICALLY";
    ICollectionMethod["SendInvoice"] = "SEND_INVOICE";
})(ICollectionMethod || (ICollectionMethod = {}));
var ICollectionNewContentLastVisitAnchor;
(function(ICollectionNewContentLastVisitAnchor) {
    ICollectionNewContentLastVisitAnchor["LastTrackedViewerVisit"] = "LAST_TRACKED_VIEWER_VISIT";
    ICollectionNewContentLastVisitAnchor["LastVisitArgument"] = "LAST_VISIT_ARGUMENT";
})(ICollectionNewContentLastVisitAnchor || (ICollectionNewContentLastVisitAnchor = {}));
var ICollectionPackaging;
(function(ICollectionPackaging) {
    ICollectionPackaging[/** When a collection have more than two tags. */ "Bundle"] = "BUNDLE";
    ICollectionPackaging[/** When a collection is made of a single tag. */ "Single"] = "SINGLE";
})(ICollectionPackaging || (ICollectionPackaging = {}));
var ICollectionPublishedStatus;
(function(ICollectionPublishedStatus) {
    ICollectionPublishedStatus["Published"] = "PUBLISHED";
    ICollectionPublishedStatus["Unpublished"] = "UNPUBLISHED";
})(ICollectionPublishedStatus || (ICollectionPublishedStatus = {}));
var ICollectionSponsoring;
(function(ICollectionSponsoring) {
    ICollectionSponsoring["None"] = "NONE";
    ICollectionSponsoring["VendorCurated"] = "VENDOR_CURATED";
    ICollectionSponsoring["VendorSponsored"] = "VENDOR_SPONSORED";
})(ICollectionSponsoring || (ICollectionSponsoring = {}));
var ICollectionSponsoringPaymentSchedule;
(function(ICollectionSponsoringPaymentSchedule) {
    ICollectionSponsoringPaymentSchedule["LumpSum"] = "LUMP_SUM";
    ICollectionSponsoringPaymentSchedule["Monthly"] = "MONTHLY";
    ICollectionSponsoringPaymentSchedule["Quarterly"] = "QUARTERLY";
    ICollectionSponsoringPaymentSchedule["Yearly"] = "YEARLY";
})(ICollectionSponsoringPaymentSchedule || (ICollectionSponsoringPaymentSchedule = {}));
var ICollectionSponsoringSponsorshipLevel;
(function(ICollectionSponsoringSponsorshipLevel) {
    ICollectionSponsoringSponsorshipLevel["Product"] = "PRODUCT";
    ICollectionSponsoringSponsorshipLevel["Vendor"] = "VENDOR";
})(ICollectionSponsoringSponsorshipLevel || (ICollectionSponsoringSponsorshipLevel = {}));
var ICollectionSponsoringType;
(function(ICollectionSponsoringType) {
    ICollectionSponsoringType["Curated"] = "CURATED";
    ICollectionSponsoringType["Sponsored"] = "SPONSORED";
})(ICollectionSponsoringType || (ICollectionSponsoringType = {}));
var ICollectionStatus;
(function(ICollectionStatus) {
    ICollectionStatus["Active"] = "ACTIVE";
    ICollectionStatus["Archived"] = "ARCHIVED";
    ICollectionStatus["Inactive"] = "INACTIVE";
})(ICollectionStatus || (ICollectionStatus = {}));
var ICommentRepliesFilter;
(function(ICommentRepliesFilter) {
    ICommentRepliesFilter["All"] = "ALL";
    ICommentRepliesFilter["Viewer"] = "VIEWER";
})(ICommentRepliesFilter || (ICommentRepliesFilter = {}));
var ICommentTargetType;
(function(ICommentTargetType) {
    ICommentTargetType["Post"] = "POST";
    ICommentTargetType["Project"] = "PROJECT";
    ICommentTargetType["Report"] = "REPORT";
    ICommentTargetType["Story"] = "STORY";
})(ICommentTargetType || (ICommentTargetType = {}));
var IConnectTargetType;
(function(IConnectTargetType) {
    IConnectTargetType["Government"] = "GOVERNMENT";
    IConnectTargetType["Group"] = "GROUP";
    IConnectTargetType["User"] = "USER";
    IConnectTargetType["Vendor"] = "VENDOR";
})(IConnectTargetType || (IConnectTargetType = {}));
var IEntityType;
(function(IEntityType) {
    IEntityType["Company"] = "COMPANY";
    IEntityType["Government"] = "GOVERNMENT";
})(IEntityType || (IEntityType = {}));
var IFeaturedTargetType;
(function(IFeaturedTargetType) {
    IFeaturedTargetType["Product"] = "PRODUCT";
    IFeaturedTargetType["Report"] = "REPORT";
    IFeaturedTargetType["Story"] = "STORY";
})(IFeaturedTargetType || (IFeaturedTargetType = {}));
var IFollowType;
(function(IFollowType) {
    IFollowType["Government"] = "GOVERNMENT";
    IFollowType["User"] = "USER";
})(IFollowType || (IFollowType = {}));
var IGovernmentSearchScope;
(function(IGovernmentSearchScope) {
    IGovernmentSearchScope["Innovator"] = "INNOVATOR";
})(IGovernmentSearchScope || (IGovernmentSearchScope = {}));
var IGovernmentVerificationRequestSearchTarget;
(function(IGovernmentVerificationRequestSearchTarget) {
    IGovernmentVerificationRequestSearchTarget["Government"] = "GOVERNMENT";
    IGovernmentVerificationRequestSearchTarget["Group"] = "GROUP";
    IGovernmentVerificationRequestSearchTarget["Project"] = "PROJECT";
})(IGovernmentVerificationRequestSearchTarget || (IGovernmentVerificationRequestSearchTarget = {}));
var IGovernmentVerificationRequestSortBy;
(function(IGovernmentVerificationRequestSortBy) {
    IGovernmentVerificationRequestSortBy["Created"] = "CREATED";
    IGovernmentVerificationRequestSortBy["Government"] = "GOVERNMENT";
    IGovernmentVerificationRequestSortBy["Status"] = "STATUS";
})(IGovernmentVerificationRequestSortBy || (IGovernmentVerificationRequestSortBy = {}));
var IGovernmentVerificationRequestSortByDirection;
(function(IGovernmentVerificationRequestSortByDirection) {
    IGovernmentVerificationRequestSortByDirection["Ascending"] = "ASCENDING";
    IGovernmentVerificationRequestSortByDirection["Descending"] = "DESCENDING";
})(IGovernmentVerificationRequestSortByDirection || (IGovernmentVerificationRequestSortByDirection = {}));
var IGovernmentVerificationRequestStatus;
(function(IGovernmentVerificationRequestStatus) {
    IGovernmentVerificationRequestStatus["Cancelled"] = "CANCELLED";
    IGovernmentVerificationRequestStatus["Declined"] = "DECLINED";
    IGovernmentVerificationRequestStatus["Pending"] = "PENDING";
    IGovernmentVerificationRequestStatus["Verified"] = "VERIFIED";
})(IGovernmentVerificationRequestStatus || (IGovernmentVerificationRequestStatus = {}));
var IGovlaunchEnvironment;
(function(IGovlaunchEnvironment) {
    IGovlaunchEnvironment["Production"] = "PRODUCTION";
    IGovlaunchEnvironment["Qa"] = "QA";
})(IGovlaunchEnvironment || (IGovlaunchEnvironment = {}));
var IGroupKind;
(function(IGroupKind) {
    IGroupKind[/** Everything that doesn't fall in the above buckets will be "community" */ "Community"] = "COMMUNITY";
    IGroupKind[/** A group will be considered a Discussion if there's a Collection for it */ "Discussion"] = "DISCUSSION";
    IGroupKind[/** A group will be considered a Vendor if the owner is a Vendor */ "Vendor"] = "VENDOR";
})(IGroupKind || (IGroupKind = {}));
var IGroupRequestStatus;
(function(IGroupRequestStatus) {
    IGroupRequestStatus["Accepted"] = "ACCEPTED";
    IGroupRequestStatus["Canceled"] = "CANCELED";
    IGroupRequestStatus["Declined"] = "DECLINED";
    IGroupRequestStatus["Pending"] = "PENDING";
})(IGroupRequestStatus || (IGroupRequestStatus = {}));
var IGroupVisibility;
(function(IGroupVisibility) {
    IGroupVisibility["Private"] = "PRIVATE";
    IGroupVisibility["Public"] = "PUBLIC";
})(IGroupVisibility || (IGroupVisibility = {}));
var IGroupsFilter;
(function(IGroupsFilter) {
    IGroupsFilter["All"] = "ALL";
    IGroupsFilter["Archived"] = "ARCHIVED";
})(IGroupsFilter || (IGroupsFilter = {}));
var IImageSourceType;
(function(IImageSourceType) {
    IImageSourceType["Product"] = "PRODUCT";
    IImageSourceType["Story"] = "STORY";
})(IImageSourceType || (IImageSourceType = {}));
var IImagesQueryTab;
(function(IImagesQueryTab) {
    IImagesQueryTab["All"] = "ALL";
    IImagesQueryTab["Archived"] = "ARCHIVED";
    IImagesQueryTab["NoAlt"] = "NO_ALT";
    IImagesQueryTab["Placeholder"] = "PLACEHOLDER";
    IImagesQueryTab["WithAlt"] = "WITH_ALT";
})(IImagesQueryTab || (IImagesQueryTab = {}));
var IInvoiceStatus;
(function(IInvoiceStatus) {
    IInvoiceStatus["Draft"] = "DRAFT";
    IInvoiceStatus["Open"] = "OPEN";
    IInvoiceStatus["Paid"] = "PAID";
    IInvoiceStatus["Uncollectible"] = "UNCOLLECTIBLE";
    IInvoiceStatus["Void"] = "VOID";
})(IInvoiceStatus || (IInvoiceStatus = {}));
var IMediaType;
(function(IMediaType) {
    IMediaType["Image"] = "IMAGE";
    IMediaType["Video"] = "VIDEO";
    IMediaType["Youtube"] = "YOUTUBE";
})(IMediaType || (IMediaType = {}));
var INewsletterCampaignFrequency;
(function(INewsletterCampaignFrequency) {
    INewsletterCampaignFrequency["Biweekly"] = "BIWEEKLY";
    INewsletterCampaignFrequency["Monthly"] = "MONTHLY";
    INewsletterCampaignFrequency["Weekly"] = "WEEKLY";
})(INewsletterCampaignFrequency || (INewsletterCampaignFrequency = {}));
var INewsletterFrequency;
(function(INewsletterFrequency) {
    INewsletterFrequency["Biweekly"] = "BIWEEKLY";
    INewsletterFrequency["Monthly"] = "MONTHLY";
    INewsletterFrequency["Weekly"] = "WEEKLY";
})(INewsletterFrequency || (INewsletterFrequency = {}));
var IOutsideProductStatus;
(function(IOutsideProductStatus) {
    IOutsideProductStatus["Added"] = "ADDED";
    IOutsideProductStatus["Denied"] = "DENIED";
    IOutsideProductStatus["Ignored"] = "IGNORED";
    IOutsideProductStatus["Pending"] = "PENDING";
})(IOutsideProductStatus || (IOutsideProductStatus = {}));
var IPlanRecurrency;
(function(IPlanRecurrency) {
    IPlanRecurrency["Monthly"] = "MONTHLY";
    IPlanRecurrency["Yearly"] = "YEARLY";
})(IPlanRecurrency || (IPlanRecurrency = {}));
var IPlanTier;
(function(IPlanTier) {
    IPlanTier["Basic"] = "BASIC";
    IPlanTier["Disruptor"] = "DISRUPTOR";
    IPlanTier["Makers"] = "MAKERS";
    IPlanTier["Makerspro"] = "MAKERSPRO";
})(IPlanTier || (IPlanTier = {}));
var IPostAudience;
(function(IPostAudience) {
    IPostAudience["Community"] = "COMMUNITY";
    IPostAudience["Public"] = "PUBLIC";
})(IPostAudience || (IPostAudience = {}));
var IProcessStatusType;
(function(IProcessStatusType) {
    IProcessStatusType["AdditionalInformationRequired"] = "ADDITIONAL_INFORMATION_REQUIRED";
    IProcessStatusType["PendingVerification"] = "PENDING_VERIFICATION";
    IProcessStatusType["Required"] = "REQUIRED";
    IProcessStatusType["Verified"] = "VERIFIED";
})(IProcessStatusType || (IProcessStatusType = {}));
var IProductFilter;
(function(IProductFilter) {
    IProductFilter["All"] = "ALL";
    IProductFilter["Archived"] = "ARCHIVED";
    IProductFilter["Disruptors"] = "DISRUPTORS";
    IProductFilter["Regular"] = "REGULAR";
    IProductFilter["Submitted"] = "SUBMITTED";
    IProductFilter["Untagged"] = "UNTAGGED";
})(IProductFilter || (IProductFilter = {}));
var IProductSearchScope;
(function(IProductSearchScope) {
    IProductSearchScope["Basic"] = "BASIC";
    IProductSearchScope["Disruptor"] = "DISRUPTOR";
    IProductSearchScope["Makers"] = "MAKERS";
    IProductSearchScope["VendorIsDisruptor"] = "VENDOR_IS_DISRUPTOR";
})(IProductSearchScope || (IProductSearchScope = {}));
var IProductStackRequestStatus;
(function(IProductStackRequestStatus) {
    IProductStackRequestStatus["Accepted"] = "ACCEPTED";
    IProductStackRequestStatus["Canceled"] = "CANCELED";
    IProductStackRequestStatus["Declined"] = "DECLINED";
    IProductStackRequestStatus["Pending"] = "PENDING";
})(IProductStackRequestStatus || (IProductStackRequestStatus = {}));
var IProductStatus;
(function(IProductStatus) {
    IProductStatus["Approved"] = "APPROVED";
    IProductStatus["Submitted"] = "SUBMITTED";
})(IProductStatus || (IProductStatus = {}));
var IProductStatusFilter;
(function(IProductStatusFilter) {
    IProductStatusFilter["All"] = "ALL";
    IProductStatusFilter["Approved"] = "APPROVED";
    IProductStatusFilter["Submitted"] = "SUBMITTED";
})(IProductStatusFilter || (IProductStatusFilter = {}));
var IProfileCoverTarget;
(function(IProfileCoverTarget) {
    IProfileCoverTarget["Company"] = "COMPANY";
    IProfileCoverTarget["Government"] = "GOVERNMENT";
    IProfileCoverTarget["User"] = "USER";
})(IProfileCoverTarget || (IProfileCoverTarget = {}));
var IProjectAudience;
(function(IProjectAudience) {
    IProjectAudience["Community"] = "COMMUNITY";
    IProjectAudience["Private"] = "PRIVATE";
    IProjectAudience["Public"] = "PUBLIC";
})(IProjectAudience || (IProjectAudience = {}));
var IProjectType;
(function(IProjectType) {
    IProjectType["GovernmentProject"] = "GOVERNMENT_PROJECT";
    IProjectType["GroupProject"] = "GROUP_PROJECT";
    IProjectType["VendorProject"] = "VENDOR_PROJECT";
})(IProjectType || (IProjectType = {}));
var ISolutionStatus;
(function(ISolutionStatus) {
    ISolutionStatus["Approved"] = "APPROVED";
    ISolutionStatus["Archived"] = "ARCHIVED";
    ISolutionStatus["Submitted"] = "SUBMITTED";
})(ISolutionStatus || (ISolutionStatus = {}));
var ISortType;
(function(ISortType) {
    ISortType["Newest"] = "NEWEST";
    ISortType["Oldest"] = "OLDEST";
    ISortType["Top"] = "TOP";
})(ISortType || (ISortType = {}));
var IStoryAudience;
(function(IStoryAudience) {
    IStoryAudience["All"] = "ALL";
    IStoryAudience["Community"] = "COMMUNITY";
    IStoryAudience["Public"] = "PUBLIC";
})(IStoryAudience || (IStoryAudience = {}));
var IStoryFilter;
(function(IStoryFilter) {
    IStoryFilter["All"] = "ALL";
    IStoryFilter["Featured"] = "FEATURED";
})(IStoryFilter || (IStoryFilter = {}));
var IStoryStatus;
(function(IStoryStatus) {
    IStoryStatus["Approved"] = "APPROVED";
    IStoryStatus["Proposed"] = "PROPOSED";
    IStoryStatus["Published"] = "PUBLISHED";
    IStoryStatus["Unpublished"] = "UNPUBLISHED";
})(IStoryStatus || (IStoryStatus = {}));
var ISubscriptionStatus;
(function(ISubscriptionStatus) {
    ISubscriptionStatus["Active"] = "ACTIVE";
    ISubscriptionStatus["Cancelled"] = "CANCELLED";
})(ISubscriptionStatus || (ISubscriptionStatus = {}));
var ITagType;
(function(ITagType) {
    ITagType["Award"] = "AWARD";
    ITagType["Custom"] = "CUSTOM";
    ITagType["Department"] = "DEPARTMENT";
    ITagType["Product"] = "PRODUCT";
    ITagType["Project"] = "PROJECT";
    ITagType["Story"] = "STORY";
})(ITagType || (ITagType = {}));
var IUpvoteTargetType;
(function(IUpvoteTargetType) {
    IUpvoteTargetType["Comment"] = "COMMENT";
    IUpvoteTargetType["Post"] = "POST";
    IUpvoteTargetType["Product"] = "PRODUCT";
    IUpvoteTargetType["Project"] = "PROJECT";
    IUpvoteTargetType["Report"] = "REPORT";
    IUpvoteTargetType["Story"] = "STORY";
})(IUpvoteTargetType || (IUpvoteTargetType = {}));
var IUserRole;
(function(IUserRole) {
    IUserRole["Owner"] = "OWNER";
    IUserRole["User"] = "USER";
})(IUserRole || (IUserRole = {}));
var IUserSearchScope;
(function(IUserSearchScope) {
    IUserSearchScope["Citizen"] = "CITIZEN";
    IUserSearchScope["Community"] = "COMMUNITY";
    IUserSearchScope["Disruptor"] = "DISRUPTOR";
    IUserSearchScope["Government"] = "GOVERNMENT";
    IUserSearchScope["Innovator"] = "INNOVATOR";
    IUserSearchScope["Pending"] = "PENDING";
    IUserSearchScope["Vendor"] = "VENDOR";
})(IUserSearchScope || (IUserSearchScope = {}));
var IUserType;
(function(IUserType) {
    IUserType["Disruptor"] = "DISRUPTOR";
    IUserType["Innovator"] = "INNOVATOR";
    IUserType["Regular"] = "REGULAR";
})(IUserType || (IUserType = {}));
var IVendorSearchScope;
(function(IVendorSearchScope) {
    IVendorSearchScope["Disruptor"] = "DISRUPTOR";
})(IVendorSearchScope || (IVendorSearchScope = {}));
var IVerificationInput;
(function(IVerificationInput) {
    IVerificationInput["None"] = "NONE";
    IVerificationInput["Unverified"] = "UNVERIFIED";
    IVerificationInput["Verified"] = "VERIFIED";
})(IVerificationInput || (IVerificationInput = {}));
var IWorkPlaceType;
(function(IWorkPlaceType) {
    IWorkPlaceType["Government"] = "GOVERNMENT";
    IWorkPlaceType["None"] = "NONE";
    IWorkPlaceType["NonprofitOrNgo"] = "NONPROFIT_OR_NGO";
    IWorkPlaceType["Other"] = "OTHER";
    IWorkPlaceType["StateOrFederalAgency"] = "STATE_OR_FEDERAL_AGENCY";
    IWorkPlaceType["Vendor"] = "VENDOR";
})(IWorkPlaceType || (IWorkPlaceType = {}));


/***/ }),

/***/ 71129:
/***/ (function() {

/* (ignored) */

/***/ })

}]);